export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Byte: { input: any; output: any }
  DateTime: { input: any; output: any }
  Decimal: { input: any; output: any }
  Guid: { input: any; output: any }
  JSONObject: { input: any; output: any }
  Long: { input: any; output: any }
  MillisecondsDate: { input: any; output: any }
  ObjectId: { input: any; output: any }
  Short: { input: any; output: any }
}

/** A raw ActiveUserBucket document with resolved user/project names. */
export interface IActiveUserBucketRecord {
  /** When this record was first created (UTC). */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The document ID. */
  id?: Maybe<Scalars['String']['output']>
  /** The project ID. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** The project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** The tenant (database) name. */
  tenant?: Maybe<Scalars['String']['output']>
  /** Time bucket start (truncated to configured bucket size, UTC). */
  timeBucket?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Time bucket end (start + bucket size, UTC). */
  timeBucketEnd?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The user's email address. */
  userEmail?: Maybe<Scalars['String']['output']>
  /** The user's first name. */
  userFirstName?: Maybe<Scalars['String']['output']>
  /** The user ID. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The user's last name. */
  userLastName?: Maybe<Scalars['String']['output']>
}

/** Details of an active user including their profile information. */
export interface IActiveUserDetails {
  /** The user's email address. */
  email?: Maybe<Scalars['String']['output']>
  /** The user's first name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** The user's last name. */
  lastName?: Maybe<Scalars['String']['output']>
  /** The user ID. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IActivitiesConfigurations {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Saved activity filter groups. */
  savedActivityGroups?: Maybe<Array<Maybe<IFilterGroup>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivitiesConfigurationsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivitiesConfigurations>
}

export interface IActivitiesConfigurationsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Saved delivery filter groups. */
  savedActivityGroups?: InputMaybe<Array<InputMaybe<IFilterGroupInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivitiesConfigurationsList {
  data: Array<IActivitiesConfigurations>
  page: IPageInfo
}

export interface IActivity {
  /** Activity linking settings. */
  activityLinkingSettings?: Maybe<IActivityLinkingSettings>
  /** Actual finish date. */
  actualFinishDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Actual start date. */
  actualStartDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Calendar id. */
  calendarId?: Maybe<Scalars['ObjectId']['output']>
  /** P6 code being used as Id. */
  code: Scalars['String']['output']
  /** Company id. */
  companyId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is activity deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Locations. */
  locations?: Maybe<Array<Maybe<ISiteLocation>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Activity on time status. */
  onTimeStatus?: Maybe<OnTimeStatus>
  /** Activity complete percent. */
  percentComplete: Scalars['Int']['output']
  /** Planned finish date. */
  plannedFinishDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Planned start date. */
  plannedStartDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Remaining early finish date. */
  remainingEarlyFinishDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Remaining early start date. */
  remainingEarlyStartDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Requester id. */
  requesterId?: Maybe<Scalars['ObjectId']['output']>
  /** Resource id. */
  resourceId?: Maybe<Scalars['ObjectId']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Activity status. */
  status: ActivityStatus
  /** Total float. */
  totalFloat: Scalars['Float']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Work breakdown structure id. */
  workBreakdownStructureId?: Maybe<Scalars['ObjectId']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IActivityAssignment {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Activity id. */
  entityId: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** IsDeleted value */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipients. */
  recipients: Array<Maybe<IRecipients>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityAssignmentChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityAssignment>
}

export interface IActivityAssignmentInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Activity id. */
  entityId: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipients. */
  recipients: Array<InputMaybe<IRecipientsInput>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityAssignmentList {
  data: Array<IActivityAssignment>
  page: IPageInfo
}

export interface IActivityChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivity>
}

export interface IActivityCode {
  /** Count. */
  count?: Maybe<Scalars['Int']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Parent activity code id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Short name. */
  shortName?: Maybe<Scalars['String']['output']>
  /** Activity code type id. */
  typeId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IActivityCodeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityCode>
}

export interface IActivityCodeDataInput {
  /** Activity code type name. */
  activityCodeType: Scalars['String']['input']
  /** Activity codes. */
  activityCodes: Array<InputMaybe<Scalars['String']['input']>>
}

export interface IActivityCodeList {
  data: Array<IActivityCode>
  page: IPageInfo
}

export interface IActivityCodeRelationship {
  /** Activity code id. */
  activityCodeId: Scalars['ObjectId']['output']
  /** Activity code type id. */
  activityCodeTypeId: Scalars['ObjectId']['output']
  /** Activity p6 code. */
  activityP6Code: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** IsDeleted value */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IActivityCodeRelationshipChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityCodeRelationship>
}

export interface IActivityCodeRelationshipInput {
  /** Activity code id. */
  activityCodeId: Scalars['ObjectId']['input']
  /** Activity code type id. */
  activityCodeTypeId: Scalars['ObjectId']['input']
  /** Activity p6 code. */
  activityP6Code?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: InputMaybe<Scalars['String']['input']>
}

export interface IActivityCodeRelationshipList {
  data: Array<IActivityCodeRelationship>
  page: IPageInfo
}

export interface IActivityCodeType {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Scope. */
  scope?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IActivityCodeTypeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityCodeType>
}

export interface IActivityCodeTypeList {
  data: Array<IActivityCodeType>
  page: IPageInfo
}

export interface IActivityDataInput {
  /** Activity to add. */
  activity: IActivityInput
  /** Activity codes data to add. */
  activityCodeData?: InputMaybe<Array<InputMaybe<IActivityCodeDataInput>>>
  /** Message to add. */
  message?: InputMaybe<ISaveMessageInput>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Activity resource name. */
  resource?: InputMaybe<Scalars['String']['input']>
}

export interface IActivityFilter {
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IActivityFilterInput {
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface IActivityFiltersSettings {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  filterInfos?: Maybe<Array<Maybe<IFilterInfo>>>
  hiddenActivityCodeIds: Array<Maybe<Scalars['String']['output']>>
  hiddenActivityCodeTypesIds: Array<Maybe<Scalars['String']['output']>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Schedule Id. */
  scheduleId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityFiltersSettingsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  filterInfos?: InputMaybe<Array<InputMaybe<IFilterInfoInput>>>
  hiddenActivityCodeIds: Array<InputMaybe<Scalars['String']['input']>>
  hiddenActivityCodeTypesIds: Array<InputMaybe<Scalars['String']['input']>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Schedule Id. */
  scheduleId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityFollowing {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityFollowingChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityFollowing>
}

export interface IActivityFollowingInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityFollowingList {
  data: Array<IActivityFollowing>
  page: IPageInfo
}

export interface IActivityInput {
  /** Activity linking settings. */
  activityLinkingSettings?: InputMaybe<IActivityLinkingSettingsInput>
  /** Actual finish date. */
  actualFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Actual start date. */
  actualStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Calendar id. */
  calendarId?: InputMaybe<Scalars['ObjectId']['input']>
  /** P6 code being used as Id. */
  code: Scalars['String']['input']
  /** Company id. */
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Locations. */
  locations?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Schedule entity name. */
  name: Scalars['String']['input']
  /** Activity on time status. */
  onTimeStatus?: InputMaybe<OnTimeStatus>
  /** Activity complete percent. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
  /** Planned finish date. */
  plannedFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Planned start date. */
  plannedStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Remaining early finish date. */
  remainingEarlyFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Remaining early start date. */
  remainingEarlyStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Requester id. */
  requesterId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Resource id. */
  resourceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['input']
  /** Activity status. */
  status: ActivityStatus
  /** Total float. */
  totalFloat?: InputMaybe<Scalars['Float']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Work breakdown structure id. */
  workBreakdownStructureId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: InputMaybe<Scalars['String']['input']>
}

export interface IActivityLinkingSettings {
  /** Is building linking active. */
  isBuildingLinkingActive?: Maybe<Scalars['Boolean']['output']>
  /** Is company linking active. */
  isCompanyLinkingActive?: Maybe<Scalars['Boolean']['output']>
  /** Is level linking active. */
  isLevelLinkingActive?: Maybe<Scalars['Boolean']['output']>
  /** Is zone linking active. */
  isZoneLinkingActive?: Maybe<Scalars['Boolean']['output']>
}

export interface IActivityLinkingSettingsInput {
  /** Is building linking active. */
  isBuildingLinkingActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Is company linking active. */
  isCompanyLinkingActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Is level linking active. */
  isLevelLinkingActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Is zone linking active. */
  isZoneLinkingActive?: InputMaybe<Scalars['Boolean']['input']>
}

export interface IActivityListCustomFilter {
  /** Category names. */
  appliedCategories?: Maybe<Array<Maybe<CategoryName>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** ActivityFilters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<IActivityFilter>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recently updated saved filter. */
  recentlyUpdatedSavedFilter?: Maybe<IRecentlyUpdatedSavedFilter>
  /** Status filter mode. */
  statusFilterMode?: Maybe<ActivityStatus>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityListCustomFilterInput {
  /** Category names. */
  appliedCategories?: InputMaybe<Array<InputMaybe<CategoryName>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** ActivityFilters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<IActivityFilterInput>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recently updated saved filter. */
  recentlyUpdatedSavedFilter?: InputMaybe<IRecentlyUpdatedSavedFilterInput>
  /** Status filter mode. */
  statusFilterMode?: InputMaybe<ActivityStatus>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityListCustomFilterList {
  data: Array<IActivityListCustomFilter>
  page: IPageInfo
}

export interface IActivityLocation {
  /** Activity code Id. In most cases it's an ActivityCode itself. */
  activityCodeId: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Location object id. */
  locationObjectId?: Maybe<Scalars['String']['output']>
  /** Location object type. */
  locationObjectType?: Maybe<LocationType>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityLocationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityLocation>
}

export interface IActivityLocationInput {
  /** Activity code Id. In most cases it's an ActivityCode itself. */
  activityCodeId: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Location object id. */
  locationObjectId?: InputMaybe<Scalars['String']['input']>
  /** Location object type. */
  locationObjectType?: InputMaybe<LocationType>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityLocationList {
  data: Array<IActivityLocation>
  page: IPageInfo
}

export interface IActivityPreset {
  /** Activities. */
  activities?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IActivityPresetChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityPreset>
}

export interface IActivityPresetInput {
  /** Activities. */
  activities: Array<InputMaybe<Scalars['String']['input']>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IActivityPresetList {
  data: Array<IActivityPreset>
  page: IPageInfo
}

export interface IActivityResourceRelationship {
  /** Activity p6 code. */
  activityP6Code: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** IsDeleted value */
  isDeleted: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Resource id. */
  resourceId: Scalars['ObjectId']['output']
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IActivityResourceRelationshipChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IActivityResourceRelationship>
}

export interface IActivityResourceRelationshipList {
  data: Array<IActivityResourceRelationship>
  page: IPageInfo
}

export enum ActivityStatus {
  Completed = 'Completed',
  Done = 'Done',
  DueToday = 'Due_Today',
  DueTomorrow = 'Due_Tomorrow',
  InProgress = 'In_Progress',
  Incomplete = 'Incomplete',
  LateFinish = 'Late_Finish',
  LateStart = 'Late_Start',
  NotStarted = 'Not_Started',
  StartsToday = 'Starts_Today',
}

export interface IAddressBounds {
  /** Top left point. */
  ne?: Maybe<ILatLng>
  /** Bottom right point. */
  sw?: Maybe<ILatLng>
}

export interface IAddressBoundsInput {
  /** Top left point. */
  ne?: InputMaybe<ILatLngInput>
  /** Bottom right point. */
  sw?: InputMaybe<ILatLngInput>
}

export interface IAffectedPermitType {
  /** Permit type id. */
  permitTypeId: Scalars['ObjectId']['output']
  /** Permit type display name. */
  permitTypeName?: Maybe<Scalars['String']['output']>
  /** Permit type stable Type string. */
  permitTypeType?: Maybe<Scalars['String']['output']>
  /** Individual references removed. */
  removals?: Maybe<Array<ICascadeRemoval>>
}

export interface IAnalyticSettingsField {
  /** Field id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether field is enabled. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Field name */
  name?: Maybe<Scalars['String']['output']>
  /** Ids of the permit type fields. */
  permitTypeFields?: Maybe<Array<Maybe<IPermitTypeFieldReference>>>
  /** Summary fields of the analytic settings field. */
  summaryFields?: Maybe<Array<Maybe<ISummaryField>>>
  /** Field type */
  type?: Maybe<Scalars['String']['output']>
}

export interface IAnalyticSettingsFieldInput {
  /** Field id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Whether field is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Field name */
  name?: InputMaybe<Scalars['String']['input']>
  /** Ids of the permit type fields. */
  permitTypeFields?: InputMaybe<
    Array<InputMaybe<IPermitTypeFieldReferenceInput>>
  >
  /** Summary fields of the analytic settings field. */
  summaryFields?: InputMaybe<Array<InputMaybe<ISummaryFieldInput>>>
  /** Field type */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface IAnalyticsSettings {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Analytics settings fields. */
  fields?: Maybe<Array<Maybe<IAnalyticSettingsField>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IAnalyticsSettingsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IAnalyticsSettings>
}

export interface IAnalyticsSettingsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Analytics settings fields. */
  fields?: InputMaybe<Array<InputMaybe<IAnalyticSettingsFieldInput>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IArea extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IAreaInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IAssociatedCode {
  /** Code Id. */
  id: Scalars['String']['output']
  /** QR Code Name. */
  name: Scalars['String']['output']
}

export interface IAssociatedCodeInput {
  /** Code Id. */
  id: Scalars['String']['input']
  /** QR Code Name. */
  name: Scalars['String']['input']
}

export enum AttachementFileType {
  Docx = 'Docx',
  Image = 'Image',
  OtherFile = 'OtherFile',
  Pdf = 'Pdf',
  Pptx = 'Pptx',
  Video = 'Video',
  Xlsx = 'Xlsx',
}

export interface IAttachment {
  /** File name. */
  fileName: Scalars['String']['output']
  /** Size. */
  size: Scalars['String']['output']
  /** Url. */
  url: Scalars['String']['output']
}

export interface IAttachmentInput {
  /** File name. */
  fileName?: InputMaybe<Scalars['String']['input']>
  /** Size. */
  size?: InputMaybe<Scalars['String']['input']>
  /** Url. */
  url?: InputMaybe<Scalars['String']['input']>
}

export interface IAttachmentPermitField extends IPermitFieldInterface {
  /** Values. */
  attachmentValues?: Maybe<Array<Maybe<IAttachment>>>
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IAttachmentPermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IAttachmentInput>>>
}

export interface IBasemap {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** File name. */
  fileName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Source. */
  source?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IBasemapChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IBasemap>
}

export interface IBasemapInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** File name. */
  fileName?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Source. */
  source?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IBasemapList {
  data: Array<IBasemap>
  page: IPageInfo
}

export enum BicCompletionMode {
  AllUsers = 'allUsers',
  AnyOne = 'anyOne',
  OnePerRule = 'onePerRule',
}

export enum BlockTypeEnum {
  Block = 'block',
  Hide = 'hide',
  Warn = 'warn',
}

/** Group of blocked workflows by a single blocking entity. */
export interface IBlockedWorkflowGroup {
  /** The date that was blocked. */
  blockedDate: Scalars['DateTime']['output']
  /** ID of the entity that blocked the workflow creation. */
  blockingEntityId?: Maybe<Scalars['ObjectId']['output']>
  /** Type of the blocking entity. */
  blockingEntityType?: Maybe<Scalars['String']['output']>
  /** ID of the location associated with the blocking closure. */
  locationId?: Maybe<Scalars['ObjectId']['output']>
  /** Name of the location associated with the blocking closure. */
  locationName?: Maybe<Scalars['String']['output']>
  /** The reason why workflows were blocked. */
  reason: BlockingReason
}

/** Reasons for blocking recurring workflow creation. */
export enum BlockingReason {
  Closure = 'CLOSURE',
  NonWorkingDay = 'NON_WORKING_DAY',
  OutsideOperatingHours = 'OUTSIDE_OPERATING_HOURS',
  ProjectClosedInterval = 'PROJECT_CLOSED_INTERVAL',
}

export interface IBookingDeadlineOptions {
  /** Block type. */
  blockType?: Maybe<BlockTypeEnum>
  /** Deadline interval. */
  deadlineInterval?: Maybe<Scalars['Long']['output']>
}

export interface IBookingDeadlineOptionsInput {
  /** Block type. */
  blockType?: InputMaybe<BlockTypeEnum>
  /** Deadline interval. */
  deadlineInterval?: InputMaybe<Scalars['Long']['input']>
}

export interface IBuilding extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Ground level. */
  groundLevel?: Maybe<Scalars['String']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Is ground index set to 0. */
  isGroundIndexZero?: Maybe<Scalars['Boolean']['output']>
  /** Level base name. */
  levelBaseName?: Maybe<Scalars['String']['output']>
  /** Levels order. */
  levelsOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** Skip level index template. */
  skipLevelIndexTemplate?: Maybe<Scalars['String']['output']>
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IBuildingInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Ground level. */
  groundLevel?: InputMaybe<Scalars['String']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is ground index set to 0. */
  isGroundIndexZero?: InputMaybe<Scalars['Boolean']['input']>
  /** Level base name. */
  levelBaseName?: InputMaybe<Scalars['String']['input']>
  /** Levels order. */
  levelsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Skip level index template. */
  skipLevelIndexTemplate?: InputMaybe<Scalars['String']['input']>
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

/** Input for applying a property patch to multiple resources. */
export interface IBulkEditResourcePropertiesInput {
  /** Key-value map of property changes to apply. Null values clear properties. */
  changes: Scalars['JSONObject']['input']
  /** Resource ids to update. */
  resourceIds: Array<Scalars['ObjectId']['input']>
  /** The resource type id (for example: material, sensor, offloading_equipment). */
  resourceTypeId: Scalars['String']['input']
}

export interface ICalendar {
  /** Field definitions of material category. */
  calendarData?: Maybe<ICalendarData>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Date last changed. */
  dateLastChanged?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is the calendar default. */
  isDefault: Scalars['Boolean']['output']
  /** Is the calendar personal. */
  isPersonalCalendar: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Parent calendar id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Calendar type. */
  type: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Work hours per day. */
  workHoursPerDay: Scalars['Int']['output']
  /** Work hours per month. */
  workHoursPerMonth: Scalars['Int']['output']
  /** Work hours per week. */
  workHoursPerWeek: Scalars['Int']['output']
  /** Work hours per year. */
  workHoursPerYear: Scalars['Int']['output']
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface ICalendarConfiguration {
  /** Delivery sharing mode */
  calendarDeliverySharingMode?: Maybe<SharingMode>
  /** Form sharing mode */
  calendarFormSharingMode?: Maybe<SharingMode>
  /** Calendar sharing enabled/disabled */
  calendarSharing?: Maybe<Scalars['Boolean']['output']>
  /** Delivery sharing FROM */
  deliverySharingFrom?: Maybe<Scalars['DateTime']['output']>
  /** Delivery sharing TO */
  deliverySharingTo?: Maybe<Scalars['DateTime']['output']>
  /** Form sharing FROM */
  formSharingFrom?: Maybe<Scalars['DateTime']['output']>
  /** Form sharing TO */
  formSharingTo?: Maybe<Scalars['DateTime']['output']>
  /** Restrict access to fetch calendar events by inviting by project code  */
  restrictByInvites?: Maybe<Scalars['Boolean']['output']>
}

export interface ICalendarData {
  /** Working days. */
  days?: Maybe<Array<Maybe<ICalendarDataDay>>>
  /** Exceptions. */
  exceptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

export interface ICalendarDataDay {
  /** Finish time. */
  finish: Scalars['String']['output']
  /** Start time. */
  start: Scalars['String']['output']
  /** Week day. */
  weekDay: Scalars['Int']['output']
}

export interface ICalendarList {
  data: Array<ICalendar>
  page: IPageInfo
}

export interface ICalendarSubscriber {
  /** Calendar subscriber type */
  calendarSubscriberType?: Maybe<CalendarSubscriberType>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Private calendar subscriber code */
  privateCode?: Maybe<Scalars['String']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Project Calendar subscriber code */
  subscriberCode?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ICalendarSubscriberList {
  data: Array<ICalendarSubscriber>
  page: IPageInfo
}

export enum CalendarSubscriberType {
  External = 'External',
  StruxHub = 'StruxHub',
}

export enum CalendricalType {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
}

/** Configuration for how entities are displayed as cards. */
export interface ICardConfiguration {
  /** Property names to display in the card body. */
  displayProperties: Array<Scalars['String']['output']>
  /** Property name to use as the card subtitle. */
  subtitleProperty?: Maybe<Scalars['String']['output']>
}

export interface ICascadeRemoval {
  /** True when the whole filter entry or conditional rule was deleted (vs. removing one option). */
  entryOrRuleDeleted: Scalars['Boolean']['output']
  /** The permit-type field affected (null for conditional-rule triggers). */
  fieldId?: Maybe<Scalars['ObjectId']['output']>
  /** The removed resource id. */
  resourceId?: Maybe<Scalars['String']['output']>
  /** Which configuration surface the reference was removed from. */
  surface: CascadeSurface
}

export enum CascadeSurface {
  AllowToSelect = 'ALLOW_TO_SELECT',
  ConditionalRule = 'CONDITIONAL_RULE',
  DynamicFilter = 'DYNAMIC_FILTER',
  Exclusion = 'EXCLUSION',
}

export interface ICastAssignment {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delivery id. */
  entityId: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipients. */
  recipients: Array<Maybe<IRecipients>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ICastAssignmentChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ICastAssignment>
}

export interface ICastAssignmentInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity id. */
  entityId?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipients. */
  recipients: Array<InputMaybe<IRecipientsInput>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ICastAssignmentList {
  data: Array<ICastAssignment>
  page: IPageInfo
}

export interface ICastFollowing {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ICastFollowingChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ICastFollowing>
}

export interface ICastFollowingInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ICastFollowingList {
  data: Array<ICastFollowing>
  page: IPageInfo
}

export interface ICategoryForCompare {
  /** What to compare. */
  categoryName: Scalars['String']['output']
  /** Count before upload. */
  previousCount: Scalars['Int']['output']
  /** Count after upload. */
  uploadCount: Scalars['Int']['output']
}

export enum CategoryName {
  ActualizedFromSchedule = 'actualizedFromSchedule',
  CategoryOfVariance = 'categoryOfVariance',
  Critical = 'critical',
  Deliveries = 'deliveries',
  Flagged = 'flagged',
  Late = 'late',
  NotCompleted = 'notCompleted',
  RecentlyUpdated = 'recentlyUpdated',
  Rfi = 'rfi',
  SafetyHazard = 'safetyHazard',
  ScheduleComment = 'scheduleComment',
  Status = 'status',
  UserAssociated = 'userAssociated',
}

export interface IChangeDeliveriesStatusCommandInput {
  /** Delivery ids. */
  deliveryIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Delivery status. */
  nextStatus?: InputMaybe<DeliveryStatus>
  /** Project id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IChecklistAnswerItem {
  /** Answer. */
  answer?: Maybe<Scalars['Boolean']['output']>
  /** Checklist item Id. */
  checklistItemId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IChecklistAnswerItemInput {
  /** Answer. */
  answer?: InputMaybe<Scalars['Boolean']['input']>
  /** Checklist item Id. */
  checklistItemId: Scalars['ObjectId']['input']
}

export interface IChecklistAnswerItemPermitField extends IPermitFieldInterface {
  /** Values. */
  checklistValues?: Maybe<Array<Maybe<IChecklistAnswerItem>>>
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IChecklistAnswerItemPermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IChecklistAnswerItemInput>>>
}

export interface IChecklistItem {
  /** Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Questionnaire type. */
  questionnaireType?: Maybe<Scalars['String']['output']>
  /** Text. */
  text?: Maybe<Scalars['String']['output']>
}

export interface IChecklistItemInput {
  /** Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Questionnaire type. */
  questionnaireType?: InputMaybe<Scalars['String']['input']>
  /** Text. */
  text?: InputMaybe<Scalars['String']['input']>
}

export interface IClosure {
  /** Associated permit's id. */
  associatedPermitId?: Maybe<Scalars['ObjectId']['output']>
  /** Closure interval. */
  closureInterval?: Maybe<ILocationClosureInterval>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Location id. */
  locationId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** List of specified permit type identifiers for this closure's location. */
  specifiedPermitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IClosureAssignment {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Closure id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipients. */
  recipients: Array<Maybe<IRecipients>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IClosureAssignmentChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IClosureAssignment>
}

export interface IClosureAssignmentInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity id. */
  entityId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipients. */
  recipients: Array<InputMaybe<IRecipientsInput>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IClosureAssignmentList {
  data: Array<IClosureAssignment>
  page: IPageInfo
}

export interface IClosureChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IClosure>
}

export interface IClosureFollowing {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IClosureFollowingChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IClosureFollowing>
}

export interface IClosureFollowingInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IClosureFollowingList {
  data: Array<IClosureFollowing>
  page: IPageInfo
}

export interface IClosureInput {
  /** Associated permit id. */
  associatedPermitId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Closure interval. */
  closureInterval?: InputMaybe<ILocationClosureIntervalInput>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Location id. */
  locationId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** List of specified permit type identifiers for this closure's location. */
  specifiedPermitTypes?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IClosureList {
  data: Array<IClosure>
  page: IPageInfo
}

export interface IColumnConfiguration {
  /** Column id. */
  columnId: Scalars['String']['output']
  /** Is column fixed. */
  isFixed: Scalars['Boolean']['output']
  /** Is column hidden. */
  isHidden: Scalars['Boolean']['output']
}

export interface IColumnConfigurationInput {
  /** Column id. */
  columnId: Scalars['String']['input']
  /** Is column fixed. */
  isFixed: Scalars['Boolean']['input']
  /** Is column hidden. */
  isHidden: Scalars['Boolean']['input']
}

export interface IColumnMappingInput {
  columnIndex: Scalars['Int']['input']
  field?: InputMaybe<Scalars['String']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
}

export interface ICompany {
  /** Company address. */
  address?: Maybe<ICompanyAddress>
  /** Avatar URL. */
  avatarUrl?: Maybe<Scalars['String']['output']>
  /** Business email. */
  businessEmail?: Maybe<Scalars['String']['output']>
  /** Business phone. */
  businessPhone?: Maybe<Scalars['String']['output']>
  /** Company code. */
  code?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** DBA. */
  dba?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** License number. */
  licenseNumber?: Maybe<Scalars['String']['output']>
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Company name. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Reports to id. */
  reportsToId?: Maybe<Scalars['ObjectId']['output']>
  /** Responsible contact Ids. */
  responsibleContactIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Role Ids. */
  roleIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** StruxHub Company id. */
  struxHubCompanyId?: Maybe<Scalars['ObjectId']['output']>
  /** Trade Ids. */
  tradeIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Company type tags. */
  typeTags: Array<Maybe<Scalars['ObjectId']['output']>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Company id. */
  value?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ICompanyAddress {
  /** Address. */
  address?: Maybe<Scalars['String']['output']>
  /** City. */
  city?: Maybe<Scalars['String']['output']>
  /** Country. */
  country?: Maybe<Scalars['String']['output']>
  /** State. */
  state?: Maybe<Scalars['String']['output']>
  /** Zip code. */
  zipCode?: Maybe<Scalars['String']['output']>
}

export interface ICompanyAddressInput {
  /** Address. */
  address?: InputMaybe<Scalars['String']['input']>
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>
  /** Country. */
  country?: InputMaybe<Scalars['String']['input']>
  /** State. */
  state?: InputMaybe<Scalars['String']['input']>
  /** Zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export interface ICompanyBasicInfo {
  /** Company id. */
  companyId?: Maybe<Scalars['ObjectId']['output']>
  /** Company name. */
  name?: Maybe<Scalars['String']['output']>
}

export interface ICompanyChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ICompany>
}

export interface ICompanyInput {
  /** Company address. */
  address?: InputMaybe<ICompanyAddressInput>
  /** Avatar URL. */
  avatarUrl?: InputMaybe<Scalars['String']['input']>
  /** Business email. */
  businessEmail?: InputMaybe<Scalars['String']['input']>
  /** Business phone. */
  businessPhone?: InputMaybe<Scalars['String']['input']>
  /** Company code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** DBA. */
  dba?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is deleted. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  /** License number. */
  licenseNumber?: InputMaybe<Scalars['String']['input']>
  /** Logo URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Reports to id. */
  reportsToId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Responsible contact Ids. */
  responsibleContactIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Role Ids. */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** StruxHub company Id. */
  struxHubCompanyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Trade Ids. */
  tradeIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Company type. */
  typeTags: Array<InputMaybe<Scalars['ObjectId']['input']>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ICompanyList {
  data: Array<ICompany>
  page: IPageInfo
}

export interface ICompanyRelationship {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** External company id. */
  externalCompanyId?: Maybe<Scalars['ObjectId']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** StruxHub's company id. */
  struxHubCompanyId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface ICompanyRelationshipChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ICompanyRelationship>
}

export interface ICompanyRelationshipInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** External company id. */
  externalCompanyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['input']
  /** StruxHub's company id. */
  struxHubCompanyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: InputMaybe<Scalars['String']['input']>
}

export interface ICompanyRelationshipList {
  data: Array<ICompanyRelationship>
  page: IPageInfo
}

export interface ICompanyStatusUpdate {
  /** Company name. */
  companyName?: Maybe<Scalars['String']['output']>
  /** Did update. */
  didUpdate?: Maybe<Scalars['Boolean']['output']>
  /** Is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Man power. */
  manpower?: Maybe<Scalars['Int']['output']>
  /** Man power updated at. */
  manpowerUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Percent complete. */
  percentComplete?: Maybe<Scalars['Int']['output']>
  /** Percent complete updated at. */
  percentCompleteUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Updated at. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

export interface ICompanyStatusUpdateInput {
  /** Company name. */
  companyName?: InputMaybe<Scalars['String']['input']>
  /** Did update. */
  didUpdate?: InputMaybe<Scalars['Boolean']['input']>
  /** Is deleted. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  /** Man power. */
  manpower?: InputMaybe<Scalars['Int']['input']>
  /** Man power updated at. */
  manpowerUpdatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Percent complete. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
  /** Percent complete updated at. */
  percentCompleteUpdatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Updated at. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IConcreteDirectAddress {
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  line: Scalars['String']['output']
  state?: Maybe<Scalars['String']['output']>
  zipCode: Scalars['String']['output']
}

export interface IConcreteDirectESignature {
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  worksiteWaiverAccepted: Scalars['Boolean']['output']
}

export interface IConcreteDirectIntegrationInput {
  /** Base URL for CD access. */
  cDBaseURL?: InputMaybe<Scalars['String']['input']>
  /** Login for CD access. */
  cDLogin?: InputMaybe<Scalars['String']['input']>
  /** Password for CD access. */
  cDPassword?: InputMaybe<Scalars['String']['input']>
  /** Is CD active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** StruxHub Project Id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Site Id for CD access. */
  siteId?: InputMaybe<Scalars['String']['input']>
  /** The sync start date uses for the initial data pull. */
  syncStartDate?: InputMaybe<Scalars['DateTime']['input']>
}

export interface IConcreteDirectItem {
  defaultSlump?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  status: Scalars['String']['output']
  systemId: Scalars['String']['output']
  type: Scalars['String']['output']
  unityOfMeasure: Scalars['String']['output']
}

export interface IConcreteDirectOrder {
  accountingReference?: Maybe<Scalars['String']['output']>
  address?: Maybe<IConcreteDirectAddress>
  concreteDirectId: Scalars['Guid']['output']
  costEstimationCalculated: Scalars['Boolean']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  customFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  deliveryId?: Maybe<Scalars['ObjectId']['output']>
  deliveryInstructions?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  isManualDispatchAllowed: Scalars['Boolean']['output']
  isPaperless: Scalars['Boolean']['output']
  isReservation: Scalars['Boolean']['output']
  isReviewNeeded: Scalars['Boolean']['output']
  isWaitingForDispatchSystem: Scalars['Boolean']['output']
  jobsiteId: Scalars['ID']['output']
  localStartDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Coordinates. */
  location?: Maybe<IGeoJson2DGeographicCoordinates>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  orderByName?: Maybe<Scalars['String']['output']>
  orderByPhone?: Maybe<Scalars['String']['output']>
  orderCostEstimations?: Maybe<Array<Maybe<IConcreteDirectOrderCostEstimation>>>
  orderItems?: Maybe<Array<Maybe<IConcreteDirectOrderItem>>>
  orderReference?: Maybe<Scalars['String']['output']>
  orderedByApp?: Maybe<Scalars['String']['output']>
  orderedByUserId?: Maybe<Scalars['ID']['output']>
  pricingPlantId: Scalars['ID']['output']
  printBatchWeights: Scalars['Boolean']['output']
  progressPercent: Scalars['Int']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  riskAssessmentQuestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  sentToExternalBackend: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['MillisecondsDate']['output']>
  status: Scalars['String']['output']
  systemId: Scalars['String']['output']
  timeWindow: Scalars['Int']['output']
  timeZone: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IConcreteDirectOrderChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IConcreteDirectOrder>
}

export interface IConcreteDirectOrderCostEstimation {
  calculatedDriveCost: Scalars['Float']['output']
  calculatedDriveCostCurrency: Scalars['String']['output']
  id: Scalars['ID']['output']
  plantId: Scalars['ID']['output']
  travelTimeInMinutes: Scalars['Int']['output']
}

export interface IConcreteDirectOrderItem {
  actualQtyPerHour: Scalars['Float']['output']
  actualSpacingInMinutes: Scalars['Int']['output']
  currentBatchedQuantity: Scalars['Float']['output']
  currentTicketedQuantity: Scalars['Float']['output']
  deliveredQuantity: Scalars['Float']['output']
  description: Scalars['String']['output']
  extendedPourElement?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  holdQty: Scalars['Float']['output']
  id: Scalars['String']['output']
  isExactQuantity: Scalars['Boolean']['output']
  item?: Maybe<IConcreteDirectItem>
  itemId: Scalars['ID']['output']
  jobsiteDistanceInMeters: Scalars['Int']['output']
  localStart?: Maybe<Scalars['MillisecondsDate']['output']>
  orderItemAdditions?: Maybe<Array<Maybe<IConcreteDirectOrderItemAddition>>>
  payloadSize: Scalars['Float']['output']
  plantId: Scalars['String']['output']
  pourElement?: Maybe<Scalars['String']['output']>
  pourMethod?: Maybe<Scalars['String']['output']>
  pouredQuantity: Scalars['Float']['output']
  progressPercent: Scalars['Float']['output']
  qtyPerHour: Scalars['Float']['output']
  quantity: Scalars['Float']['output']
  rateType: Scalars['String']['output']
  slump?: Maybe<Scalars['String']['output']>
  spacingInMinutes: Scalars['Int']['output']
  start?: Maybe<Scalars['MillisecondsDate']['output']>
  travelTimeInMinutes: Scalars['Int']['output']
}

export interface IConcreteDirectOrderItemAddition {
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  item?: Maybe<IConcreteDirectItem>
  itemId: Scalars['ID']['output']
  quantity: Scalars['Float']['output']
}

export interface IConcreteDirectOrderList {
  data: Array<IConcreteDirectOrder>
  page: IPageInfo
}

export interface IConcreteDirectPayload {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  cumulativeQuantity: Scalars['Float']['output']
  deliveredAt?: Maybe<Scalars['MillisecondsDate']['output']>
  deliveredQuantity?: Maybe<Scalars['Float']['output']>
  eSignature?: Maybe<IConcreteDirectESignature>
  eSignatureMissing: Scalars['Boolean']['output']
  eta?: Maybe<Scalars['MillisecondsDate']['output']>
  etaCalculatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  etaQuality?: Maybe<Scalars['String']['output']>
  hasESignature: Scalars['Boolean']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  isRedirect: Scalars['Boolean']['output']
  isRetro: Scalars['Boolean']['output']
  isReviewed: Scalars['Boolean']['output']
  lastUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  orderId: Scalars['Guid']['output']
  orderItemId: Scalars['Guid']['output']
  payloadEvent?: Maybe<IConcreteDirectPayloadEvent>
  payloadId: Scalars['Guid']['output']
  permittedStatuses: Array<Maybe<Scalars['String']['output']>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  quantity: Scalars['Float']['output']
  returnedQuantity?: Maybe<Scalars['String']['output']>
  siteId: Scalars['Guid']['output']
  slump?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  supportsAdditives: Scalars['Boolean']['output']
  ticketReference: Scalars['String']['output']
  timeOnSite: Scalars['Int']['output']
  totalNoOfTests: Scalars['Int']['output']
  totalNoOfTestsCompleted: Scalars['Int']['output']
  transportedByVehicleId?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  waterContent?: Maybe<IConcreteDirectWaterContent>
}

export interface IConcreteDirectPayloadChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IConcreteDirectPayload>
}

export interface IConcreteDirectPayloadEvent {
  arrivalTime?: Maybe<Scalars['MillisecondsDate']['output']>
  batchEndTime?: Maybe<Scalars['MillisecondsDate']['output']>
  batchStartTime?: Maybe<Scalars['MillisecondsDate']['output']>
  departureTime?: Maybe<Scalars['MillisecondsDate']['output']>
  departureTimeQuality?: Maybe<Scalars['String']['output']>
  pouringStartTime?: Maybe<Scalars['MillisecondsDate']['output']>
  toPlantTime?: Maybe<Scalars['MillisecondsDate']['output']>
  typedTime?: Maybe<Scalars['MillisecondsDate']['output']>
  washTime?: Maybe<Scalars['MillisecondsDate']['output']>
}

export interface IConcreteDirectPayloadList {
  data: Array<IConcreteDirectPayload>
  page: IPageInfo
}

export interface IConcreteDirectSqsConfigurationInput {
  /** Access Key for SQS. */
  accessKey?: InputMaybe<Scalars['String']['input']>
  /** Aws Region. */
  awsRegion?: InputMaybe<Scalars['String']['input']>
  /** Is Test. */
  isTest?: InputMaybe<Scalars['Boolean']['input']>
  /** Max Number Of Messages. */
  maxNumberOfMessages?: InputMaybe<Scalars['Int']['input']>
  /** Message Group Id. */
  messageGroupId?: InputMaybe<Scalars['String']['input']>
  /** Message Wait Time Seconds. */
  messageWaitTimeSeconds?: InputMaybe<Scalars['Int']['input']>
  /** Queue Url. */
  queueUrl?: InputMaybe<Scalars['String']['input']>
  /** Secret. */
  secret?: InputMaybe<Scalars['String']['input']>
  /** Use Fifo. */
  useFifo?: InputMaybe<Scalars['Boolean']['input']>
}

export interface IConcreteDirectWaterContent {
  actualWater?: Maybe<Scalars['String']['output']>
  actualWaterUOM?: Maybe<Scalars['String']['output']>
  designWater?: Maybe<Scalars['String']['output']>
  designWaterUOM?: Maybe<Scalars['String']['output']>
  waterCementRatioActual?: Maybe<Scalars['String']['output']>
  waterCementRatioDesign?: Maybe<Scalars['String']['output']>
  waterToAdd?: Maybe<Scalars['String']['output']>
  waterToAddUOM?: Maybe<Scalars['String']['output']>
}

export interface IConditionalField {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Key. */
  key: Scalars['String']['output']
  /** Values. */
  values: Array<Maybe<IPermitTypeField>>
}

export interface IConditionalFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Key. */
  key: Scalars['String']['input']
  /** Values. */
  values: Array<InputMaybe<IPermitTypeFieldsInput>>
}

export interface IConfiguration {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The description of the configuration. */
  description: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** The collection of tags for this configuration. */
  tags: Array<Maybe<Scalars['String']['output']>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The value of the configuration. */
  value: Scalars['String']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IConfigurationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IConfiguration>
}

export interface IConstraint {
  /** Building id. */
  buildingId?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is explicit. */
  isExplicit: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Restricted areas ids. */
  restrictedAreas: Array<Maybe<Scalars['String']['output']>>
  /** Restricted equipment ids. */
  restrictedEquipment: Array<Maybe<Scalars['String']['output']>>
  /** Restricted gates ids. */
  restrictedGates: Array<Maybe<Scalars['String']['output']>>
  /** Restricted interior doors. */
  restrictedInteriorDoors: Array<Maybe<Scalars['String']['output']>>
  /** Restricted interior paths. */
  restrictedInteriorPaths: Array<Maybe<Scalars['String']['output']>>
  /** Restricted levels ids. */
  restrictedLevels: Array<Maybe<Scalars['String']['output']>>
  /** Restricted routes ids. */
  restrictedRoutes: Array<Maybe<Scalars['String']['output']>>
  /** Restricted stagings. */
  restrictedStagings: Array<Maybe<Scalars['String']['output']>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Zone id. */
  zoneId: Scalars['String']['output']
}

export interface IConstraintChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IConstraint>
}

export interface IConstraintInput {
  /** Building id. */
  buildingId?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is explicit. */
  isExplicit: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Restricted areas ids. */
  restrictedAreas: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted equipment ids. */
  restrictedEquipment: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted gates ids. */
  restrictedGates: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted interior doors. */
  restrictedInteriorDoors: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted interior paths. */
  restrictedInteriorPaths: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted levels ids. */
  restrictedLevels: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted routes ids. */
  restrictedRoutes: Array<InputMaybe<Scalars['String']['input']>>
  /** Restricted stagings. */
  restrictedStagings: Array<InputMaybe<Scalars['String']['input']>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Zone id. */
  zoneId: Scalars['String']['input']
}

export interface IConstraintList {
  data: Array<IConstraint>
  page: IPageInfo
}

export interface IContentObject {
  activityObjectId?: Maybe<Scalars['String']['output']>
  author?: Maybe<Scalars['ObjectId']['output']>
  contentObjectType?: Maybe<ContentObjectType>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  status?: Maybe<ContentObjectStatus>
  threadId?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IContentObjectChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IContentObject>
}

export interface IContentObjectInput {
  activityObjectId?: InputMaybe<Scalars['String']['input']>
  author?: InputMaybe<Scalars['ObjectId']['input']>
  contentObjectType?: InputMaybe<ContentObjectType>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  status?: InputMaybe<ContentObjectStatus>
  threadId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IContentObjectList {
  data: Array<IContentObject>
  page: IPageInfo
}

export enum ContentObjectStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export enum ContentObjectType {
  CategoryOfVariance = 'CategoryOfVariance',
  Flag = 'Flag',
  RequestForInformation = 'RequestForInformation',
  SafetyHazard = 'SafetyHazard',
  ScheduleComment = 'ScheduleComment',
}

export interface ICopyAllGraphType {
  /** Copy all Companies */
  companies?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy all Forms */
  forms?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy all Materials */
  materials?: InputMaybe<Scalars['Boolean']['input']>
  /** Copy all Users */
  users?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for creating a new property definition. */
export interface ICreateResourcePropertyInput {
  /** Type-specific configuration. */
  configuration?: InputMaybe<IPropertyConfigurationInput>
  /** Human-readable label for UI display. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** If true, property is managed by external system and read-only in UI. */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>
  /** Identifier name (snake_case, unique within resource type). */
  name: Scalars['String']['input']
  /** Global display order. */
  position?: InputMaybe<Scalars['Int']['input']>
  /** The data type of this property. */
  propertyType: PropertyType
  /** The resource type this property belongs to. */
  resourceTypeId: Scalars['String']['input']
}

/** Input for creating a new resource template. */
export interface ICreateResourceTemplateInput {
  /** Prefix used for auto-generating resource codes (e.g., 'EQP', 'MAT', 'STG'). */
  codePrefix?: InputMaybe<Scalars['String']['input']>
  /** Optional description of when to use this template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Display name for this template. */
  name: Scalars['String']['input']
  /** Properties to include in this template. */
  properties?: InputMaybe<Array<ITemplatePropertyInput>>
  /** The resource type this template applies to. */
  resourceTypeId: Scalars['String']['input']
}

export interface ICsvFileModelInput {
  /** File. */
  file?: InputMaybe<Scalars['String']['input']>
  /** Project Id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IDailyLogFieldMappingInput {
  /** Procore DailyLog field name */
  dailyLogFieldName?: InputMaybe<Scalars['String']['input']>
  /** List of source fields to map from */
  fieldSources?: InputMaybe<Array<InputMaybe<IPermitFieldSourceInput>>>
}

export interface IDashboardPreferences {
  /** Chart type configurations (stringified JSON). */
  chartTypes?: Maybe<Scalars['String']['output']>
  /** Custom widgets configuration (stringified JSON). */
  customWidgets?: Maybe<Scalars['String']['output']>
  /** Dashboard layout configuration (stringified JSON). */
  layout?: Maybe<Scalars['String']['output']>
  /** Widget visibility settings (stringified JSON). */
  widgetVisibility?: Maybe<Scalars['String']['output']>
}

export interface IDashboardPreferencesInput {
  /** Chart type configurations (stringified JSON). */
  chartTypes?: InputMaybe<Scalars['String']['input']>
  /** Custom widgets configuration (stringified JSON). */
  customWidgets?: InputMaybe<Scalars['String']['input']>
  /** Dashboard layout configuration (stringified JSON). */
  layout?: InputMaybe<Scalars['String']['input']>
  /** Widget visibility settings (stringified JSON). */
  widgetVisibility?: InputMaybe<Scalars['String']['input']>
}

export interface IDateInterval {
  /** Weekday this interval recurs on, 1 = Sunday .. 7 = Saturday. Null means the interval is not weekday-scoped: it repeats every day unless isDaily is false, which marks it dated. */
  dayOfWeek?: Maybe<Scalars['Int']['output']>
  endDate: Scalars['Long']['output']
  isDaily?: Maybe<Scalars['Boolean']['output']>
  startDate: Scalars['Long']['output']
}

export interface IDateIntervalInput {
  /** Weekday this interval recurs on, 1 = Sunday .. 7 = Saturday. Null means the interval is not weekday-scoped: it repeats every day unless isDaily is false, which marks it dated. */
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>
  endDate: Scalars['Long']['input']
  isDaily?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['Long']['input']
}

export interface IDateTimePermitField extends IPermitFieldInterface {
  /** Values. */
  dateTimeValues?: Maybe<Array<Maybe<Scalars['MillisecondsDate']['output']>>>
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IDateTimePermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['MillisecondsDate']['input']>>>
}

export enum DefaultCompanyType {
  GeneralContractorPrimary = 'GeneralContractorPrimary',
  GeneralContractorSecondary = 'GeneralContractorSecondary',
  Owner = 'Owner',
  SubContractor = 'SubContractor',
  TieredSubContractor = 'TieredSubContractor',
  Vendor = 'Vendor',
}

export enum DefaultLandingPage {
  Analytics = 'analytics',
  Deliveries = 'deliveries',
  Equipment = 'equipment',
  Forms = 'forms',
  Home = 'home',
  Locations = 'locations',
  MaterialResources = 'materialResources',
  Materials = 'materials',
  Photos = 'photos',
  StruxTags = 'struxTags',
  Tracker = 'tracker',
}

export interface IDefaultPermitType {
  /** IDs of steps for auto-ending. */
  autoEndStepIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Booking deadline options. */
  bookingDeadlineOptions?: Maybe<IBookingDeadlineOptions>
  /** Associated category id. Can be null. */
  categoryId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default duration options. */
  defaultDurationOptions?: Maybe<IWorkflowDurationOptions>
  /** Icon name. */
  iconName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inspection options. */
  inspectionOptions?: Maybe<IInspectionOptions>
  /** Is auto activation enabled. */
  isAutoActivationEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Determines whether the form is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Is enabled. */
  isEnabled: Scalars['Boolean']['output']
  /** Indicates whether the workflow form title is mandatory. */
  isWorkflowTitleMandatory?: Maybe<Scalars['Boolean']['output']>
  /** Maximum duration options. */
  maxDurationOptions?: Maybe<IWorkflowDurationOptions>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Permit type name. */
  name?: Maybe<Scalars['String']['output']>
  /** Order index. */
  orderIndex: Scalars['Int']['output']
  /** Recurring options. */
  recurringOptions?: Maybe<IRecurringOptions>
  /** Type (eg 'hotwork', 'ladder', 'energized', 'aerial', 'fireExtinguisher'). */
  type: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Steps. */
  workflowSteps?: Maybe<Array<Maybe<IWorkflowStep>>>
}

export interface IDefaultPermitTypeList {
  data: Array<IDefaultPermitType>
  page: IPageInfo
}

export interface IDefaultTeam {
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Name. */
  name: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDefaultTeamList {
  data: Array<IDefaultTeam>
  page: IPageInfo
}

export interface IDeleteUsersInput {
  /** User Email. */
  email: Scalars['String']['input']
  /** User Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** User Phone. */
  phoneNumber: Scalars['String']['input']
}

export interface IDeletedUserInfo {
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** User Id. */
  id: Scalars['ObjectId']['output']
  /** Initials. */
  initials?: Maybe<Scalars['String']['output']>
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>
}

export interface IDelivery {
  /** Activity Id. */
  activityId?: Maybe<Scalars['String']['output']>
  /** Actual end date. */
  actualEndDate?: Maybe<Scalars['Long']['output']>
  /** Actual start date. */
  actualStartDate?: Maybe<Scalars['Long']['output']>
  /** Booking Id. */
  bookingId?: Maybe<Scalars['String']['output']>
  cancellationReason?: Maybe<Scalars['String']['output']>
  /** Company id. */
  company?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Driver phone numbers. */
  driverPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** End date. */
  endDate?: Maybe<Scalars['Long']['output']>
  /** From installation zone. */
  fromInstallationZone?: Maybe<Scalars['String']['output']>
  /** Globe view urls. */
  globeViewUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inspector user Id. */
  inspector?: Maybe<Scalars['ObjectId']['output']>
  /** To installation zone. */
  installationZone?: Maybe<Scalars['String']['output']>
  /** Is inspection required. */
  isInspectionRequired?: Maybe<Scalars['Boolean']['output']>
  /** Is late request. */
  isLateRequest?: Maybe<Scalars['Boolean']['output']>
  /** Is scheduling in advance prevented. */
  isSchedulingInAdvancePrevented?: Maybe<Scalars['Boolean']['output']>
  /** Is unscheduled request. */
  isUnscheduledRequest?: Maybe<Scalars['Boolean']['output']>
  /** Delivery location from. */
  locationsFrom?: Maybe<Array<Maybe<ISiteLocation>>>
  /** Delivery location to. */
  locationsTo?: Maybe<Array<Maybe<ISiteLocation>>>
  /** Last time a message was sent to the delivery log. */
  logUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delivery materials. */
  materials?: Maybe<Array<Maybe<IDeliveryMaterial>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Note. */
  note?: Maybe<Scalars['String']['output']>
  /** Number of equipment picks. */
  numberOfEquipmentPicks?: Maybe<Scalars['String']['output']>
  /** Offloading equipment. */
  offloadingEquipments?: Maybe<Array<Maybe<IDeliveryAttribute>>>
  /** On-site contact person Ids. */
  onSiteContactPersonIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recurring setting id. */
  recurringSettingId?: Maybe<Scalars['ObjectId']['output']>
  /** Sitemap urls. */
  sitemapUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Start date. */
  startDate?: Maybe<Scalars['Long']['output']>
  /** Status. */
  status?: Maybe<DeliveryStatus>
  /** Thread Id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** Truck license plate. */
  truckLicensePlate?: Maybe<Scalars['String']['output']>
  /** Truck number. */
  truckNumber?: Maybe<Scalars['String']['output']>
  /** Truck size. */
  truckSize?: Maybe<Scalars['ObjectId']['output']>
  /** Type. */
  type: DeliveryType
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** Vendor name. */
  vendor?: Maybe<Scalars['ObjectId']['output']>
  /** Vendor emails. */
  vendorEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryAssignment {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delivery id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipients. */
  recipients: Array<Maybe<IRecipients>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryAssignmentChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryAssignment>
}

export interface IDeliveryAssignmentInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Delivery id. */
  entityId: Scalars['ObjectId']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipients. */
  recipients: Array<InputMaybe<IRecipientsInput>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryAssignmentList {
  data: Array<IDeliveryAssignment>
  page: IPageInfo
}

export interface IDeliveryAttribute {
  /** Delivery attribute Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
}

export interface IDeliveryAttributeInput {
  /** Attribute Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IDeliveryCardField {
  /** Delivery field id. */
  fieldId: Scalars['String']['output']
  /** Is field hidden. */
  isHidden: Scalars['Boolean']['output']
}

export interface IDeliveryCardFieldInput {
  /** Delivery field id. */
  fieldId: Scalars['String']['input']
  /** Is field hidden. */
  isHidden: Scalars['Boolean']['input']
}

export interface IDeliveryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDelivery>
}

export interface IDeliveryConfigurations {
  /** Colors list. */
  allColors?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Delivery card coloring location type. */
  cardColoringLocationType?: Maybe<LocationType>
  /** Delivery card fields configuration. */
  cardFieldsConfig?: Maybe<Array<Maybe<IDeliveryCardField>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom action button text. */
  customActionButtonText?: Maybe<Scalars['String']['output']>
  /** Custom action text. */
  customActionText?: Maybe<Scalars['String']['output']>
  /** Custom action url. */
  customActionUrl?: Maybe<Scalars['String']['output']>
  /** Deadline Interval. */
  deadlineInterval?: Maybe<Scalars['Int']['output']>
  /** Delivery Duration. */
  deliveryDuration?: Maybe<Scalars['Int']['output']>
  /** List of the hidden cancellation reasons. */
  hiddenCancelationReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is custom action included. */
  isCustomActionIncluded?: Maybe<Scalars['Boolean']['output']>
  /** Is multiple equipment allowed. */
  isMultipleEquipmentAllowed?: Maybe<Scalars['Boolean']['output']>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Non work-times block type. */
  nonWorkTimesBlockType?: Maybe<BlockTypeEnum>
  /** On time window. */
  onTimeWindow?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Saved delivery filter groups. */
  savedDeliveryGroups?: Maybe<Array<Maybe<IFilterGroup>>>
  /** Should Block Late Requesting. */
  shouldBlockLateRequesting?: Maybe<Scalars['Boolean']['output']>
  /** Unextendable fields. */
  unextendableFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryConfigurationsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryConfigurations>
}

export interface IDeliveryConfigurationsInput {
  /** Colors list. */
  allColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Delivery card coloring location type. */
  cardColoringLocationType?: InputMaybe<LocationType>
  /** Delivery card fields configuration. */
  cardFieldsConfig?: InputMaybe<Array<InputMaybe<IDeliveryCardFieldInput>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom action button text. */
  customActionButtonText?: InputMaybe<Scalars['String']['input']>
  /** Custom action text. */
  customActionText?: InputMaybe<Scalars['String']['input']>
  /** Custom action url. */
  customActionUrl?: InputMaybe<Scalars['String']['input']>
  /** Deadline Interval. */
  deadlineInterval?: InputMaybe<Scalars['Int']['input']>
  /** Delivery Duration. */
  deliveryDuration?: InputMaybe<Scalars['Int']['input']>
  /** List of the hidden cancellation reasons. */
  hiddenCancelationReasons?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is custom action included. */
  isCustomActionIncluded?: InputMaybe<Scalars['Boolean']['input']>
  /** Is multiple equipment allowed. */
  isMultipleEquipmentAllowed?: InputMaybe<Scalars['Boolean']['input']>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Non work-times block type. */
  nonWorkTimesBlockType?: InputMaybe<BlockTypeEnum>
  /** On time window. */
  onTimeWindow?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Saved delivery filter groups. */
  savedDeliveryGroups?: InputMaybe<Array<InputMaybe<IFilterGroupInput>>>
  /** Should Block Late Requesting. */
  shouldBlockLateRequesting?: InputMaybe<Scalars['Boolean']['input']>
  /** Unextendable fields. */
  unextendableFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryConfigurationsList {
  data: Array<IDeliveryConfigurations>
  page: IPageInfo
}

export interface IDeliveryEquipmentReport {
  /** Id */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Name */
  name?: Maybe<Scalars['String']['output']>
  /** Number of Equipment Picks */
  numberOfEquipmentPicks?: Maybe<Scalars['String']['output']>
}

export interface IDeliveryFieldName {
  /** Field id. */
  id: Scalars['String']['output']
  /** Custom field name. */
  name: Scalars['String']['output']
}

export interface IDeliveryFieldNameInput {
  /** Field id. */
  id: Scalars['String']['input']
  /** Custom field name. */
  name: Scalars['String']['input']
}

export interface IDeliveryFieldsConfigurations {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** List of custom names of delivery fields. */
  fieldNames?: Maybe<Array<Maybe<IDeliveryFieldName>>>
  /** List of hidden delivery fields. */
  hiddenFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** List of mandatory delivery fields. */
  mandatoryFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryFieldsConfigurationsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryFieldsConfigurations>
}

export interface IDeliveryFieldsConfigurationsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** List of custom names of delivery fields. */
  fieldNames?: InputMaybe<Array<InputMaybe<IDeliveryFieldNameInput>>>
  /** List of hidden delivery fields. */
  hiddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** List of mandatory delivery fields. */
  mandatoryFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryFieldsConfigurationsList {
  data: Array<IDeliveryFieldsConfigurations>
  page: IPageInfo
}

export interface IDeliveryFilter {
  /** Type. */
  type?: Maybe<DeliveryFilterType>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IDeliveryFilterInput {
  /** Type. */
  type?: InputMaybe<DeliveryFilterType>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum DeliveryFilterType {
  Area = 'area',
  Assignee = 'assignee',
  Assigners = 'assigners',
  Building = 'building',
  Company = 'company',
  Equipment = 'equipment',
  Followers = 'followers',
  Gate = 'gate',
  InteriorDoor = 'interiorDoor',
  InteriorPath = 'interiorPath',
  Level = 'level',
  Locations = 'locations',
  Project = 'project',
  Route = 'route',
  Staging = 'staging',
  Status = 'status',
  Zone = 'zone',
}

export interface IDeliveryFollowing {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryFollowingChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryFollowing>
}

export interface IDeliveryFollowingInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryFollowingList {
  data: Array<IDeliveryFollowing>
  page: IPageInfo
}

export interface IDeliveryHierarchyParent {
  /** Parent id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Parent type. */
  parentType?: Maybe<LocationType>
}

export interface IDeliveryHierarchyParentInput {
  /** Parent id. */
  parentId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Parent type. */
  parentType?: InputMaybe<LocationType>
}

export interface IDeliveryInput {
  /** Activity Id. */
  activityId?: InputMaybe<Scalars['String']['input']>
  /** Company. */
  company?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Driver phone numbers. */
  driverPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** End date. */
  endDate: Scalars['Long']['input']
  /** From installation zone. */
  fromInstallationZone?: InputMaybe<Scalars['String']['input']>
  /** Globe view urls. */
  globeViewUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Inspector. */
  inspector?: InputMaybe<Scalars['ObjectId']['input']>
  /** To installation zone. */
  installationZone?: InputMaybe<Scalars['String']['input']>
  /** Is inspection required. */
  isInspectionRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Is unscheduled request. */
  isUnscheduledRequest?: InputMaybe<Scalars['Boolean']['input']>
  /** Delivery location from. */
  locationsFrom?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Delivery location to. */
  locationsTo?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Materials. */
  materials?: InputMaybe<Array<InputMaybe<IDeliveryMaterialInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Node. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Number of equipment picks. */
  numberOfEquipmentPicks?: InputMaybe<Scalars['String']['input']>
  /** Offloading equipments. */
  offloadingEquipments?: InputMaybe<Array<InputMaybe<IDeliveryAttributeInput>>>
  /** On site contact person ids. */
  onSiteContactPersonIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recurring setting id. */
  recurringSettingId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Sitemap urls. */
  sitemapUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Start date. */
  startDate?: InputMaybe<Scalars['Long']['input']>
  /** Status. */
  status?: InputMaybe<DeliveryStatus>
  /** Thread Id. */
  threadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Truck license plate. */
  truckLicensePlate?: InputMaybe<Scalars['String']['input']>
  /** Truck number. */
  truckNumber?: InputMaybe<Scalars['String']['input']>
  /** Truck size. */
  truckSize?: InputMaybe<Scalars['ObjectId']['input']>
  /** Type. */
  type: DeliveryType
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User id. */
  userId?: InputMaybe<Scalars['String']['input']>
  /** Vendor. */
  vendor?: InputMaybe<Scalars['ObjectId']['input']>
  /** Vendor emails. */
  vendorEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryList {
  data: Array<IDelivery>
  page: IPageInfo
}

export interface IDeliveryListCustomFilter {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default for users. */
  defaultForUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Filters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<IDeliveryFilter>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryListCustomFilterInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default for users. */
  defaultForUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** DeliveryFilters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<IDeliveryFilterInput>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryListCustomFilterList {
  data: Array<IDeliveryListCustomFilter>
  page: IPageInfo
}

export enum DeliveryListFilterType {
  Building = 'building',
  Company = 'company',
  Gate = 'gate',
  Lbs = 'lbs',
  MaterialsCategory = 'materialsCategory',
  None = 'none',
  OnSiteContact = 'onSiteContact',
  Route = 'route',
  Status = 'status',
  VehicleType = 'vehicleType',
  Vendor = 'vendor',
  Zone = 'zone',
}

export interface IDeliveryListSettings {
  /** Is following filter active. */
  isFollowingFilterActive: Scalars['Boolean']['output']
  /** Is my company filter active. */
  isMyCompanyFilterActive: Scalars['Boolean']['output']
  /** Selected filters. */
  selectedFilters?: Maybe<Array<Maybe<IDeliveryFilter>>>
  /** Selected group by option. */
  selectedGroupByOption?: Maybe<DeliveryListFilterType>
}

export interface IDeliveryListSettingsInput {
  /** Is following filter active. */
  isFollowingFilterActive: Scalars['Boolean']['input']
  /** Is my company filter active. */
  isMyCompanyFilterActive: Scalars['Boolean']['input']
  /** Selected filters. */
  selectedFilters?: InputMaybe<Array<InputMaybe<IDeliveryFilterInput>>>
  /** Selected group by option. */
  selectedGroupByOption?: InputMaybe<DeliveryListFilterType>
}

export interface IDeliveryMaterial {
  /** Location Id. */
  locationId?: Maybe<Scalars['ObjectId']['output']>
  /** Material Id. */
  materialId: Scalars['ObjectId']['output']
  /** Note. */
  note?: Maybe<Scalars['String']['output']>
  /** Procurement Id. */
  procurementId?: Maybe<Scalars['String']['output']>
  /** Quantity. */
  quantity?: Maybe<Scalars['Float']['output']>
  /** Unit id. */
  unitId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IDeliveryMaterialInput {
  /** Location Id. */
  locationId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Material Id. */
  materialId: Scalars['ObjectId']['input']
  /** Note. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Procurement Id. */
  procurementId?: InputMaybe<Scalars['String']['input']>
  /** Quantity. */
  quantity?: InputMaybe<Scalars['Float']['input']>
  /** Unit id. */
  unitId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IDeliveryMaterialReport {
  /** Material Category. */
  materialCategory?: Maybe<Scalars['String']['output']>
  /** Material Name. */
  materialName?: Maybe<Scalars['String']['output']>
  /** Material Note. */
  materialNote?: Maybe<Scalars['String']['output']>
  /** Quantity. */
  quantity?: Maybe<Scalars['Float']['output']>
  /** Unit. */
  unit?: Maybe<Scalars['String']['output']>
}

export interface IDeliveryReportResponse {
  /** Activity Id. */
  activityId?: Maybe<Scalars['String']['output']>
  /** Area. */
  area?: Maybe<Scalars['String']['output']>
  /** Booking Id. */
  bookingId?: Maybe<Scalars['String']['output']>
  /** Building. */
  building?: Maybe<Scalars['String']['output']>
  /** Cancellation Reason. */
  cancellationReason?: Maybe<Scalars['String']['output']>
  /** Company. */
  company?: Maybe<Scalars['String']['output']>
  /** Delivery Id. */
  deliveryId?: Maybe<Scalars['ObjectId']['output']>
  /** Delta End. */
  deltaEnd?: Maybe<Scalars['Float']['output']>
  /** Delta Start. */
  deltaStart?: Maybe<Scalars['Float']['output']>
  /** Done Date. */
  doneDate?: Maybe<Scalars['String']['output']>
  /** Driver Phone Number. */
  driverPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Duration Actual. */
  durationActual?: Maybe<Scalars['Float']['output']>
  /** Duration Scheduled. */
  durationScheduled?: Maybe<Scalars['Float']['output']>
  /** End Date. */
  endDate?: Maybe<Scalars['String']['output']>
  /** Entry Gate. */
  entryGate?: Maybe<Scalars['String']['output']>
  /** Id. */
  id?: Maybe<Scalars['String']['output']>
  /** Inspector. */
  inspector?: Maybe<Scalars['String']['output']>
  /** Installation Zone. */
  installationZone?: Maybe<Scalars['String']['output']>
  /** Is Inspection Required. */
  isInspectionRequired?: Maybe<Scalars['String']['output']>
  /** Is Late Request. */
  isLateRequest?: Maybe<Scalars['Boolean']['output']>
  /** Is Scheduling in Advance Prevented. */
  isSchedulingInAdvancePrevented?: Maybe<Scalars['Boolean']['output']>
  /** Is Unscheduled Requested. */
  isUnscheduledRequest?: Maybe<Scalars['Boolean']['output']>
  /** Latitude. */
  latitude?: Maybe<Scalars['Float']['output']>
  /** Level. */
  level?: Maybe<Scalars['String']['output']>
  /** Location Name. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Location Path. */
  locationPath?: Maybe<Scalars['String']['output']>
  /** Location Type. */
  locationType?: Maybe<Scalars['String']['output']>
  /** Longitude. */
  longitude?: Maybe<Scalars['Float']['output']>
  /** Materials List. */
  materials?: Maybe<Array<Maybe<IDeliveryMaterialReport>>>
  /** Note. */
  note?: Maybe<Scalars['String']['output']>
  /** Offloading Equipments List. */
  offloadingEquipments?: Maybe<Array<Maybe<IDeliveryEquipmentReport>>>
  /** On Site Contact Persons. */
  onSiteContactPersons?: Maybe<Array<Maybe<IOnSiteContactPerson>>>
  /** On Site Date. */
  onsiteDate?: Maybe<Scalars['String']['output']>
  /** Project Name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Requester full name. */
  requester?: Maybe<Scalars['String']['output']>
  /** Requester email. */
  requesterEmail?: Maybe<Scalars['String']['output']>
  /** Route. */
  route?: Maybe<Scalars['String']['output']>
  /** Secondary Location. */
  secondaryLocation?: Maybe<Scalars['String']['output']>
  /** Secondary Location Type. */
  secondaryLocationType?: Maybe<Scalars['String']['output']>
  /** Sitemap Urls. */
  sitemapUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Start Date. */
  startDate?: Maybe<Scalars['String']['output']>
  /** Status. */
  status?: Maybe<Scalars['String']['output']>
  /** Status Changes List. */
  statusChanges?: Maybe<Array<Maybe<IStatusChange>>>
  /** Thread Id. */
  threadId?: Maybe<Scalars['String']['output']>
  /** Truck Number. */
  truckNumber?: Maybe<Scalars['String']['output']>
  /** Truck Size. */
  truckSize?: Maybe<Scalars['String']['output']>
  /** Vendor. */
  vendor?: Maybe<Scalars['String']['output']>
  /** Vendor Emails. */
  vendorEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Zone. */
  zone?: Maybe<Scalars['String']['output']>
}

export enum DeliveryStatus {
  Canceled = 'Canceled',
  Changed = 'Changed',
  Deleted = 'Deleted',
  Delivering = 'Delivering',
  Denied = 'Denied',
  Done = 'Done',
  FailedInspection = 'FailedInspection',
  IncompleteDone = 'IncompleteDone',
  OnHold = 'OnHold',
  OnSite = 'OnSite',
  PassedInspection = 'PassedInspection',
  Paused = 'Paused',
  Requested = 'Requested',
  Scheduled = 'Scheduled',
}

export interface IDeliveryStatusChange {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delivery Id. */
  deliveryId?: Maybe<Scalars['ObjectId']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Status. */
  status?: Maybe<DeliveryStatus>
  /** Thread Id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryStatusChangeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryStatusChange>
}

export interface IDeliveryStatusChangeList {
  data: Array<IDeliveryStatusChange>
  page: IPageInfo
}

export interface IDeliveryTicketMaterial {
  /** Material category. */
  category?: Maybe<Scalars['String']['output']>
  /** Location. */
  location?: Maybe<Scalars['String']['output']>
  /** Material name. */
  name?: Maybe<Scalars['String']['output']>
  /** Note. */
  note?: Maybe<Scalars['String']['output']>
  /** Quantity. */
  quantity?: Maybe<Scalars['Float']['output']>
  /** Unit. */
  unit?: Maybe<Scalars['String']['output']>
}

export interface IDeliveryTicketResponse {
  /** Address. */
  address?: Maybe<Scalars['String']['output']>
  /** Area. */
  area?: Maybe<Scalars['String']['output']>
  /** Building. */
  building?: Maybe<Scalars['String']['output']>
  /** Custom Action Button Text. */
  customActionButtonText?: Maybe<Scalars['String']['output']>
  /** Custom Action Text. */
  customActionText?: Maybe<Scalars['String']['output']>
  /** Custom Action Url. */
  customActionUrl?: Maybe<Scalars['String']['output']>
  /** Date. */
  date?: Maybe<Scalars['String']['output']>
  /** Delivery Code. */
  deliveryCode?: Maybe<Scalars['String']['output']>
  displayNames?: Maybe<Array<Maybe<IDisplayName>>>
  /** Driver Phone Number. */
  driverPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Equipments. */
  equipments?: Maybe<Scalars['String']['output']>
  /** Gate. */
  gate?: Maybe<Scalars['String']['output']>
  /** Globe view Urls. */
  globeViewUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Inspector Company. */
  inspectorCompany?: Maybe<Scalars['String']['output']>
  /** Inspector Contacts. */
  inspectorContacts?: Maybe<Scalars['String']['output']>
  /** Inspector Name. */
  inspectorName?: Maybe<Scalars['String']['output']>
  /** Is Custom Action Included. */
  isCustomActionIncluded?: Maybe<Scalars['Boolean']['output']>
  /** Level. */
  level?: Maybe<Scalars['String']['output']>
  /** Materials. */
  materials?: Maybe<Array<Maybe<IDeliveryTicketMaterial>>>
  /** On Site Contacts. */
  onSiteContacts?: Maybe<Array<Maybe<IOnSiteContactResponse>>>
  /** Project Name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Requester Company. */
  requesterCompany?: Maybe<Scalars['String']['output']>
  /** Route. */
  route?: Maybe<Scalars['String']['output']>
  /** Sitemap Urls. */
  sitemapUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Status. */
  status?: Maybe<Scalars['String']['output']>
  /** Time Range. */
  timeRange?: Maybe<Scalars['String']['output']>
  /** Vehicle. */
  vehicle?: Maybe<Scalars['String']['output']>
  /** Zone. */
  zone?: Maybe<Scalars['String']['output']>
}

export enum DeliveryType {
  FromTo = 'FromTo',
  Regular = 'Regular',
}

export interface IDeliveryUnit {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is delivery unit deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Delivery unit name. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryUnitChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryUnit>
}

export interface IDeliveryUnitInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is delivery unit deleted. */
  isDeleted: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Delivery unit name. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryUnitList {
  data: Array<IDeliveryUnit>
  page: IPageInfo
}

export interface IDeliveryVehicleType {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is delivery vehicle type deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Delivery vehicle type name. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IDeliveryVehicleTypeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IDeliveryVehicleType>
}

export interface IDeliveryVehicleTypeInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is delivery vehicle type deleted. */
  isDeleted: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Delivery vehicle type name. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IDeliveryVehicleTypeList {
  data: Array<IDeliveryVehicleType>
  page: IPageInfo
}

export interface IDeviceInfo {
  /** Device locale. */
  locale?: Maybe<Scalars['String']['output']>
  /** Device token. */
  token?: Maybe<Scalars['String']['output']>
}

export interface IDisableLocationsAndClearControlsInput {
  /** Resource (location) ids to disable and clear. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
}

export interface IDisplayName {
  /** Key. */
  key?: Maybe<Scalars['String']['output']>
  /** Name. */
  name?: Maybe<Scalars['String']['output']>
}

export interface IEndClosureAction extends IPermitActionInterface {
  /** Action Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Location field Ids. */
  locationFieldIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Type. */
  type?: Maybe<PermitActionType>
}

export interface IEndClosureActionInput {
  /** Action Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Location field Ids. */
  locationFieldIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export interface IEntityRelationship {
  /** Entity id. */
  entityId: Scalars['ObjectId']['output']
  /** Relationship type. */
  relationshipType: RelationshipType
}

export interface IEntityTag {
  /** Tag color. */
  color?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Tag value. */
  value?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IEntityTagChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IEntityTag>
}

export interface IEntityTagInput {
  /** Tag color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** Tag value. */
  value?: InputMaybe<Scalars['String']['input']>
}

export interface IEntityTagList {
  data: Array<IEntityTag>
  page: IPageInfo
}

/** Effective GPS position of equipment, derived from linked StruxTag sensor. */
export interface IEquipmentPosition {
  /** When the position was last updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  /** GPS latitude. */
  latitude?: Maybe<Scalars['Float']['output']>
  /** GPS longitude. */
  longitude?: Maybe<Scalars['Float']['output']>
  /** Source of the position data. */
  source: PositionSource
}

export interface IFacet {
  /** Count */
  count?: Maybe<Scalars['Int']['output']>
  /** Facet key. */
  key?: Maybe<Scalars['String']['output']>
}

export enum FileCategory {
  Document = 'Document',
  Image = 'Image',
  Presentation = 'Presentation',
  Spreadsheet = 'Spreadsheet',
  Video = 'Video',
}

export interface IFileRequisites {
  /** Upload content type. */
  contentType?: Maybe<Scalars['String']['output']>
  /** File path in bucket. */
  filePath?: Maybe<Scalars['String']['output']>
  /** Url for file. */
  fileURL?: Maybe<Scalars['String']['output']>
  /** Url for upload file to bucket. */
  signedUrl?: Maybe<Scalars['String']['output']>
  /** The upload log entry associated with this file upload. */
  uploadLog?: Maybe<IUploadLog>
}

export enum FileType {
  Csv = 'CSV',
  Pdf = 'PDF',
}

export interface IFilterGroup {
  /** Filter set. */
  filterNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IFilterGroupInput {
  /** Filter set. */
  filterNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface IFilterInfo {
  canBeDisabled: Scalars['Boolean']['output']
  caption?: Maybe<Scalars['String']['output']>
  codeTypeIds: Array<Maybe<Scalars['String']['output']>>
  hiddenCodeIds: Array<Maybe<Scalars['String']['output']>>
  index: Scalars['Int']['output']
  isDisabled: Scalars['Boolean']['output']
  isRemovable: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  sourceType?: Maybe<FilterSourceType>
}

export interface IFilterInfoInput {
  canBeDisabled: Scalars['Boolean']['input']
  caption?: InputMaybe<Scalars['String']['input']>
  codeTypeIds: Array<InputMaybe<Scalars['String']['input']>>
  hiddenCodeIds: Array<InputMaybe<Scalars['String']['input']>>
  index: Scalars['Int']['input']
  isDisabled: Scalars['Boolean']['input']
  isRemovable: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  sourceType?: InputMaybe<FilterSourceType>
}

export enum FilterSourceType {
  ActivityCode = 'ActivityCode',
  ProjectMember = 'ProjectMember',
}

export enum FilterType {
  Building = 'building',
  Company = 'company',
  Gate = 'gate',
  Level = 'level',
  Name = 'name',
  Period = 'period',
  Zone = 'zone',
}

export interface IForecastCloudsParams {
  /** Cloudiness, %. */
  cloudiness: Scalars['Short']['output']
}

export interface IForecastConditionParams {
  /** Group of weather parameters (Rain, Snow, Extreme etc.). */
  condition: Scalars['String']['output']
  /** Weather condition within the group. */
  description: Scalars['String']['output']
  /** Weather icon id. */
  iconId: Scalars['String']['output']
  /** Weather condition id. */
  id: Scalars['Int']['output']
}

export interface IForecastMainParams {
  /** The temperature parameter accounts for the human perception of weather. */
  feelsLikeTemp: Scalars['Float']['output']
  /** Humidity, %. */
  humidity: Scalars['Short']['output']
  /** Maximal forecasted temperature. */
  maxTemperature: Scalars['Float']['output']
  /** Minimal forecasted temperature. */
  minTemperature: Scalars['Float']['output']
  /** Atmospheric pressure on the sea level by default, hPa. */
  pressure: Scalars['Int']['output']
  /** Atmospheric pressure on the ground level, hPa. */
  pressureOnGroundLevel: Scalars['Int']['output']
  /** Atmospheric pressure on the sea level, hPa. */
  pressureOnSeaLevel: Scalars['Int']['output']
  /** public parameter. */
  tempKf: Scalars['Float']['output']
  /** Temperature. */
  temperature: Scalars['Float']['output']
}

export interface IForecastPrecipitationParams {
  /** Precipitation volume for last 3 hours, mm. */
  volume: Scalars['Float']['output']
}

export interface IForecastSystemParams {
  /** Part of the day (n - night, d - day). */
  partOfDay: Scalars['String']['output']
}

export interface IForecastWindParams {
  /** Wind direction, degrees (meteorological). */
  degrees: Scalars['Int']['output']
  /** Wind gust. */
  gust: Scalars['Float']['output']
  /** Wind speed. */
  speed: Scalars['Float']['output']
}

export interface IFormAnalyticResponse {
  /** Basic Fields. */
  basicFields?: Maybe<Array<Maybe<IFormAnalyticsAdditionalInfo>>>
  /** Equipment. */
  equipment?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Inspections. */
  inspections?: Maybe<Array<Maybe<IFormAnalyticsInspection>>>
  /** Locations. */
  locations?: Maybe<IFormAnalyticsCanonicalLocation>
  /** Materials. */
  materials?: Maybe<Array<Maybe<IFormAnalyticsMaterial>>>
  /** Status. */
  status?: Maybe<Scalars['String']['output']>
  /** Status Change List. */
  statusChanges?: Maybe<Array<Maybe<IFormAnalyticsStatusChange>>>
  /** Workflow Fields. */
  workflowFields?: Maybe<IFormAnalyticsWorkflowFields>
}

export interface IFormAnalyticsAdditionalInfo {
  /** Name. */
  name?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IFormAnalyticsCanonicalLocation {
  /** Latitude. */
  latitude?: Maybe<Scalars['Float']['output']>
  /** Location Name. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Location Path. */
  locationPath?: Maybe<Scalars['String']['output']>
  /** Location Type. */
  locationType?: Maybe<Scalars['String']['output']>
  /** Longitude. */
  longitude?: Maybe<Scalars['Float']['output']>
}

export interface IFormAnalyticsInspection {
  /** Date. */
  date?: Maybe<Scalars['String']['output']>
  /** Inspection Changes. */
  inspectionChanges?: Maybe<Array<Maybe<IFormAnalyticsInspectionChange>>>
}

export interface IFormAnalyticsInspectionChange {
  /** Number Of Checklist Positive. */
  numberOfChecklistPositive?: Maybe<Scalars['Int']['output']>
  /** Number Of Checklist Questions. */
  numberOfChecklistQuestions?: Maybe<Scalars['Int']['output']>
  /** User. */
  user?: Maybe<Scalars['String']['output']>
}

export interface IFormAnalyticsMaterial {
  /** Material Category. */
  materialCategory?: Maybe<Scalars['String']['output']>
  /** Material Name. */
  materialName?: Maybe<Scalars['String']['output']>
}

export interface IFormAnalyticsStatusChange {
  /** Date. */
  date?: Maybe<Scalars['String']['output']>
  /** Email. */
  email?: Maybe<Scalars['String']['output']>
  /** Status. */
  status?: Maybe<Scalars['String']['output']>
  /** User Company. */
  userCompany?: Maybe<Scalars['String']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['String']['output']>
  /** User Name. */
  userName?: Maybe<Scalars['String']['output']>
}

export interface IFormAnalyticsWorkflowFields {
  /** Assignee. */
  assignee?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assignee Email. */
  assigneeEmail?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Company. */
  company?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** EndDate. */
  endDate?: Maybe<Scalars['String']['output']>
  /** Form Code. */
  formCode?: Maybe<Scalars['String']['output']>
  /** Form ID. */
  formId?: Maybe<Scalars['String']['output']>
  /** Form Type. */
  formType?: Maybe<Scalars['String']['output']>
  /** InspectionFrequencyPeriod. */
  inspectionFrequencyPeriod?: Maybe<Scalars['String']['output']>
  /** InspectionFrequencyValue. */
  inspectionFrequencyValue?: Maybe<Scalars['String']['output']>
  /** Permit Title. */
  permitTitle?: Maybe<Scalars['String']['output']>
  /** Project Name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Requester. */
  requester?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Requester Email. */
  requesterEmail?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Start Date. */
  startDate?: Maybe<Scalars['String']['output']>
  /** Tenant Name. */
  tenantName?: Maybe<Scalars['String']['output']>
  /** Timezone. */
  timezone?: Maybe<Scalars['String']['output']>
  /** Workflow Category. */
  workflowCategory?: Maybe<Scalars['String']['output']>
}

export interface IFormCategories {
  /** Activity form category. */
  activity?: Maybe<Scalars['Boolean']['output']>
  /** Delivery form category. */
  delivery?: Maybe<Scalars['Boolean']['output']>
  /** Environmental form category. */
  environmental?: Maybe<Scalars['Boolean']['output']>
  /** Equipment form category. */
  equipment?: Maybe<Scalars['Boolean']['output']>
  /** Material form category. */
  material?: Maybe<Scalars['Boolean']['output']>
  /** Quality form category. */
  quality?: Maybe<Scalars['Boolean']['output']>
  /** Report form category. */
  report?: Maybe<Scalars['Boolean']['output']>
  /** Safety form category. */
  safety?: Maybe<Scalars['Boolean']['output']>
  /** Site communication form category. */
  site_communication?: Maybe<Scalars['Boolean']['output']>
}

export interface IFormCategory {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** The internal name of the record. */
  internalName: Scalars['String']['output']
  /** Determines whether the category is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** The label of the record. */
  label: Scalars['String']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The optional Project Id associated with this form category. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IFormCategoryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IFormCategory>
}

export interface IFormCategoryInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** The internal name of the record. */
  internalName?: InputMaybe<Scalars['String']['input']>
  /** The label of the record. */
  label: Scalars['String']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The Project Id associated with this form category. This is a required field to prevent adding new categories at the tenant level. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IFormCategoryList {
  data: Array<IFormCategory>
  page: IPageInfo
}

export interface IFormMaterial {
  /** Material Id. */
  materialId: Scalars['ObjectId']['output']
  /** Procurement ID. */
  procurementId?: Maybe<Scalars['String']['output']>
}

export interface IFormMaterialInput {
  /** Material Id. */
  materialId: Scalars['ObjectId']['input']
  /** Procurement ID. */
  procurementId?: InputMaybe<Scalars['String']['input']>
}

export interface IFormMaterialResource {
  /** Resource material Location Id. */
  locationId: Scalars['ObjectId']['output']
}

export interface IFormMaterialResourceInput {
  /** Resource material Location Id. */
  locationId: Scalars['ObjectId']['input']
}

export interface IGate extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IGateInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IGenerateReportCommandInput {
  /** Additional recipient Ids. */
  additionalRecipientIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Report additional data. */
  dataJSON?: InputMaybe<Scalars['String']['input']>
  /** Report finish date. */
  dateFrom?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Report start date. */
  dateTo?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Files. */
  files?: InputMaybe<Array<InputMaybe<IReportFileInput>>>
  /** Is full time report. */
  isFullTime?: InputMaybe<Scalars['Boolean']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** QR code link. */
  qRCodeLink?: InputMaybe<Scalars['String']['input']>
  /** Report will be sent via email if set to true. */
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>
  /** Report template id. */
  templateId: Scalars['String']['input']
  /** Timezone id. */
  timezoneId?: InputMaybe<Scalars['String']['input']>
  /** Report title. */
  title?: InputMaybe<Scalars['String']['input']>
}

export interface IGenerateSignedUploadUrlInput {
  /** File name. */
  fileName: Scalars['String']['input']
  /** A value indicating whether the generated upload log should be hidden. */
  isLogHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Determines whether the file is public. */
  isPublic: Scalars['Boolean']['input']
  /** IDs of the locations associated with this upload. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Name of the location associated with this upload. */
  locationName?: InputMaybe<Scalars['String']['input']>
  /** Type of the location associated with this upload. */
  locationType?: InputMaybe<LocationType>
  /** Whether to create an upload log entry for this upload. */
  logUpload?: InputMaybe<Scalars['Boolean']['input']>
  /** Project Id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Code or identifier of the source entity. */
  sourceEntityCode?: InputMaybe<Scalars['String']['input']>
  /** ID of the source entity related to this upload. */
  sourceEntityId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Type of the source entity (e.g., Delivery, Form). */
  sourceEntityType?: InputMaybe<SourceEntityType>
  /** Display name of the source entity type. */
  sourceEntityTypeName?: InputMaybe<Scalars['String']['input']>
  /** Uploading type. */
  uploadingType: UploadingType
}

export interface IGeoJson2DGeographicCoordinates {
  /** Latitude. */
  latitude: Scalars['Float']['output']
  /** Longitude. */
  longitude: Scalars['Float']['output']
}

export interface IGeoJson2DGeographicCoordinatesInput {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export interface IGlobeView {
  /** Altitude. */
  altitude?: Maybe<Scalars['Float']['output']>
  /** Bearing. */
  bearing?: Maybe<Scalars['Float']['output']>
  /** Earth coordinates of bounding box. */
  bounds?: Maybe<IAddressBounds>
  /** Earth coordinates of the center point. */
  center?: Maybe<ILatLng>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Filled image. */
  filledImage?: Maybe<Scalars['String']['output']>
  /** Earth coordinates of the corner points. */
  geoCorners?: Maybe<Array<Maybe<IGeoJson2DGeographicCoordinates>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is orientation locked. */
  isOrientationLocked?: Maybe<Scalars['Boolean']['output']>
  items?: Maybe<Array<Maybe<IGlobeViewSpecificItemData>>>
  /** Items filled image. */
  itemsFilledImage?: Maybe<Scalars['String']['output']>
  /** Map files. */
  mapFiles?: Maybe<Array<Maybe<IGlobeViewMapFile>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Pitch. */
  pitch?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Style. */
  style?: Maybe<IGlobeViewStyle>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Zoom. */
  zoom?: Maybe<Scalars['Float']['output']>
}

export interface IGlobeViewChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IGlobeView>
}

export interface IGlobeViewCircle extends IGlobeViewItemShapeInterface {
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface IGlobeViewCircleInput {
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface IGlobeViewInput {
  /** Altitude. */
  altitude?: InputMaybe<Scalars['Float']['input']>
  /** Bearing. */
  bearing?: InputMaybe<Scalars['Float']['input']>
  /** Earth coordinates of bounding box. */
  bounds?: InputMaybe<IAddressBoundsInput>
  /** Earth coordinates of the center point. */
  center?: InputMaybe<ILatLngInput>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Filled image. */
  filledImage?: InputMaybe<Scalars['String']['input']>
  /** Earth coordinates of the corner points. */
  geoCorners?: InputMaybe<
    Array<InputMaybe<IGeoJson2DGeographicCoordinatesInput>>
  >
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is orientation locked. */
  isOrientationLocked?: InputMaybe<Scalars['Boolean']['input']>
  /** Items filled image. */
  itemsFilledImage?: InputMaybe<Scalars['String']['input']>
  /** Map files. */
  mapFiles?: InputMaybe<Array<InputMaybe<IGlobeViewMapFileInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Pitch. */
  pitch?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Style. */
  style?: InputMaybe<IGlobeViewStyleInput>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Zoom. */
  zoom?: InputMaybe<Scalars['Float']['input']>
}

export type IGlobeViewItemShapeInterface = {
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface IGlobeViewList {
  data: Array<IGlobeView>
  page: IPageInfo
}

export interface IGlobeViewMapFile {
  /** Entity Id. */
  entityId: Scalars['ObjectId']['output']
  /** Entity Type. */
  entityType: MapFileType
}

export interface IGlobeViewMapFileInput {
  /** Entity Id. */
  entityId: Scalars['ObjectId']['input']
  /** Entity Type. */
  entityType: MapFileType
}

export enum GlobeViewMapType {
  Satellite = 'Satellite',
  Street = 'Street',
}

export interface IGlobeViewPin {
  /** IsHidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
}

export interface IGlobeViewPinInput {
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export interface IGlobeViewPolyline extends IGlobeViewItemShapeInterface {
  /** Arrow position. */
  arrowPosition?: Maybe<SitemapLineArrowPosition>
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is closed. */
  isClosed: Scalars['Boolean']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface IGlobeViewPolylineInput {
  /** Arrow position. */
  arrowPosition?: InputMaybe<SitemapLineArrowPosition>
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** IsClosed. */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface IGlobeViewRectangle extends IGlobeViewItemShapeInterface {
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface IGlobeViewRectangleInput {
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface IGlobeViewSpecificItemData {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Globe view Id. */
  globeViewId?: Maybe<Scalars['ObjectId']['output']>
  /** Icon. */
  icon?: Maybe<IGlobeViewPin>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Label. */
  label?: Maybe<IGlobeViewTextBox>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Shape. */
  shape?: Maybe<IGlobeViewItemShapeInterface>
  /** Sitemap item Id. */
  sitemapItemId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IGlobeViewSpecificItemDataChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IGlobeViewSpecificItemData>
}

export interface IGlobeViewSpecificItemDataCircleInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Globe view Id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Icon. */
  icon?: InputMaybe<IGlobeViewPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<IGlobeViewTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<IGlobeViewCircleInput>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IGlobeViewSpecificItemDataPolylineInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Globe view Id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Icon. */
  icon?: InputMaybe<IGlobeViewPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<IGlobeViewTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<IGlobeViewPolylineInput>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IGlobeViewSpecificItemDataRectangleInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Globe view Id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Icon. */
  icon?: InputMaybe<IGlobeViewPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<IGlobeViewTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<IGlobeViewRectangleInput>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IGlobeViewStyle {
  /** Is label overlap enabled. */
  isLabelOverlapEnabled: Scalars['Boolean']['output']
  /** Is terrain enabled. */
  isTerrainEnabled: Scalars['Boolean']['output']
  /** Is 3D enabled. */
  isThreeDEnabled: Scalars['Boolean']['output']
  /** Is traffic enabled. */
  isTrafficEnabled: Scalars['Boolean']['output']
  /** Is zoom scaling enabled. */
  isZoomScalingEnabled: Scalars['Boolean']['output']
  /** Map type. */
  mapType: GlobeViewMapType
  /** Should hide labels. */
  shouldHideLabels: Scalars['Boolean']['output']
  /** Should hide workflow pin labels. */
  shouldHideWorkflowPinLabels: Scalars['Boolean']['output']
}

export interface IGlobeViewStyleInput {
  /** Is label overlap enabled. */
  isLabelOverlapEnabled: Scalars['Boolean']['input']
  /** Is terrain enabled. */
  isTerrainEnabled: Scalars['Boolean']['input']
  /** Is 3D enabled. */
  isThreeDEnabled: Scalars['Boolean']['input']
  /** Is traffic enabled. */
  isTrafficEnabled: Scalars['Boolean']['input']
  /** Is zoom scaling enabled. */
  isZoomScalingEnabled: Scalars['Boolean']['input']
  /** Map type. */
  mapType: GlobeViewMapType
  /** Should hide labels. */
  shouldHideLabels: Scalars['Boolean']['input']
  /** Should hide workflow pin labels. */
  shouldHideWorkflowPinLabels: Scalars['Boolean']['input']
}

export interface IGlobeViewTextBox {
  /** Color. */
  color?: Maybe<Scalars['String']['output']>
  /** Font size. */
  fontSize: Scalars['Int']['output']
  /** Is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Is text box displayed. */
  isTextBoxDisplayed: Scalars['Boolean']['output']
}

export interface IGlobeViewTextBoxInput {
  /** Color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** Font size. */
  fontSize: Scalars['Int']['input']
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Is text box displayed. */
  isTextBoxDisplayed: Scalars['Boolean']['input']
}

export interface IGlobesSetupSettings {
  /** Last edited globe id. */
  lastEditedGlobeId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IGlobesSetupSettingsInput {
  /** Last edited globe id. */
  lastEditedGlobeId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IHierarchyConfigurations {
  /** Order of hierarchy bands in hierarchy. */
  bandsHierarchyOrder?: Maybe<Array<Maybe<FilterType>>>
  /** Container updates accessibility. */
  canGCUpdateActivity?: Maybe<Scalars['Boolean']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Hierarchy modes in specific views. */
  viewsToHierarchyModes?: Maybe<IViewTypes>
}

export interface IHierarchyConfigurationsInput {
  /** Order of hierarchy bands in hierarchy. */
  bandsHierarchyOrder?: InputMaybe<Array<InputMaybe<FilterType>>>
  /** Container updates accessibility. */
  canGCUpdateActivity?: InputMaybe<Scalars['Boolean']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Hierarchy modes in specific views. */
  viewsToHierarchyModes?: InputMaybe<IViewTypesInput>
}

export interface IHierarchyConfigurationsList {
  data: Array<IHierarchyConfigurations>
  page: IPageInfo
}

export enum HierarchyModes {
  Hierarchy = 'HIERARCHY',
  Wbs = 'WBS',
}

export interface IHistoryItem {
  /** Who updated the schedule. */
  by?: Maybe<IUpdaterInfo>
  /** Schedule file name. */
  fileName?: Maybe<Scalars['String']['output']>
  /** Materials upload id. */
  materialsUploadId?: Maybe<Scalars['ObjectId']['output']>
  schedule?: Maybe<ISchedule>
  /** Schedule id. */
  scheduleId?: Maybe<Scalars['ObjectId']['output']>
  /** Total entities count. */
  totalCount?: Maybe<Scalars['Int']['output']>
  /** When upload was done. */
  updatedAt: Scalars['MillisecondsDate']['output']
}

export interface IHistoryItemInput {
  /** Who updated the schedule. */
  by: IUpdaterInfoInput
  /** Schedule file name. */
  fileName?: InputMaybe<Scalars['String']['input']>
  /** Materials upload id. */
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Schedule id. */
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Total entities count. */
  totalCount?: InputMaybe<Scalars['Int']['input']>
  /** When upload was done. */
  updatedAt: Scalars['MillisecondsDate']['input']
}

export interface IImportError {
  message: Scalars['String']['output']
  propertyName?: Maybe<Scalars['String']['output']>
  row: Scalars['Int']['output']
  value?: Maybe<Scalars['String']['output']>
}

/** Configuration for importing and exporting relational property values. */
export interface IImportExportConfiguration {
  /** The type of entity this property references (e.g., 'user', 'company'). */
  entityType?: Maybe<Scalars['String']['output']>
  /** Field on the related entity to resolve during export (e.g., 'email', 'name'). */
  exportField?: Maybe<Scalars['String']['output']>
  /** Field on the related entity to match against during import (e.g., 'email', 'name'). */
  importField?: Maybe<Scalars['String']['output']>
}

/** Input for import/export configuration of relational properties. */
export interface IImportExportConfigurationInput {
  /** The type of entity this property references (e.g., 'user', 'company'). */
  entityType: Scalars['String']['input']
  /** Field on the related entity to resolve during export (e.g., 'email', 'name'). */
  exportField: Scalars['String']['input']
  /** Field on the related entity to match against during import (e.g., 'email', 'name'). */
  importField: Scalars['String']['input']
}

export interface IImportResult {
  created: Scalars['Int']['output']
  errors: Array<IImportError>
  failed: Scalars['Int']['output']
  skipped: Scalars['Int']['output']
  updated: Scalars['Int']['output']
}

export interface IInspectionOptions {
  /** Inspection deadline time. */
  deadlineTime?: Maybe<Scalars['Long']['output']>
  /** Inspection frequency number. */
  inspectionFrequency?: Maybe<Scalars['Int']['output']>
  /** Inspection frequency type. */
  inspectionFrequencyType?: Maybe<CalendricalType>
  /** Selected days to repeat. */
  selectedDaysToRepeat?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

export interface IInspectionOptionsInput {
  /** Inspection deadline time. */
  deadlineTime?: InputMaybe<Scalars['Long']['input']>
  /** Inspection frequency number. */
  inspectionFrequency?: InputMaybe<Scalars['Int']['input']>
  /** Inspection frequency type. */
  inspectionFrequencyType?: InputMaybe<CalendricalType>
  /** Selected days to repeat. */
  selectedDaysToRepeat?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export interface IInstructions {
  /** List. */
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** List type. */
  listType?: Maybe<Scalars['String']['output']>
}

export interface IInstructionsInput {
  /** List. */
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** List type. */
  listType?: InputMaybe<Scalars['String']['input']>
}

export interface IIntegration extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IIntegrationInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IIntegrationWorkflowTypeConfigInput {
  /** List of field mappings from Procore DailyLog fields to corresponding workflow type fields */
  fieldMappings?: InputMaybe<Array<InputMaybe<IDailyLogFieldMappingInput>>>
  /** Initial type identifier that persists across all permit type versions. */
  initialType?: InputMaybe<Scalars['String']['input']>
  /** Workflow type Id */
  typeId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IInteriorDoor extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Max height. */
  maxHeight?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Max weight. */
  maxWeight?: Maybe<Scalars['Float']['output']>
  /** Max width. */
  maxWidth?: Maybe<Scalars['Float']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IInteriorDoorInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Max height. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Max weight. */
  maxWeight?: InputMaybe<Scalars['Float']['input']>
  /** Max width. */
  maxWidth?: InputMaybe<Scalars['Float']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IInteriorPath extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Max height. */
  maxHeight?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Max weight. */
  maxWeight?: Maybe<Scalars['Float']['output']>
  /** Max width. */
  maxWidth?: Maybe<Scalars['Float']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IInteriorPathInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Max height. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Max weight. */
  maxWeight?: InputMaybe<Scalars['Float']['input']>
  /** Max width. */
  maxWidth?: InputMaybe<Scalars['Float']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export enum InviteStatus {
  Accepted = 'Accepted',
  NotInvited = 'Not_Invited',
  Pending = 'Pending',
}

export interface IJobsiteConfiguration {
  /** Widget configuration stored as JSON string. */
  configuration?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IJobsiteConfigurationByCode {
  /** Widget configuration stored as JSON string. */
  configuration?: Maybe<Scalars['String']['output']>
  /** When the configuration was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The configuration ID. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** The project ID. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** When the configuration was last updated. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Configuration version number. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IJobsiteConfigurationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IJobsiteConfiguration>
}

export interface IJobsiteConfigurationInput {
  /** Widget configuration stored as JSON string. */
  configuration?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ILastMobileActivityFilter {
  /** Filter type. */
  filterType: Scalars['String']['output']
  /** Values. */
  values: Array<Maybe<Scalars['String']['output']>>
}

export interface ILastMobileActivityFilterInput {
  /** Filter type. */
  filterType: Scalars['String']['input']
  /** Values. */
  values: Array<InputMaybe<Scalars['String']['input']>>
}

export interface ILastUpdatedItem {
  /** Updated page name. */
  pageName: Scalars['String']['output']
  /** Uploaded schedule info. */
  updateInfo: IHistoryItem
}

export interface ILastUpdatedItemInput {
  /** Updated page name. */
  pageName: Scalars['String']['input']
  /** Uploaded schedule info. */
  updateInfo: IHistoryItemInput
}

export interface ILatLng {
  /** Latitude. */
  lat: Scalars['Float']['output']
  /** Longitude. */
  lng: Scalars['Float']['output']
}

export interface ILatLngInput {
  /** Latitude. */
  lat: Scalars['Float']['input']
  /** Longitude. */
  lng: Scalars['Float']['input']
}

export interface ILevel extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Is name implicitly set. */
  isNameImplicit?: Maybe<Scalars['Boolean']['output']>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface ILevelInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is name implicitly set. */
  isNameImplicit?: InputMaybe<Scalars['Boolean']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ILevelsClosure {
  /** Date interval. */
  interval?: Maybe<IDateInterval>
  /** Levels. */
  levels?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface ILevelsClosureInput {
  /** Date interval. */
  interval?: InputMaybe<IDateIntervalInput>
  /** Levels. */
  levels?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
}

/** Result of a resource link operation. */
export interface ILinkResult {
  /** Error message if the operation failed. */
  error?: Maybe<Scalars['String']['output']>
  /** Source entity ID. */
  sourceId?: Maybe<Scalars['ObjectId']['output']>
  /** Whether the link operation succeeded. */
  success: Scalars['Boolean']['output']
  /** Target entity ID. */
  targetId?: Maybe<Scalars['ObjectId']['output']>
}

export interface ILocation extends ILocationBase {
  /** Accessible levels. */
  accessibleLevels?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Ground level. */
  groundLevel?: Maybe<Scalars['String']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Is ground index set to 0. */
  isGroundIndexZero?: Maybe<Scalars['Boolean']['output']>
  /** Is linked implicitly set. */
  isLinked: Scalars['Boolean']['output']
  /** Is name implicitly set. */
  isNameImplicit?: Maybe<Scalars['Boolean']['output']>
  /** Level base name. */
  levelBaseName?: Maybe<Scalars['String']['output']>
  /** Levels closures. */
  levelsClosures?: Maybe<Array<Maybe<ILevelsClosure>>>
  /** Levels order. */
  levelsOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Max height. */
  maxHeight?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Max weight. */
  maxWeight?: Maybe<Scalars['Float']['output']>
  /** Max width. */
  maxWidth?: Maybe<Scalars['Float']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** Skip level index template. */
  skipLevelIndexTemplate?: Maybe<Scalars['String']['output']>
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export type ILocationBase = {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Location parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface ILocationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ILocationBase>
}

export interface ILocationClosureInterval {
  endDate: Scalars['Long']['output']
  isDaily?: Maybe<Scalars['Boolean']['output']>
  startDate: Scalars['Long']['output']
}

export interface ILocationClosureIntervalInput {
  endDate: Scalars['Long']['input']
  isDaily?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['Long']['input']
}

export interface ILocationField {
  /** Location name */
  locationName?: Maybe<Scalars['String']['output']>
  /** Location url */
  locationUrl?: Maybe<Scalars['String']['output']>
}

export interface ILocationInput {
  /** Accessible levels. */
  accessibleLevels?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Ground level. */
  groundLevel?: InputMaybe<Scalars['String']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is ground index set to 0. */
  isGroundIndexZero?: InputMaybe<Scalars['Boolean']['input']>
  /** Is linked implicitly set. */
  isLinked?: InputMaybe<Scalars['Boolean']['input']>
  /** Is name implicitly set. */
  isNameImplicit?: InputMaybe<Scalars['Boolean']['input']>
  /** Level base name. */
  levelBaseName?: InputMaybe<Scalars['String']['input']>
  /** Levels closures. */
  levelsClosures?: InputMaybe<Array<InputMaybe<ILevelsClosureInput>>>
  /** Levels order. */
  levelsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Max height. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Max weight. */
  maxWeight?: InputMaybe<Scalars['Float']['input']>
  /** Max width. */
  maxWidth?: InputMaybe<Scalars['Float']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Skip level index template. */
  skipLevelIndexTemplate?: InputMaybe<Scalars['String']['input']>
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ILocationList {
  data: Array<ILocationBase>
  page: IPageInfo
}

export interface ILocationPermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Values. */
  locationValues?: Maybe<Array<Maybe<ISiteLocation>>>
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface ILocationPermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
}

export interface ILocationRestrictionCheckResult {
  /** The permits that already overlap in this time period. */
  conflictingPermits?: Maybe<Array<Maybe<ISitePermit>>>
  /** Whether overlapping with existing permits is allowed. */
  isOverlappingAllowed: Scalars['Boolean']['output']
  /** The location ID that was checked. */
  locationId: Scalars['ObjectId']['output']
  /** List of violated restrictions with details. */
  violatedRestrictions: Array<Maybe<Scalars['String']['output']>>
}

export enum LocationType {
  Area = 'Area',
  Building = 'Building',
  Gate = 'Gate',
  Integration = 'Integration',
  InteriorDoor = 'InteriorDoor',
  InteriorPath = 'InteriorPath',
  Level = 'Level',
  Location = 'Location',
  LogisticsObject = 'LogisticsObject',
  Material = 'Material',
  OffloadingEquipment = 'OffloadingEquipment',
  ProjectLocation = 'ProjectLocation',
  Route = 'Route',
  Sensor = 'Sensor',
  Staging = 'Staging',
  VerticalObject = 'VerticalObject',
  Zone = 'Zone',
}

/** Workflow restrictions for a location. */
export interface ILocationWorkflowRestrictions {
  /** Maximum booking duration restrictions for workflows at this location. */
  maxBookingDurations?: Maybe<Array<Maybe<IWorkflowLocationRestriction>>>
  /** Maximum overlapping booking restrictions for workflows at this location. */
  maxOverlappingBookings?: Maybe<Array<Maybe<IWorkflowLocationRestriction>>>
}

export interface ILogisticsConfigurations {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ILogisticsConfigurationsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ILogisticsConfigurations>
}

export interface ILogisticsConfigurationsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ILogisticsConfigurationsList {
  data: Array<ILogisticsConfigurations>
  page: IPageInfo
}

export interface ILogisticsObject extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface ILogisticsObjectInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export enum MapFileType {
  RemoteTileset = 'RemoteTileset',
  Sitemap = 'Sitemap',
  Tileset = 'Tileset',
}

export interface IMapboxTilesetData {
  /** Center. */
  center: Array<Scalars['Float']['output']>
  /** FileSize. */
  fileSize: Scalars['Long']['output']
  /** Id. */
  id?: Maybe<Scalars['String']['output']>
  /** Name. */
  name?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface IMarkup {
  /** Arrowhead at end. */
  arrowheadEnd?: Maybe<Scalars['String']['output']>
  /** Arrowhead at start. */
  arrowheadStart?: Maybe<Scalars['String']['output']>
  /** Bold text. */
  bold?: Maybe<Scalars['Boolean']['output']>
  /** Text box width in px (null = auto). */
  boxWidth?: Maybe<Scalars['Float']['output']>
  /** Color. */
  color?: Maybe<Scalars['String']['output']>
  /** Coordinates. */
  coordinates?: Maybe<Array<Maybe<IGeoJson2DGeographicCoordinates>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill style. */
  fillStyle?: Maybe<Scalars['String']['output']>
  /** Font size. */
  fontSize?: Maybe<Scalars['Float']['output']>
  /** GeoJSON geometry type. */
  geometryType?: Maybe<Scalars['String']['output']>
  /** Globe view id. */
  globeViewId?: Maybe<Scalars['ObjectId']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether the markup is soft-deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Italic text. */
  italic?: Maybe<Scalars['Boolean']['output']>
  /** Markup kind. */
  kind?: Maybe<Scalars['String']['output']>
  /** Line sub-type. */
  lineType?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Opacity. */
  opacity?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Rotation in degrees (null = 0). */
  rotation?: Maybe<Scalars['Float']['output']>
  /** Shape sub-type. */
  shapeKind?: Maybe<Scalars['String']['output']>
  /** Workflow (site permit) id. */
  sitePermitId?: Maybe<Scalars['ObjectId']['output']>
  /** Stroke style. */
  strokeStyle?: Maybe<Scalars['String']['output']>
  /** Stroke width. */
  strokeWidth?: Maybe<Scalars['Float']['output']>
  /** Text. */
  text?: Maybe<Scalars['String']['output']>
  /** Text alignment. */
  textAlign?: Maybe<Scalars['String']['output']>
  /** Underlined text. */
  underline?: Maybe<Scalars['Boolean']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IMarkupChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IMarkup>
}

export interface IMarkupInput {
  /** Arrowhead at end. */
  arrowheadEnd?: InputMaybe<Scalars['String']['input']>
  /** Arrowhead at start. */
  arrowheadStart?: InputMaybe<Scalars['String']['input']>
  /** Bold text. */
  bold?: InputMaybe<Scalars['Boolean']['input']>
  /** Text box width in px (null = auto). */
  boxWidth?: InputMaybe<Scalars['Float']['input']>
  /** Color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** Coordinates. */
  coordinates?: InputMaybe<
    Array<InputMaybe<IGeoJson2DGeographicCoordinatesInput>>
  >
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill style. */
  fillStyle?: InputMaybe<Scalars['String']['input']>
  /** Font size. */
  fontSize?: InputMaybe<Scalars['Float']['input']>
  /** GeoJSON geometry type. */
  geometryType?: InputMaybe<Scalars['String']['input']>
  /** Globe view id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Italic text. */
  italic?: InputMaybe<Scalars['Boolean']['input']>
  /** Markup kind. */
  kind?: InputMaybe<Scalars['String']['input']>
  /** Line sub-type. */
  lineType?: InputMaybe<Scalars['String']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Opacity. */
  opacity?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Rotation in degrees (null = 0). */
  rotation?: InputMaybe<Scalars['Float']['input']>
  /** Shape sub-type. */
  shapeKind?: InputMaybe<Scalars['String']['input']>
  /** Workflow (site permit) id. */
  sitePermitId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Stroke style. */
  strokeStyle?: InputMaybe<Scalars['String']['input']>
  /** Stroke width. */
  strokeWidth?: InputMaybe<Scalars['Float']['input']>
  /** Text. */
  text?: InputMaybe<Scalars['String']['input']>
  /** Text alignment. */
  textAlign?: InputMaybe<Scalars['String']['input']>
  /** Underlined text. */
  underline?: InputMaybe<Scalars['Boolean']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IMarkupList {
  data: Array<IMarkup>
  page: IPageInfo
}

export interface IMaterial extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Rollup values aggregated from linked workflows. */
  rollups?: Maybe<Scalars['JSONObject']['output']>
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IMaterialCategoryFieldDefinition {
  /** Name of definition. */
  name: Scalars['String']['output']
  /** Type of definition. */
  type: Scalars['String']['output']
}

export interface IMaterialConfiguration {
  /** Material list columns configuration. */
  columnsConfig?: Maybe<Array<Maybe<IColumnConfiguration>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Saved groups. */
  savedGroups?: Maybe<Array<Maybe<IFilterGroup>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IMaterialConfigurationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IMaterialConfiguration>
}

export interface IMaterialConfigurationInput {
  /** Material list columns configuration. */
  columnsConfig?: InputMaybe<Array<InputMaybe<IColumnConfigurationInput>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Saved groups. */
  savedGroups?: InputMaybe<Array<InputMaybe<IFilterGroupInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IMaterialFormField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Values. */
  materialValues?: Maybe<Array<Maybe<IFormMaterial>>>
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IMaterialFormFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IFormMaterialInput>>>
}

export interface IMaterialInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IMaterialProcurementData {
  /** Delivery location id. */
  deliveryLocationId?: Maybe<Scalars['ObjectId']['output']>
  /** Description. */
  description?: Maybe<Scalars['String']['output']>
  /** Install location id. */
  installLocationId?: Maybe<Scalars['ObjectId']['output']>
  /** Planned quantity. */
  plannedQuantity?: Maybe<Scalars['Float']['output']>
  /** Procurement Id. */
  procurementId?: Maybe<Scalars['String']['output']>
}

export interface IMaterialProcurementDataInput {
  /** Delivery location id. */
  deliveryLocationId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Description. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Install location id. */
  installLocationId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Planned quantity. */
  plannedQuantity?: InputMaybe<Scalars['Float']['input']>
  /** Procurement Id. */
  procurementId?: InputMaybe<Scalars['String']['input']>
}

export interface IMaterialResourceFormField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Values. */
  materialResourceValues?: Maybe<Array<Maybe<IFormMaterialResource>>>
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IMaterialResourceFormFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IFormMaterialResourceInput>>>
}

export interface IMaturixCast {
  /** Cast Id. */
  castId?: Maybe<Scalars['String']['output']>
  /** Cast name. */
  castName?: Maybe<Scalars['String']['output']>
  /** Maturix project Id. */
  maturixProjectId?: Maybe<Scalars['String']['output']>
  /** Monitorings. */
  monitorings?: Maybe<Array<Maybe<IMonitoringLatestData>>>
  /** Maturix project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Cast status. */
  status?: Maybe<Scalars['String']['output']>
}

export interface IMaturixMonitoringData {
  /** Maturity. */
  maturity?: Maybe<Scalars['Float']['output']>
  /** Strength. */
  strength?: Maybe<Scalars['Float']['output']>
  /** strength unit. */
  strengthUnit?: Maybe<Scalars['String']['output']>
  /** Temperature. */
  temperature?: Maybe<Scalars['Float']['output']>
  /** Temperature unit. */
  temperatureUnit?: Maybe<Scalars['String']['output']>
  /** Timestamp. */
  timestamp?: Maybe<Scalars['Long']['output']>
}

export interface IMaturixMonitoringDataResponse {
  /** Data. */
  data?: Maybe<Array<Maybe<IMaturixMonitoringData>>>
  /** Monitoring info. */
  monitoring?: Maybe<IMonitoringInfo>
}

export interface IMaturixProject {
  /** End time. */
  endTime?: Maybe<Scalars['Long']['output']>
  /** Project Id. */
  id?: Maybe<Scalars['String']['output']>
  /** Project description. */
  projectDescription?: Maybe<Scalars['String']['output']>
  /** Project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Start time. */
  startTime?: Maybe<Scalars['Long']['output']>
  /** Project status. */
  status?: Maybe<Scalars['String']['output']>
}

export interface IMeasure {
  /** Units. */
  units?: Maybe<Scalars['String']['output']>
  /** Value. */
  value?: Maybe<Scalars['String']['output']>
}

export interface IMeasureInput {
  /** Units. */
  units?: InputMaybe<Scalars['String']['input']>
  /** Value. */
  value?: InputMaybe<Scalars['String']['input']>
}

export interface IMeasurePermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Values. */
  measureValues?: Maybe<Array<Maybe<IMeasure>>>
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IMeasurePermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IMeasureInput>>>
}

export enum MediaViewType {
  GallerySlider = 'GallerySlider',
  Separated = 'Separated',
}

export interface IMergeResult {
  activitiesUpdates?: Maybe<Scalars['Long']['output']>
  activityAssignmentsUpdates?: Maybe<Scalars['Long']['output']>
  activityListCustomFiltersUpdates?: Maybe<Scalars['Long']['output']>
  castAssignmentsUpdates?: Maybe<Scalars['Long']['output']>
  closureAssignmentsUpdates?: Maybe<Scalars['Long']['output']>
  companyRelationshipsUpdates?: Maybe<Scalars['Long']['output']>
  deliveriesUpdates?: Maybe<Scalars['Long']['output']>
  deliveryAssignmentsUpdates?: Maybe<Scalars['Long']['output']>
  deliveryListCustomFiltersUpdates?: Maybe<Scalars['Long']['output']>
  locationsUpdates?: Maybe<Scalars['Long']['output']>
  mergeLogId?: Maybe<Scalars['ObjectId']['output']>
  operationRulesUpdates?: Maybe<Scalars['Long']['output']>
  sitePermitAssignmentsUpdates?: Maybe<Scalars['Long']['output']>
  sitePermitsUpdates?: Maybe<Scalars['Long']['output']>
  userProjectsUpdates?: Maybe<Scalars['Long']['output']>
  whiteListsUpdates?: Maybe<Scalars['Long']['output']>
  workflowsCustomFiltersUpdates?: Maybe<Scalars['Long']['output']>
}

export interface IMessage {
  /** Activity Id. */
  activityId?: Maybe<Scalars['String']['output']>
  /** Attachments. */
  attachments?: Maybe<Array<Maybe<IAttachment>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** File Id. */
  photoId?: Maybe<Scalars['String']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Read by. */
  readBy?: Maybe<Array<Maybe<IReadBy>>>
  /** Text. */
  text?: Maybe<Scalars['String']['output']>
  /** Thread Id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IMessageChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IMessage>
}

export interface IMessageInput {
  /** Activity Id. */
  activityId?: InputMaybe<Scalars['String']['input']>
  /** Attachments. */
  attachments?: InputMaybe<Array<InputMaybe<IAttachmentInput>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** File Id. */
  photoId?: InputMaybe<Scalars['String']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Read by. */
  readBy?: InputMaybe<Array<InputMaybe<IReadByInput>>>
  /** Text. */
  text?: InputMaybe<Scalars['String']['input']>
  /** Thread Id. */
  threadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IMessageList {
  data: Array<IMessage>
  page: IPageInfo
}

export interface IMonitoringData {
  /** Maturity. */
  maturity?: Maybe<Scalars['Decimal']['output']>
  /** Strength. */
  strength?: Maybe<Scalars['Decimal']['output']>
  /** Strength unit. */
  strengthUnit?: Maybe<Scalars['String']['output']>
  /** Temperature. */
  temperature?: Maybe<Scalars['Decimal']['output']>
  /** Temperature unit. */
  temperatureUnit?: Maybe<Scalars['String']['output']>
  /** Timestamp. */
  timestamp?: Maybe<Scalars['MillisecondsDate']['output']>
}

export interface IMonitoringInfo {
  /** Device Id. */
  deviceId?: Maybe<Scalars['String']['output']>
  /** Monitoring Id. */
  monitoringId?: Maybe<Scalars['String']['output']>
  /** Monitoring name. */
  monitoringName?: Maybe<Scalars['String']['output']>
  /** Monitoring status. */
  status?: Maybe<MonitoringStatus>
}

export interface IMonitoringLatestData {
  /** Latest data. */
  latestData?: Maybe<IMonitoringData>
  /** Monitoring. */
  monitoring?: Maybe<IMonitoringInfo>
}

export enum MonitoringStatus {
  Active = 'Active',
  Planned = 'Planned',
  Stopped = 'Stopped',
}

export interface IMutation {
  activityWithData?: Maybe<IActivity>
  addSitePermitInspection?: Maybe<ISitePermitInspection>
  addSitePermitInspectionChange?: Maybe<ISitePermitInspectionChange>
  archiveProject?: Maybe<Scalars['Boolean']['output']>
  /** Archives a property definition, removing it from all templates. */
  archiveResourceProperty?: Maybe<Scalars['Boolean']['output']>
  /** Applies custom property changes to multiple resources of the same type. */
  bulkEditResourceProperties?: Maybe<Array<Scalars['ObjectId']['output']>>
  changeDeliveriesStatus?: Maybe<Scalars['Boolean']['output']>
  createDeliveries?: Maybe<Array<Maybe<IDelivery>>>
  createDelivery?: Maybe<IDelivery>
  /** Create recurring deliveries. */
  createRecurringDeliveries?: Maybe<Array<Maybe<IDelivery>>>
  /** Create recurring workflows. Returns created workflows and information about dates that were blocked. */
  createRecurringWorkflows?: Maybe<IRecurringWorkflowCreationResult>
  /** Link two resources together (e.g., equipment to sensor). */
  createResourceLink?: Maybe<ILinkResult>
  /** Creates a new property definition. */
  createResourceProperty?: Maybe<IResourceProperty>
  /** Creates a new resource template. */
  createResourceTemplate?: Maybe<IResourceTemplate>
  deleteActivitiesConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteActivityAssignment?: Maybe<Scalars['Boolean']['output']>
  deleteActivityFollowing?: Maybe<Scalars['Boolean']['output']>
  deleteActivityListCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteActivityLocation?: Maybe<Scalars['Boolean']['output']>
  deleteActivityPreset?: Maybe<Scalars['Boolean']['output']>
  deleteCalendarSubscriber?: Maybe<Scalars['Boolean']['output']>
  deleteCastAssignment?: Maybe<Scalars['Boolean']['output']>
  deleteCastFollowing?: Maybe<Scalars['Boolean']['output']>
  deleteClosureAssignment?: Maybe<Scalars['Boolean']['output']>
  deleteClosureFollowing?: Maybe<Scalars['Boolean']['output']>
  deleteCompanyRelationship?: Maybe<Scalars['Boolean']['output']>
  deleteConcreteDirectFromProject?: Maybe<Scalars['Boolean']['output']>
  deleteConstraint?: Maybe<Scalars['Boolean']['output']>
  deleteDeliveryAssignment?: Maybe<Scalars['Boolean']['output']>
  deleteDeliveryConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteDeliveryFieldsConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteDeliveryFollowing?: Maybe<Scalars['Boolean']['output']>
  deleteDeliveryListCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteGlobeView?: Maybe<Scalars['Boolean']['output']>
  deleteGlobeViewSpecificItemData?: Maybe<Scalars['Boolean']['output']>
  deleteHierarchyConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteLogisticsConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivitiesConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivityAssignments?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivityFollowings?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivityListCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivityLocations?: Maybe<Scalars['Boolean']['output']>
  deleteManyActivityPresets?: Maybe<Scalars['Boolean']['output']>
  deleteManyCalendarSubscribers?: Maybe<Scalars['Boolean']['output']>
  deleteManyCastAssignments?: Maybe<Scalars['Boolean']['output']>
  deleteManyCastFollowings?: Maybe<Scalars['Boolean']['output']>
  deleteManyClosureAssignments?: Maybe<Scalars['Boolean']['output']>
  deleteManyClosureFollowings?: Maybe<Scalars['Boolean']['output']>
  deleteManyClosures?: Maybe<Scalars['Boolean']['output']>
  deleteManyCompanyRelationships?: Maybe<Scalars['Boolean']['output']>
  deleteManyConstraints?: Maybe<Scalars['Boolean']['output']>
  deleteManyDeliveryAssignments?: Maybe<Scalars['Boolean']['output']>
  deleteManyDeliveryConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyDeliveryFieldsConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyDeliveryFollowings?: Maybe<Scalars['Boolean']['output']>
  deleteManyDeliveryListCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyDraftPermits?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  deleteManyGlobeViewSpecificItemData?: Maybe<Scalars['Boolean']['output']>
  deleteManyHierarchyConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyLogisticsConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyMarkups?: Maybe<Scalars['Boolean']['output']>
  deleteManyNotificationCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyOperationRules?: Maybe<Scalars['Boolean']['output']>
  deleteManyPresentationSettings?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectAddresses?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectColoringOptions?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectHistories?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectMaterialOptions?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectStatusUpdateOptions?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjectTypeOptions?: Maybe<Scalars['Boolean']['output']>
  deleteManyProjects?: Maybe<Scalars['Boolean']['output']>
  deleteManyRemoteTilesets?: Maybe<Scalars['Boolean']['output']>
  /** Deletes multiple resource templates. */
  deleteManyResourceTemplates?: Maybe<Scalars['Boolean']['output']>
  deleteManyResourcesCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyScanners?: Maybe<Scalars['Boolean']['output']>
  deleteManySitePermitAssignments?: Maybe<Scalars['Boolean']['output']>
  deleteManySitePermitFollowings?: Maybe<Scalars['Boolean']['output']>
  deleteManySitePermitInspectionChanges?: Maybe<Scalars['Boolean']['output']>
  deleteManySitePermitInspections?: Maybe<Scalars['Boolean']['output']>
  deleteManySitemapItems?: Maybe<Scalars['Boolean']['output']>
  deleteManySitemapSpecificItemData?: Maybe<Scalars['Boolean']['output']>
  deleteManyTeams?: Maybe<Scalars['Boolean']['output']>
  deleteManyThreads?: Maybe<Scalars['Boolean']['output']>
  deleteManyTilesets?: Maybe<Scalars['Boolean']['output']>
  deleteManyTrades?: Maybe<Scalars['Boolean']['output']>
  deleteManyUploadLogCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyUploadLogs?: Maybe<Scalars['Boolean']['output']>
  deleteManyUserRoles?: Maybe<Scalars['Boolean']['output']>
  deleteManyWhiteListItems?: Maybe<Scalars['Boolean']['output']>
  deleteManyWorkflowConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteManyWorkflowLocationRestrictions?: Maybe<Scalars['Boolean']['output']>
  deleteManyWorkflowsCustomFilters?: Maybe<Scalars['Boolean']['output']>
  deleteManyZoneMapThresholds?: Maybe<Scalars['Boolean']['output']>
  deleteMarkup?: Maybe<Scalars['Boolean']['output']>
  deleteMaturixFromProject?: Maybe<Scalars['Boolean']['output']>
  deleteMaturixTokenForProject?: Maybe<Scalars['Boolean']['output']>
  deleteNotificationCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteOperationRule?: Maybe<Scalars['Boolean']['output']>
  deletePresentationSettings?: Maybe<Scalars['Boolean']['output']>
  deleteProcoreFromProject?: Maybe<Scalars['Boolean']['output']>
  deleteProject?: Maybe<Scalars['Boolean']['output']>
  deleteProjectAddress?: Maybe<Scalars['Boolean']['output']>
  deleteProjectColoringOptions?: Maybe<Scalars['Boolean']['output']>
  deleteProjectHistory?: Maybe<Scalars['Boolean']['output']>
  deleteProjectMaterialOptions?: Maybe<Scalars['Boolean']['output']>
  deleteProjectStatusUpdateOptions?: Maybe<Scalars['Boolean']['output']>
  deleteProjectTypeOptions?: Maybe<Scalars['Boolean']['output']>
  /** Remove a link between two resources. */
  deleteResourceLink?: Maybe<ILinkResult>
  /** Deletes a property definition, removing it from all templates and its values from all resources. */
  deleteResourceProperty?: Maybe<Scalars['Boolean']['output']>
  /** Deletes a resource template. */
  deleteResourceTemplate?: Maybe<Scalars['Boolean']['output']>
  deleteResourcesCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteScanner?: Maybe<Scalars['Boolean']['output']>
  deleteSitePermitAssignment?: Maybe<Scalars['Boolean']['output']>
  deleteSitePermitFollowing?: Maybe<Scalars['Boolean']['output']>
  deleteSitePermitInspection?: Maybe<Scalars['Boolean']['output']>
  deleteSitePermitInspectionChange?: Maybe<Scalars['Boolean']['output']>
  deleteSitemap?: Maybe<Scalars['Boolean']['output']>
  deleteSitemapSpecificItemData?: Maybe<Scalars['Boolean']['output']>
  deleteTeam?: Maybe<Scalars['Boolean']['output']>
  /** Delete the specified form and all its future recurring instances. */
  deleteThisAndFutureForms?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  deleteThread?: Maybe<Scalars['Boolean']['output']>
  deleteTileset?: Maybe<Scalars['Boolean']['output']>
  deleteTilesetFromMapbox?: Maybe<Scalars['Boolean']['output']>
  deleteTrade?: Maybe<Scalars['Boolean']['output']>
  deleteUploadLog?: Maybe<Scalars['Boolean']['output']>
  deleteUploadLogCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteUserRole?: Maybe<Scalars['Boolean']['output']>
  deleteUsers?: Maybe<Scalars['Boolean']['output']>
  deleteWhiteListItem?: Maybe<Scalars['Boolean']['output']>
  deleteWorkflowConfigurations?: Maybe<Scalars['Boolean']['output']>
  deleteWorkflowLocationRestriction?: Maybe<Scalars['Boolean']['output']>
  deleteWorkflowsCustomFilter?: Maybe<Scalars['Boolean']['output']>
  deleteZoneMapThresholds?: Maybe<Scalars['Boolean']['output']>
  disableLocationsAndClearControls?: Maybe<IResourceControlCascadeResult>
  /** Executes a resource import with user-confirmed column mappings. */
  executeResourceImport?: Maybe<IImportResult>
  /** Exports resource records as CSV or Excel. */
  exportResourceRecords?: Maybe<IResourceExportResult>
  fillupProjectMaterialsData?: Maybe<Scalars['Boolean']['output']>
  generateReport?: Maybe<Scalars['ObjectId']['output']>
  generateSubscriberForExternalCalendars?: Maybe<ICalendarSubscriber>
  getPresentationUserToken?: Maybe<Scalars['String']['output']>
  inviteCalendarSubscriber?: Maybe<ICalendarSubscriber>
  /** Link company with the StruxHub company. */
  linkStruxHubCompany?: Maybe<ICompany>
  /** Merge companies and return new merged company. */
  mergeCompanies?: Maybe<IMergeResult>
  recoverManyCompanies?: Maybe<Scalars['Boolean']['output']>
  removePhoneNumber?: Maybe<IPhoneTransferResult>
  removeUserProjects?: Maybe<Scalars['Boolean']['output']>
  /** Request project access field */
  requestProjectAccess?: Maybe<InviteStatus>
  resendInviteKey?: Maybe<Scalars['Boolean']['output']>
  restoreMaterials?: Maybe<Scalars['Boolean']['output']>
  saveActivitiesConfigurations?: Maybe<IActivitiesConfigurations>
  saveActivity?: Maybe<IActivity>
  saveActivityAssignment?: Maybe<IActivityAssignment>
  saveActivityCodeRelationship?: Maybe<IActivityCodeRelationship>
  saveActivityFiltersSettings?: Maybe<IActivityFiltersSettings>
  saveActivityListCustomFilter?: Maybe<IActivityListCustomFilter>
  saveActivityLocation?: Maybe<IActivityLocation>
  saveActivityPreset?: Maybe<IActivityPreset>
  saveAnalyticsSettings?: Maybe<IAnalyticsSettings>
  saveBasemap?: Maybe<IBasemap>
  saveCastAssignment?: Maybe<ICastAssignment>
  saveClosureAssignment?: Maybe<IClosureAssignment>
  saveCompanyRelationship?: Maybe<ICompanyRelationship>
  saveConcreteDirectDataForProject?: Maybe<Scalars['Boolean']['output']>
  saveConcreteDirectSQSConfiguration?: Maybe<Scalars['Boolean']['output']>
  saveConstraint?: Maybe<IConstraint>
  saveDeliveryAssignment?: Maybe<IDeliveryAssignment>
  saveDeliveryConfigurations?: Maybe<IDeliveryConfigurations>
  saveDeliveryFieldsConfigurations?: Maybe<IDeliveryFieldsConfigurations>
  saveDeliveryListCustomFilter?: Maybe<IDeliveryListCustomFilter>
  saveDeliveryUnit?: Maybe<IDeliveryUnit>
  saveDeliveryVehicleType?: Maybe<IDeliveryVehicleType>
  saveDevice?: Maybe<Scalars['Boolean']['output']>
  saveGlobeView?: Maybe<IGlobeView>
  saveGlobeViewSpecificItemData?: Maybe<
    Array<Maybe<IGlobeViewSpecificItemData>>
  >
  saveGlobeViewStyle?: Maybe<IGlobeView>
  saveHierarchyConfigurations?: Maybe<IHierarchyConfigurations>
  saveJobsiteConfiguration?: Maybe<IJobsiteConfiguration>
  saveLogisticsConfigurations?: Maybe<ILogisticsConfigurations>
  saveManyActivities?: Maybe<Array<Maybe<IActivity>>>
  saveManyActivitiesConfigurations?: Maybe<
    Array<Maybe<IActivitiesConfigurations>>
  >
  saveManyActivityAssignments?: Maybe<Array<Maybe<IActivityAssignment>>>
  saveManyActivityCodeRelationships?: Maybe<
    Array<Maybe<IActivityCodeRelationship>>
  >
  saveManyActivityFiltersSettings?: Maybe<
    Array<Maybe<IActivityFiltersSettings>>
  >
  saveManyActivityFollowings?: Maybe<Array<Maybe<IActivityFollowing>>>
  saveManyActivityListCustomFilters?: Maybe<
    Array<Maybe<IActivityListCustomFilter>>
  >
  saveManyActivityLocations?: Maybe<Array<Maybe<IActivityLocation>>>
  saveManyActivityPresets?: Maybe<Array<Maybe<IActivityPreset>>>
  saveManyAnalyticsSettings?: Maybe<Array<Maybe<IAnalyticsSettings>>>
  saveManyAreas?: Maybe<Array<Maybe<IArea>>>
  saveManyBasemaps?: Maybe<Array<Maybe<IBasemap>>>
  saveManyBuildings?: Maybe<Array<Maybe<IBuilding>>>
  saveManyCastAssignments?: Maybe<Array<Maybe<ICastAssignment>>>
  saveManyCastFollowings?: Maybe<Array<Maybe<ICastFollowing>>>
  saveManyClosureAssignments?: Maybe<Array<Maybe<IClosureAssignment>>>
  saveManyClosureFollowings?: Maybe<Array<Maybe<IClosureFollowing>>>
  saveManyClosures?: Maybe<Array<Maybe<IClosure>>>
  saveManyCompanies?: Maybe<Array<Maybe<ICompany>>>
  saveManyCompanyRelationships?: Maybe<Array<Maybe<ICompanyRelationship>>>
  saveManyConstraints?: Maybe<Array<Maybe<IConstraint>>>
  saveManyContentObjects?: Maybe<Array<Maybe<IContentObject>>>
  saveManyDeliveryAssignments?: Maybe<Array<Maybe<IDeliveryAssignment>>>
  saveManyDeliveryConfigurations?: Maybe<Array<Maybe<IDeliveryConfigurations>>>
  saveManyDeliveryFieldsConfigurations?: Maybe<
    Array<Maybe<IDeliveryFieldsConfigurations>>
  >
  saveManyDeliveryFollowings?: Maybe<Array<Maybe<IDeliveryFollowing>>>
  saveManyDeliveryListCustomFilters?: Maybe<
    Array<Maybe<IDeliveryListCustomFilter>>
  >
  saveManyDeliveryUnits?: Maybe<Array<Maybe<IDeliveryUnit>>>
  saveManyDeliveryVehicleTypes?: Maybe<Array<Maybe<IDeliveryVehicleType>>>
  saveManyFormCategories?: Maybe<Array<Maybe<IFormCategory>>>
  saveManyGates?: Maybe<Array<Maybe<IGate>>>
  saveManyGlobeViews?: Maybe<Array<Maybe<IGlobeView>>>
  saveManyHierarchyConfigurations?: Maybe<
    Array<Maybe<IHierarchyConfigurations>>
  >
  saveManyIntegrations?: Maybe<Array<Maybe<IIntegration>>>
  saveManyInteriorDoors?: Maybe<Array<Maybe<IInteriorDoor>>>
  saveManyInteriorPaths?: Maybe<Array<Maybe<IInteriorPath>>>
  saveManyJobsiteConfigurations?: Maybe<Array<Maybe<IJobsiteConfiguration>>>
  saveManyLevels?: Maybe<Array<Maybe<ILevel>>>
  saveManyLocations?: Maybe<Array<Maybe<ILocation>>>
  saveManyLogisticsConfigurations?: Maybe<
    Array<Maybe<ILogisticsConfigurations>>
  >
  saveManyLogisticsObjects?: Maybe<Array<Maybe<ILogisticsObject>>>
  saveManyMarkups?: Maybe<Array<Maybe<IMarkup>>>
  saveManyMaterialConfigurations?: Maybe<Array<Maybe<IMaterialConfiguration>>>
  saveManyMaterials?: Maybe<Array<Maybe<IMaterial>>>
  saveManyMessages?: Maybe<Array<Maybe<IMessage>>>
  saveManyNotificationCustomFilters?: Maybe<
    Array<Maybe<INotificationCustomFilter>>
  >
  saveManyNotifications?: Maybe<Array<Maybe<INotification>>>
  saveManyOffloadingEquipments?: Maybe<Array<Maybe<IOffloadingEquipment>>>
  saveManyOperationRules?: Maybe<Array<Maybe<IOperationRule>>>
  saveManyPermitTypes?: Maybe<Array<Maybe<IPermitType>>>
  saveManyPhotos?: Maybe<Array<Maybe<IPhoto>>>
  saveManyPresentationSettings?: Maybe<Array<Maybe<IPresentationSettings>>>
  saveManyProjectAddresses?: Maybe<Array<Maybe<IProjectAddress>>>
  saveManyProjectColoringOptions?: Maybe<Array<Maybe<IProjectColoringOptions>>>
  saveManyProjectHistories?: Maybe<Array<Maybe<IProjectHistory>>>
  saveManyProjectLocations?: Maybe<Array<Maybe<IProjectLocation>>>
  saveManyProjectMaterialCategories?: Maybe<
    Array<Maybe<IProjectMaterialCategory>>
  >
  saveManyProjectMaterialOptions?: Maybe<Array<Maybe<IProjectMaterialOptions>>>
  saveManyProjectMaterials?: Maybe<Array<Maybe<IProjectMaterial>>>
  saveManyProjectStatusUpdateOptions?: Maybe<
    Array<Maybe<IProjectStatusUpdateOptions>>
  >
  saveManyProjectTypeOptions?: Maybe<Array<Maybe<IProjectTypeOptions>>>
  saveManyProjects?: Maybe<Array<Maybe<IProject>>>
  saveManyProjectsData?: Maybe<Array<Maybe<IProject>>>
  saveManyRemoteTilesets?: Maybe<Array<Maybe<IRemoteTileset>>>
  saveManyResourcesCustomFilters?: Maybe<Array<Maybe<IResourcesCustomFilter>>>
  saveManyRoutes?: Maybe<Array<Maybe<IRoute>>>
  saveManyScanHistories?: Maybe<Array<Maybe<IScanHistory>>>
  saveManyScanners?: Maybe<Array<Maybe<IScanner>>>
  saveManySensors?: Maybe<Array<Maybe<ISensor>>>
  saveManySitePermitAssignments?: Maybe<Array<Maybe<ISitePermitAssignment>>>
  saveManySitePermitFollowings?: Maybe<Array<Maybe<ISitePermitFollowing>>>
  saveManySitePermits?: Maybe<Array<Maybe<ISitePermit>>>
  saveManySitemapItems?: Maybe<Array<Maybe<ISitemapItem>>>
  saveManySitemaps?: Maybe<Array<Maybe<ISitemap>>>
  saveManyStagings?: Maybe<Array<Maybe<IStaging>>>
  saveManyStatusUpdates?: Maybe<Array<Maybe<IStatusUpdate>>>
  saveManyTeams?: Maybe<Array<Maybe<ITeam>>>
  saveManyThreads?: Maybe<Array<Maybe<IThread>>>
  saveManyTilesets?: Maybe<Array<Maybe<ITileset>>>
  saveManyTrades?: Maybe<Array<Maybe<ITrade>>>
  saveManyUploadLogConfigurations?: Maybe<Array<Maybe<IUploadLogConfiguration>>>
  saveManyUploadLogCustomFilters?: Maybe<Array<Maybe<IUploadLogCustomFilter>>>
  saveManyUploadLogs?: Maybe<Array<Maybe<IUploadLog>>>
  saveManyUserProjects?: Maybe<Array<Maybe<IUserProject>>>
  saveManyUserRoles?: Maybe<Array<Maybe<IUserRole>>>
  saveManyVerticalObjects?: Maybe<Array<Maybe<IVerticalObject>>>
  saveManyWorkflowConfigurations?: Maybe<Array<Maybe<IWorkflowConfigurations>>>
  saveManyWorkflowLocationRestrictions?: Maybe<
    Array<Maybe<IWorkflowLocationRestriction>>
  >
  saveManyWorkflowsCustomFilters?: Maybe<Array<Maybe<IWorkflowsCustomFilter>>>
  saveManyZoneMapThresholds?: Maybe<Array<Maybe<IZoneMapThresholds>>>
  saveManyZones?: Maybe<Array<Maybe<IZone>>>
  saveManycompanyTypeTags?: Maybe<Array<Maybe<IEntityTag>>>
  saveMarkup?: Maybe<IMarkup>
  saveMaterialConfiguration?: Maybe<IMaterialConfiguration>
  saveMembers?: Maybe<Array<Maybe<IUser>>>
  saveMessage?: Maybe<IMessage>
  saveNotification?: Maybe<INotification>
  saveNotificationCustomFilter?: Maybe<INotificationCustomFilter>
  saveOperationRule?: Maybe<IOperationRule>
  savePermitMessage?: Maybe<IMessage>
  savePhoto?: Maybe<IPhoto>
  savePresentationSettings?: Maybe<IPresentationSettings>
  saveProcoreDataForProject?: Maybe<Scalars['Boolean']['output']>
  saveProjectColoringOptions?: Maybe<IProjectColoringOptions>
  saveProjectHistory?: Maybe<IProjectHistory>
  saveProjectMaterial?: Maybe<IProjectMaterial>
  saveProjectMaterialCategory?: Maybe<IProjectMaterialCategory>
  saveProjectMaterialOptions?: Maybe<IProjectMaterialOptions>
  saveProjectStatusUpdateOptions?: Maybe<IProjectStatusUpdateOptions>
  saveProjectTypeOptions?: Maybe<IProjectTypeOptions>
  saveRemoteTileset?: Maybe<IRemoteTileset>
  saveResourcesCustomFilter?: Maybe<IResourcesCustomFilter>
  saveScanHistory?: Maybe<IScanHistory>
  saveSitePermitAssignment?: Maybe<ISitePermitAssignment>
  saveSitemap?: Maybe<ISitemap>
  saveSitemapItem?: Maybe<ISitemapItem>
  saveSitemapSpecificItemData?: Maybe<Array<Maybe<ISitemapSpecificItemData>>>
  saveStatusUpdate?: Maybe<IStatusUpdate>
  saveTeam?: Maybe<ITeam>
  saveThread?: Maybe<IThread>
  saveTileset?: Maybe<ITileset>
  saveTrade?: Maybe<ITrade>
  saveUploadLog?: Maybe<IUploadLog>
  saveUploadLogConfiguration?: Maybe<IUploadLogConfiguration>
  saveUploadLogCustomFilter?: Maybe<IUploadLogCustomFilter>
  saveUserRole?: Maybe<IUserRole>
  saveWhiteListItem?: Maybe<IWhiteListItem>
  saveWorkflowConfigurations?: Maybe<IWorkflowConfigurations>
  saveWorkflowLocationRestriction?: Maybe<IWorkflowLocationRestriction>
  saveWorkflowsCustomFilter?: Maybe<IWorkflowsCustomFilter>
  saveZoneMapThresholds?: Maybe<IZoneMapThresholds>
  savecompanyTypeTag?: Maybe<IEntityTag>
  sendInvites?: Maybe<Scalars['Boolean']['output']>
  sendSmsDeliveryTicket?: Maybe<Scalars['Boolean']['output']>
  sendWelcomeEmails?: Maybe<Scalars['Boolean']['output']>
  setUserProjectTags?: Maybe<Array<Maybe<IUserProject>>>
  /** 'Sign Up' field */
  signUp?: Maybe<InviteStatus>
  softDeleteCompany?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyActivities?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyCompanies?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyDeliveries?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyDeliveryUnits?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyFormCategories?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyForms?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  softDeleteManyLocations?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyPermitTypes?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyStatusUpdates?: Maybe<Scalars['Boolean']['output']>
  softDeleteManyVehicleTypes?: Maybe<Scalars['Boolean']['output']>
  subscribeToTenantLink?: Maybe<ITenantLink>
  transferPhoneNumber?: Maybe<IPhoneTransferResult>
  transferProjectData?: Maybe<Scalars['Boolean']['output']>
  /** Restores an archived property definition and re-adds it to templates. */
  unarchiveResourceProperty?: Maybe<Scalars['Boolean']['output']>
  /** UnLink company with the StruxHub company. */
  unlinkStruxHubCompany?: Maybe<ICompany>
  unsubscribeFromTenantLink?: Maybe<ITenantLink>
  updateActivityFields?: Maybe<Scalars['Boolean']['output']>
  /** Updates Calendar delivery sharing mode */
  updateCalendarDeliverySharingMode?: Maybe<ICalendarConfiguration>
  /** Updates Calendar form sharing mode */
  updateCalendarFormSharingMode?: Maybe<ICalendarConfiguration>
  updateDeliveries?: Maybe<Array<Maybe<IDelivery>>>
  updateDeliveriesFields?: Maybe<Scalars['Boolean']['output']>
  updateDelivery?: Maybe<IDelivery>
  updateLocationsIsBookable?: Maybe<Array<Scalars['ObjectId']['output']>>
  updateLocationsOperatingIntervals?: Maybe<
    Array<Scalars['ObjectId']['output']>
  >
  updateLocationsPermittedCompanies?: Maybe<
    Array<Scalars['ObjectId']['output']>
  >
  updateLocationsShowInMap?: Maybe<Array<Scalars['ObjectId']['output']>>
  updateLocationsWorkflowTypes?: Maybe<Array<Scalars['ObjectId']['output']>>
  /** Updates OperationRule property OperationType */
  updateOperationRuleType?: Maybe<IOperationRule>
  updateProjectCalendarSharing?: Maybe<ICalendarConfiguration>
  updateProjectDeliveryDateRange?: Maybe<ICalendarConfiguration>
  updateProjectFormDateRange?: Maybe<ICalendarConfiguration>
  updateProjectIsLogoWhite?: Maybe<IProject>
  updateProjectRestrictByInvitation?: Maybe<ICalendarConfiguration>
  /** Update recurring deliveries. */
  updateRecurringDeliveries?: Maybe<Array<Maybe<IDelivery>>>
  updateResourceControls?: Maybe<IResourceControlCascadeResult>
  /** Updates an existing property definition. */
  updateResourceProperty?: Maybe<IResourceProperty>
  /** Updates an existing resource template. */
  updateResourceTemplate?: Maybe<IResourceTemplate>
  updateStatusUpdatesMissedStatuses?: Maybe<Scalars['Boolean']['output']>
  updateStatusUpdatesMultiDates?: Maybe<Scalars['Boolean']['output']>
  /** Updates settings for a single property within a template. */
  updateTemplatePropertySettings?: Maybe<IResourceTemplate>
  uploadExcelSchedule?: Maybe<Scalars['String']['output']>
  uploadMaterialsExcel?: Maybe<Scalars['String']['output']>
  uploadSchedule?: Maybe<Scalars['String']['output']>
  uploadUsersFromCsv?: Maybe<Array<Maybe<IUser>>>
  upsertMaturixData?: Maybe<Scalars['Boolean']['output']>
  upsertMaturixTokenForProject?: Maybe<Scalars['Boolean']['output']>
}

export type IMutationActivityWithDataArgs = {
  data: IActivityDataInput
}

export type IMutationAddSitePermitInspectionArgs = {
  fields: IPermitFieldsInput
  inspection: ISitePermitInspectionInput
}

export type IMutationAddSitePermitInspectionChangeArgs = {
  fields: IPermitFieldsInput
  inspectionChange: ISitePermitInspectionInput
}

export type IMutationArchiveProjectArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IMutationArchiveResourcePropertyArgs = {
  id: Scalars['ObjectId']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationBulkEditResourcePropertiesArgs = {
  input: IBulkEditResourcePropertiesInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationChangeDeliveriesStatusArgs = {
  changeDeliveriesStatus: IChangeDeliveriesStatusCommandInput
}

export type IMutationCreateDeliveriesArgs = {
  deliveries: Array<InputMaybe<IDeliveryInput>>
}

export type IMutationCreateDeliveryArgs = {
  delivery: IDeliveryInput
  timezoneId: Scalars['String']['input']
}

export type IMutationCreateRecurringDeliveriesArgs = {
  delivery: IDeliveryInput
  recurringSettings: IRecurringDeliveriesSettingsInput
  timezoneId: Scalars['String']['input']
}

export type IMutationCreateRecurringWorkflowsArgs = {
  recurringSettings: IRecurringWorkflowSettingsInput
  timezoneId: Scalars['String']['input']
  workflow: IPermitWithFieldsInput
}

export type IMutationCreateResourceLinkArgs = {
  kindId: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  sourceId: Scalars['ObjectId']['input']
  targetId: Scalars['ObjectId']['input']
}

export type IMutationCreateResourcePropertyArgs = {
  input: ICreateResourcePropertyInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationCreateResourceTemplateArgs = {
  input: ICreateResourceTemplateInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivitiesConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivityAssignmentArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivityFollowingArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivityListCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivityLocationArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteActivityPresetArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteCalendarSubscriberArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteCastAssignmentArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteCastFollowingArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteClosureAssignmentArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteClosureFollowingArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteCompanyRelationshipArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteConcreteDirectFromProjectArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteConstraintArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteDeliveryAssignmentArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteDeliveryConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteDeliveryFieldsConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteDeliveryFollowingArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteDeliveryListCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteGlobeViewArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteGlobeViewSpecificItemDataArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteHierarchyConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteLogisticsConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteManyActivitiesConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyActivityAssignmentsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyActivityFollowingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyActivityListCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyActivityLocationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyActivityPresetsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyCalendarSubscribersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyCastAssignmentsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyCastFollowingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyClosureAssignmentsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyClosureFollowingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyClosuresArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyCompanyRelationshipsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyConstraintsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDeliveryAssignmentsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDeliveryConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDeliveryFieldsConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDeliveryFollowingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDeliveryListCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyDraftPermitsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyGlobeViewSpecificItemDataArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyHierarchyConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyLogisticsConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyMarkupsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyNotificationCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyOperationRulesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyPresentationSettingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectAddressesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectColoringOptionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectHistoriesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectMaterialOptionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectStatusUpdateOptionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectTypeOptionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyProjectsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyRemoteTilesetsArgs = {
  ids: Array<Scalars['ObjectId']['input']>
}

export type IMutationDeleteManyResourceTemplatesArgs = {
  ids: Array<Scalars['ObjectId']['input']>
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteManyResourcesCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyScannersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitePermitAssignmentsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitePermitFollowingsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitePermitInspectionChangesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitePermitInspectionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitemapItemsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManySitemapSpecificItemDataArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyTeamsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyThreadsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyTilesetsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyTradesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyUploadLogCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyUploadLogsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyUserRolesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyWhiteListItemsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyWorkflowConfigurationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyWorkflowLocationRestrictionsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyWorkflowsCustomFiltersArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteManyZoneMapThresholdsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationDeleteMarkupArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteMaturixFromProjectArgs = {
  struxHubProjectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteMaturixTokenForProjectArgs = {
  struxHubProjectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteNotificationCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteOperationRuleArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeletePresentationSettingsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProcoreFromProjectArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectAddressArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectColoringOptionsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectHistoryArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectMaterialOptionsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectStatusUpdateOptionsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteProjectTypeOptionsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteResourceLinkArgs = {
  kindId: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  sourceId: Scalars['ObjectId']['input']
}

export type IMutationDeleteResourcePropertyArgs = {
  id: Scalars['ObjectId']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteResourceTemplateArgs = {
  id: Scalars['ObjectId']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationDeleteResourcesCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteScannerArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitePermitAssignmentArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitePermitFollowingArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitePermitInspectionArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitePermitInspectionChangeArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitemapArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteSitemapSpecificItemDataArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteTeamArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteThisAndFutureFormsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteThreadArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteTilesetArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteTilesetFromMapboxArgs = {
  tilesetId: Scalars['ObjectId']['input']
}

export type IMutationDeleteTradeArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteUploadLogArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteUploadLogCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteUserRoleArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteUsersArgs = {
  deleteUsers: Array<InputMaybe<IDeleteUsersInput>>
}

export type IMutationDeleteWhiteListItemArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteWorkflowConfigurationsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteWorkflowLocationRestrictionArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteWorkflowsCustomFilterArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDeleteZoneMapThresholdsArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationDisableLocationsAndClearControlsArgs = {
  input: IDisableLocationsAndClearControlsInput
}

export type IMutationExecuteResourceImportArgs = {
  mappings: Array<IColumnMappingInput>
  projectId: Scalars['ObjectId']['input']
  resourceTypeId: Scalars['String']['input']
  storagePath: Scalars['String']['input']
  templateId: Scalars['String']['input']
}

export type IMutationExportResourceRecordsArgs = {
  input: IResourceExportRecordsInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationFillupProjectMaterialsDataArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IMutationGenerateReportArgs = {
  generateReport: IGenerateReportCommandInput
}

export type IMutationGetPresentationUserTokenArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IMutationInviteCalendarSubscriberArgs = {
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  subscriberCode?: InputMaybe<Scalars['String']['input']>
}

export type IMutationLinkStruxHubCompanyArgs = {
  companyId: Scalars['ObjectId']['input']
  struxHubCompanyId: Scalars['ObjectId']['input']
}

export type IMutationMergeCompaniesArgs = {
  companyIds: Array<Scalars['ObjectId']['input']>
  targetCompany: ICompanyInput
}

export type IMutationRecoverManyCompaniesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationRemovePhoneNumberArgs = {
  confirmStrandSource?: InputMaybe<Scalars['Boolean']['input']>
  projectId: Scalars['ObjectId']['input']
  userId: Scalars['ObjectId']['input']
}

export type IMutationRemoveUserProjectsArgs = {
  projectId: Scalars['ObjectId']['input']
  userIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationRequestProjectAccessArgs = {
  projectCode: Scalars['String']['input']
}

export type IMutationResendInviteKeyArgs = {
  inviteKey: Scalars['String']['input']
  projectCode: Scalars['String']['input']
}

export type IMutationRestoreMaterialsArgs = {
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  projectId: Scalars['ObjectId']['input']
}

export type IMutationSaveActivitiesConfigurationsArgs = {
  activitiesConfigurations: IActivitiesConfigurationsInput
}

export type IMutationSaveActivityArgs = {
  activity: IActivityInput
}

export type IMutationSaveActivityAssignmentArgs = {
  activityAssignment: IActivityAssignmentInput
}

export type IMutationSaveActivityCodeRelationshipArgs = {
  activityCodeRelationship: IActivityCodeRelationshipInput
}

export type IMutationSaveActivityFiltersSettingsArgs = {
  activityFiltersSettings: IActivityFiltersSettingsInput
}

export type IMutationSaveActivityListCustomFilterArgs = {
  activityListCustomFilter: IActivityListCustomFilterInput
}

export type IMutationSaveActivityLocationArgs = {
  activityLocation: IActivityLocationInput
}

export type IMutationSaveActivityPresetArgs = {
  activityPreset: IActivityPresetInput
}

export type IMutationSaveAnalyticsSettingsArgs = {
  analyticsSettings: IAnalyticsSettingsInput
}

export type IMutationSaveBasemapArgs = {
  basemap: IBasemapInput
}

export type IMutationSaveCastAssignmentArgs = {
  castAssignment: ICastAssignmentInput
}

export type IMutationSaveClosureAssignmentArgs = {
  closureAssignment: IClosureAssignmentInput
}

export type IMutationSaveCompanyRelationshipArgs = {
  companyRelationship: ICompanyRelationshipInput
}

export type IMutationSaveConcreteDirectDataForProjectArgs = {
  concreteDirectIntegration?: InputMaybe<IConcreteDirectIntegrationInput>
}

export type IMutationSaveConcreteDirectSqsConfigurationArgs = {
  concreteDirectSQSConfiguration?: InputMaybe<IConcreteDirectSqsConfigurationInput>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IMutationSaveConstraintArgs = {
  constraint: IConstraintInput
}

export type IMutationSaveDeliveryAssignmentArgs = {
  deliveryAssignment: IDeliveryAssignmentInput
}

export type IMutationSaveDeliveryConfigurationsArgs = {
  deliveryConfigurations: IDeliveryConfigurationsInput
}

export type IMutationSaveDeliveryFieldsConfigurationsArgs = {
  deliveryFieldsConfigurations: IDeliveryFieldsConfigurationsInput
}

export type IMutationSaveDeliveryListCustomFilterArgs = {
  deliveryListCustomFilter: IDeliveryListCustomFilterInput
}

export type IMutationSaveDeliveryUnitArgs = {
  deliveryUnit: IDeliveryUnitInput
}

export type IMutationSaveDeliveryVehicleTypeArgs = {
  deliveryVehicleType: IDeliveryVehicleTypeInput
}

export type IMutationSaveDeviceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

export type IMutationSaveGlobeViewArgs = {
  globeView: IGlobeViewInput
}

export type IMutationSaveGlobeViewSpecificItemDataArgs = {
  circles?: InputMaybe<Array<InputMaybe<IGlobeViewSpecificItemDataCircleInput>>>
  polylines?: InputMaybe<
    Array<InputMaybe<IGlobeViewSpecificItemDataPolylineInput>>
  >
  rectangles?: InputMaybe<
    Array<InputMaybe<IGlobeViewSpecificItemDataRectangleInput>>
  >
}

export type IMutationSaveGlobeViewStyleArgs = {
  globeViewId: Scalars['ObjectId']['input']
  style: IGlobeViewStyleInput
}

export type IMutationSaveHierarchyConfigurationsArgs = {
  hierarchyConfigurations: IHierarchyConfigurationsInput
}

export type IMutationSaveJobsiteConfigurationArgs = {
  jobsiteConfiguration: IJobsiteConfigurationInput
}

export type IMutationSaveLogisticsConfigurationsArgs = {
  logisticsConfigurations: ILogisticsConfigurationsInput
}

export type IMutationSaveManyActivitiesArgs = {
  activities: Array<InputMaybe<IActivityInput>>
}

export type IMutationSaveManyActivitiesConfigurationsArgs = {
  activitiesConfigurations: Array<InputMaybe<IActivitiesConfigurationsInput>>
}

export type IMutationSaveManyActivityAssignmentsArgs = {
  activityAssignments: Array<InputMaybe<IActivityAssignmentInput>>
}

export type IMutationSaveManyActivityCodeRelationshipsArgs = {
  activityCodeRelationships: Array<InputMaybe<IActivityCodeRelationshipInput>>
}

export type IMutationSaveManyActivityFiltersSettingsArgs = {
  activityFiltersSettings: Array<InputMaybe<IActivityFiltersSettingsInput>>
}

export type IMutationSaveManyActivityFollowingsArgs = {
  activityFollowings: Array<InputMaybe<IActivityFollowingInput>>
}

export type IMutationSaveManyActivityListCustomFiltersArgs = {
  activityListCustomFilters: Array<InputMaybe<IActivityListCustomFilterInput>>
}

export type IMutationSaveManyActivityLocationsArgs = {
  activityLocations: Array<InputMaybe<IActivityLocationInput>>
}

export type IMutationSaveManyActivityPresetsArgs = {
  activityPresets: Array<InputMaybe<IActivityPresetInput>>
}

export type IMutationSaveManyAnalyticsSettingsArgs = {
  analyticsSettings: Array<InputMaybe<IAnalyticsSettingsInput>>
}

export type IMutationSaveManyAreasArgs = {
  areas: Array<InputMaybe<IAreaInput>>
}

export type IMutationSaveManyBasemapsArgs = {
  basemaps: Array<InputMaybe<IBasemapInput>>
}

export type IMutationSaveManyBuildingsArgs = {
  buildings: Array<InputMaybe<IBuildingInput>>
}

export type IMutationSaveManyCastAssignmentsArgs = {
  castAssignments: Array<InputMaybe<ICastAssignmentInput>>
}

export type IMutationSaveManyCastFollowingsArgs = {
  castFollowings: Array<InputMaybe<ICastFollowingInput>>
}

export type IMutationSaveManyClosureAssignmentsArgs = {
  closureAssignments: Array<InputMaybe<IClosureAssignmentInput>>
}

export type IMutationSaveManyClosureFollowingsArgs = {
  closureFollowings: Array<InputMaybe<IClosureFollowingInput>>
}

export type IMutationSaveManyClosuresArgs = {
  closures: Array<InputMaybe<IClosureInput>>
}

export type IMutationSaveManyCompaniesArgs = {
  companies: Array<InputMaybe<ICompanyInput>>
}

export type IMutationSaveManyCompanyRelationshipsArgs = {
  companyRelationships: Array<InputMaybe<ICompanyRelationshipInput>>
}

export type IMutationSaveManyConstraintsArgs = {
  constraints: Array<InputMaybe<IConstraintInput>>
}

export type IMutationSaveManyContentObjectsArgs = {
  contentObjects: Array<InputMaybe<IContentObjectInput>>
}

export type IMutationSaveManyDeliveryAssignmentsArgs = {
  deliveryAssignments: Array<InputMaybe<IDeliveryAssignmentInput>>
}

export type IMutationSaveManyDeliveryConfigurationsArgs = {
  deliveryConfigurations: Array<InputMaybe<IDeliveryConfigurationsInput>>
}

export type IMutationSaveManyDeliveryFieldsConfigurationsArgs = {
  deliveryFieldsConfigurations: Array<
    InputMaybe<IDeliveryFieldsConfigurationsInput>
  >
}

export type IMutationSaveManyDeliveryFollowingsArgs = {
  deliveryFollowings: Array<InputMaybe<IDeliveryFollowingInput>>
}

export type IMutationSaveManyDeliveryListCustomFiltersArgs = {
  deliveryListCustomFilters: Array<InputMaybe<IDeliveryListCustomFilterInput>>
}

export type IMutationSaveManyDeliveryUnitsArgs = {
  deliveryUnits: Array<InputMaybe<IDeliveryUnitInput>>
}

export type IMutationSaveManyDeliveryVehicleTypesArgs = {
  deliveryVehicleTypes: Array<InputMaybe<IDeliveryVehicleTypeInput>>
}

export type IMutationSaveManyFormCategoriesArgs = {
  formCategories: Array<InputMaybe<IFormCategoryInput>>
}

export type IMutationSaveManyGatesArgs = {
  gates: Array<InputMaybe<IGateInput>>
}

export type IMutationSaveManyGlobeViewsArgs = {
  globeViews: Array<InputMaybe<IGlobeViewInput>>
}

export type IMutationSaveManyHierarchyConfigurationsArgs = {
  hierarchyConfigurations: Array<InputMaybe<IHierarchyConfigurationsInput>>
}

export type IMutationSaveManyIntegrationsArgs = {
  integrations: Array<InputMaybe<IIntegrationInput>>
}

export type IMutationSaveManyInteriorDoorsArgs = {
  interiorDoors: Array<InputMaybe<IInteriorDoorInput>>
}

export type IMutationSaveManyInteriorPathsArgs = {
  interiorPaths: Array<InputMaybe<IInteriorPathInput>>
}

export type IMutationSaveManyJobsiteConfigurationsArgs = {
  jobsiteConfigurations: Array<InputMaybe<IJobsiteConfigurationInput>>
}

export type IMutationSaveManyLevelsArgs = {
  levels: Array<InputMaybe<ILevelInput>>
}

export type IMutationSaveManyLocationsArgs = {
  locations: Array<InputMaybe<ILocationInput>>
}

export type IMutationSaveManyLogisticsConfigurationsArgs = {
  logisticsConfigurations: Array<InputMaybe<ILogisticsConfigurationsInput>>
}

export type IMutationSaveManyLogisticsObjectsArgs = {
  logisticsObjects: Array<InputMaybe<ILogisticsObjectInput>>
}

export type IMutationSaveManyMarkupsArgs = {
  markups: Array<InputMaybe<IMarkupInput>>
}

export type IMutationSaveManyMaterialConfigurationsArgs = {
  materialConfigurations: Array<InputMaybe<IMaterialConfigurationInput>>
}

export type IMutationSaveManyMaterialsArgs = {
  materials: Array<InputMaybe<IMaterialInput>>
}

export type IMutationSaveManyMessagesArgs = {
  messages: Array<InputMaybe<IMessageInput>>
}

export type IMutationSaveManyNotificationCustomFiltersArgs = {
  notificationCustomFilters: Array<InputMaybe<INotificationCustomFilterInput>>
}

export type IMutationSaveManyNotificationsArgs = {
  notifications: Array<InputMaybe<INotificationInput>>
}

export type IMutationSaveManyOffloadingEquipmentsArgs = {
  offloadingEquipments: Array<InputMaybe<IOffloadingEquipmentInput>>
}

export type IMutationSaveManyOperationRulesArgs = {
  operationRules: Array<InputMaybe<IOperationRuleInput>>
}

export type IMutationSaveManyPermitTypesArgs = {
  actions?: InputMaybe<Array<InputMaybe<IPermitTypeActionsDtoInput>>>
  deletedOperationRuleIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>
  operationRules?: InputMaybe<Array<IOperationRuleInput>>
  permitTypes: Array<InputMaybe<IPermitTypeInput>>
  projectId: Scalars['ObjectId']['input']
}

export type IMutationSaveManyPhotosArgs = {
  photos: Array<InputMaybe<IPhotoInput>>
}

export type IMutationSaveManyPresentationSettingsArgs = {
  presentationSettings: Array<InputMaybe<IPresentationSettingsInput>>
}

export type IMutationSaveManyProjectAddressesArgs = {
  projectAddresses: Array<InputMaybe<IProjectAddressInput>>
}

export type IMutationSaveManyProjectColoringOptionsArgs = {
  projectColoringOptions: Array<InputMaybe<IProjectColoringOptionsInput>>
}

export type IMutationSaveManyProjectHistoriesArgs = {
  projectHistories: Array<InputMaybe<IProjectHistoryInput>>
}

export type IMutationSaveManyProjectLocationsArgs = {
  projectLocations: Array<InputMaybe<IProjectLocationInput>>
}

export type IMutationSaveManyProjectMaterialCategoriesArgs = {
  projectMaterialCategories: Array<InputMaybe<IProjectMaterialCategoryInput>>
}

export type IMutationSaveManyProjectMaterialOptionsArgs = {
  projectMaterialOptions: Array<InputMaybe<IProjectMaterialOptionsInput>>
}

export type IMutationSaveManyProjectMaterialsArgs = {
  projectMaterials: Array<InputMaybe<IProjectMaterialInput>>
}

export type IMutationSaveManyProjectStatusUpdateOptionsArgs = {
  projectStatusUpdateOptions: Array<
    InputMaybe<IProjectStatusUpdateOptionsInput>
  >
}

export type IMutationSaveManyProjectTypeOptionsArgs = {
  projectTypeOptions: Array<InputMaybe<IProjectTypeOptionsInput>>
}

export type IMutationSaveManyProjectsArgs = {
  projects: Array<InputMaybe<IProjectInput>>
}

export type IMutationSaveManyProjectsDataArgs = {
  projectsData: Array<InputMaybe<IProjectDataInput>>
}

export type IMutationSaveManyRemoteTilesetsArgs = {
  remoteTilesets: Array<InputMaybe<IRemoteTilesetInput>>
}

export type IMutationSaveManyResourcesCustomFiltersArgs = {
  resourcesCustomFilters: Array<InputMaybe<IResourcesCustomFilterInput>>
}

export type IMutationSaveManyRoutesArgs = {
  routes: Array<InputMaybe<IRouteInput>>
}

export type IMutationSaveManyScanHistoriesArgs = {
  scanHistories: Array<InputMaybe<IScanHistoryInput>>
}

export type IMutationSaveManyScannersArgs = {
  scanners: Array<InputMaybe<IScannerInput>>
}

export type IMutationSaveManySensorsArgs = {
  sensors: Array<InputMaybe<ISensorInput>>
}

export type IMutationSaveManySitePermitAssignmentsArgs = {
  sitePermitAssignments: Array<InputMaybe<ISitePermitAssignmentInput>>
}

export type IMutationSaveManySitePermitFollowingsArgs = {
  sitePermitFollowings: Array<InputMaybe<ISitePermitFollowingInput>>
}

export type IMutationSaveManySitePermitsArgs = {
  permits: Array<InputMaybe<IPermitWithFieldsInput>>
}

export type IMutationSaveManySitemapItemsArgs = {
  sitemapItems: Array<InputMaybe<ISitemapItemInput>>
}

export type IMutationSaveManySitemapsArgs = {
  sitemaps: Array<InputMaybe<ISitemapInput>>
}

export type IMutationSaveManyStagingsArgs = {
  stagings: Array<InputMaybe<IStagingInput>>
}

export type IMutationSaveManyStatusUpdatesArgs = {
  statusUpdates: Array<InputMaybe<IStatusUpdateInput>>
}

export type IMutationSaveManyTeamsArgs = {
  teams: Array<InputMaybe<ITeamInput>>
}

export type IMutationSaveManyThreadsArgs = {
  threads: Array<InputMaybe<IThreadInput>>
}

export type IMutationSaveManyTilesetsArgs = {
  tilesets: Array<InputMaybe<ITilesetInput>>
}

export type IMutationSaveManyTradesArgs = {
  trades: Array<InputMaybe<ITradeInput>>
}

export type IMutationSaveManyUploadLogConfigurationsArgs = {
  uploadLogConfigurations: Array<InputMaybe<IUploadLogConfigurationInput>>
}

export type IMutationSaveManyUploadLogCustomFiltersArgs = {
  uploadLogCustomFilters: Array<InputMaybe<IUploadLogCustomFilterInput>>
}

export type IMutationSaveManyUploadLogsArgs = {
  uploadLogs: Array<InputMaybe<IUploadLogInput>>
}

export type IMutationSaveManyUserProjectsArgs = {
  userProjects: Array<InputMaybe<IUserProjectInput>>
}

export type IMutationSaveManyUserRolesArgs = {
  userRoles: Array<InputMaybe<IUserRoleInput>>
}

export type IMutationSaveManyVerticalObjectsArgs = {
  verticalObjects: Array<InputMaybe<IVerticalObjectInput>>
}

export type IMutationSaveManyWorkflowConfigurationsArgs = {
  workflowConfigurations: Array<InputMaybe<IWorkflowConfigurationsInput>>
}

export type IMutationSaveManyWorkflowLocationRestrictionsArgs = {
  workflowLocationRestrictions: Array<
    InputMaybe<IWorkflowLocationRestrictionInput>
  >
}

export type IMutationSaveManyWorkflowsCustomFiltersArgs = {
  workflowsCustomFilters: Array<InputMaybe<IWorkflowsCustomFilterInput>>
}

export type IMutationSaveManyZoneMapThresholdsArgs = {
  zoneMapThresholds: Array<InputMaybe<IZoneMapThresholdsInput>>
}

export type IMutationSaveManyZonesArgs = {
  zones: Array<InputMaybe<IZoneInput>>
}

export type IMutationSaveManycompanyTypeTagsArgs = {
  companyTypeTags: Array<InputMaybe<IEntityTagInput>>
}

export type IMutationSaveMarkupArgs = {
  markup: IMarkupInput
}

export type IMutationSaveMaterialConfigurationArgs = {
  materialConfiguration: IMaterialConfigurationInput
}

export type IMutationSaveMembersArgs = {
  reassignClaimedPhone?: InputMaybe<Scalars['Boolean']['input']>
  saveMembers: Array<InputMaybe<ISaveMemberModelInput>>
}

export type IMutationSaveMessageArgs = {
  message: IMessageInput
}

export type IMutationSaveNotificationArgs = {
  notification: INotificationInput
}

export type IMutationSaveNotificationCustomFilterArgs = {
  notificationCustomFilter: INotificationCustomFilterInput
}

export type IMutationSaveOperationRuleArgs = {
  operationRule: IOperationRuleInput
}

export type IMutationSavePermitMessageArgs = {
  message: IMessageInput
  permitId: Scalars['ObjectId']['input']
}

export type IMutationSavePhotoArgs = {
  photo: IPhotoInput
}

export type IMutationSavePresentationSettingsArgs = {
  presentationSettings: IPresentationSettingsInput
}

export type IMutationSaveProcoreDataForProjectArgs = {
  procoreIntegration?: InputMaybe<IProcoreIntegrationConfigurationInput>
}

export type IMutationSaveProjectColoringOptionsArgs = {
  projectColoringOptions: IProjectColoringOptionsInput
}

export type IMutationSaveProjectHistoryArgs = {
  projectHistory: IProjectHistoryInput
}

export type IMutationSaveProjectMaterialArgs = {
  projectMaterial: IProjectMaterialInput
}

export type IMutationSaveProjectMaterialCategoryArgs = {
  projectMaterialCategory: IProjectMaterialCategoryInput
}

export type IMutationSaveProjectMaterialOptionsArgs = {
  projectMaterialOptions: IProjectMaterialOptionsInput
}

export type IMutationSaveProjectStatusUpdateOptionsArgs = {
  projectStatusUpdateOptions: IProjectStatusUpdateOptionsInput
}

export type IMutationSaveProjectTypeOptionsArgs = {
  projectTypeOptions: IProjectTypeOptionsInput
}

export type IMutationSaveRemoteTilesetArgs = {
  remoteTileset: IRemoteTilesetInput
}

export type IMutationSaveResourcesCustomFilterArgs = {
  resourcesCustomFilter: IResourcesCustomFilterInput
}

export type IMutationSaveScanHistoryArgs = {
  scanHistory: IScanHistoryInput
}

export type IMutationSaveSitePermitAssignmentArgs = {
  sitePermitAssignment: ISitePermitAssignmentInput
}

export type IMutationSaveSitemapArgs = {
  sitemap: ISitemapInput
}

export type IMutationSaveSitemapItemArgs = {
  sitemapItem: ISitemapItemInput
}

export type IMutationSaveSitemapSpecificItemDataArgs = {
  circles?: InputMaybe<Array<InputMaybe<ISitemapSpecificItemDataCircleInput>>>
  polylines?: InputMaybe<
    Array<InputMaybe<ISitemapSpecificItemDataPolylineInput>>
  >
  rectangles?: InputMaybe<
    Array<InputMaybe<ISitemapSpecificItemDataRectangleInput>>
  >
}

export type IMutationSaveStatusUpdateArgs = {
  statusUpdate: IStatusUpdateInput
}

export type IMutationSaveTeamArgs = {
  team: ITeamInput
}

export type IMutationSaveThreadArgs = {
  thread: IThreadInput
}

export type IMutationSaveTilesetArgs = {
  tileset: ITilesetInput
}

export type IMutationSaveTradeArgs = {
  trade: ITradeInput
}

export type IMutationSaveUploadLogArgs = {
  uploadLog: IUploadLogInput
}

export type IMutationSaveUploadLogConfigurationArgs = {
  uploadLogConfiguration: IUploadLogConfigurationInput
}

export type IMutationSaveUploadLogCustomFilterArgs = {
  uploadLogCustomFilter: IUploadLogCustomFilterInput
}

export type IMutationSaveUserRoleArgs = {
  userRole: IUserRoleInput
}

export type IMutationSaveWhiteListItemArgs = {
  whiteListItem: IWhiteListItemInput
}

export type IMutationSaveWorkflowConfigurationsArgs = {
  workflowConfigurations: IWorkflowConfigurationsInput
}

export type IMutationSaveWorkflowLocationRestrictionArgs = {
  workflowLocationRestriction: IWorkflowLocationRestrictionInput
}

export type IMutationSaveWorkflowsCustomFilterArgs = {
  workflowsCustomFilter: IWorkflowsCustomFilterInput
}

export type IMutationSaveZoneMapThresholdsArgs = {
  zoneMapThresholds: IZoneMapThresholdsInput
}

export type IMutationSavecompanyTypeTagArgs = {
  entityTag: IEntityTagInput
}

export type IMutationSendInvitesArgs = {
  projectId: Scalars['ObjectId']['input']
  userData: Array<InputMaybe<IUserDataInput>>
}

export type IMutationSendSmsDeliveryTicketArgs = {
  deliveryId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationSendWelcomeEmailsArgs = {
  projectId: Scalars['ObjectId']['input']
  userEmails: Array<InputMaybe<Scalars['String']['input']>>
}

export type IMutationSetUserProjectTagsArgs = {
  projectId: Scalars['ObjectId']['input']
  userTags: Array<InputMaybe<IUserProjectTagsInput>>
}

export type IMutationSignUpArgs = {
  companyAlias?: InputMaybe<Scalars['String']['input']>
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  projectCode?: InputMaybe<Scalars['String']['input']>
}

export type IMutationSoftDeleteCompanyArgs = {
  id: Scalars['ObjectId']['input']
}

export type IMutationSoftDeleteManyActivitiesArgs = {
  activitiesCodes: Array<InputMaybe<Scalars['String']['input']>>
  projectId: Scalars['ObjectId']['input']
}

export type IMutationSoftDeleteManyCompaniesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyDeliveriesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyDeliveryUnitsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyFormCategoriesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyFormsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyLocationsArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyPermitTypesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSoftDeleteManyStatusUpdatesArgs = {
  activityCode: Scalars['String']['input']
  company?: InputMaybe<Scalars['String']['input']>
  projectId: Scalars['ObjectId']['input']
  timezoneId: Scalars['String']['input']
  unixTime: Scalars['MillisecondsDate']['input']
  userId: Scalars['ObjectId']['input']
}

export type IMutationSoftDeleteManyVehicleTypesArgs = {
  ids: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IMutationSubscribeToTenantLinkArgs = {
  projectId: Scalars['ObjectId']['input']
  tenantLink: Scalars['String']['input']
}

export type IMutationTransferPhoneNumberArgs = {
  confirmReplaceTarget?: InputMaybe<Scalars['Boolean']['input']>
  confirmStrandSource?: InputMaybe<Scalars['Boolean']['input']>
  phoneNumber: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  toUserId: Scalars['ObjectId']['input']
}

export type IMutationTransferProjectDataArgs = {
  definitions: ITransferProjectDefinitionsGraphType
  email: Scalars['String']['input']
}

export type IMutationUnarchiveResourcePropertyArgs = {
  id: Scalars['ObjectId']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUnlinkStruxHubCompanyArgs = {
  companyId: Scalars['ObjectId']['input']
}

export type IMutationUnsubscribeFromTenantLinkArgs = {
  tenantLinkId: Scalars['ObjectId']['input']
}

export type IMutationUpdateActivityFieldsArgs = {
  activities: Array<InputMaybe<IUpdateActivitiesFieldsInput>>
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateCalendarDeliverySharingModeArgs = {
  projectId: Scalars['ObjectId']['input']
  sharingMode: SharingMode
}

export type IMutationUpdateCalendarFormSharingModeArgs = {
  projectId: Scalars['ObjectId']['input']
  sharingMode: SharingMode
}

export type IMutationUpdateDeliveriesArgs = {
  deliveries: Array<InputMaybe<IDeliveryInput>>
}

export type IMutationUpdateDeliveriesFieldsArgs = {
  updateDeliveriesFields?: InputMaybe<IUpdateDeliveriesFieldsInput>
}

export type IMutationUpdateDeliveryArgs = {
  delivery: IDeliveryInput
  message?: InputMaybe<ISaveMessageInput>
  timezoneId: Scalars['String']['input']
}

export type IMutationUpdateLocationsIsBookableArgs = {
  input: IUpdateLocationsIsBookableInput
}

export type IMutationUpdateLocationsOperatingIntervalsArgs = {
  input: IUpdateLocationsOperatingIntervalsInput
}

export type IMutationUpdateLocationsPermittedCompaniesArgs = {
  input: IUpdateLocationsPermittedCompaniesInput
}

export type IMutationUpdateLocationsShowInMapArgs = {
  input: IUpdateLocationsShowInMapInput
}

export type IMutationUpdateLocationsWorkflowTypesArgs = {
  input: IUpdateLocationsWorkflowTypesInput
}

export type IMutationUpdateOperationRuleTypeArgs = {
  id: Scalars['ObjectId']['input']
  operationType: OperationType
}

export type IMutationUpdateProjectCalendarSharingArgs = {
  calendarSharing: Scalars['Boolean']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateProjectDeliveryDateRangeArgs = {
  deliveryFrom: Scalars['DateTime']['input']
  deliveryTo: Scalars['DateTime']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateProjectFormDateRangeArgs = {
  formFrom: Scalars['DateTime']['input']
  formTo: Scalars['DateTime']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateProjectIsLogoWhiteArgs = {
  isLogoWhite: Scalars['Boolean']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateProjectRestrictByInvitationArgs = {
  projectId: Scalars['ObjectId']['input']
  restrictByInviting: Scalars['Boolean']['input']
}

export type IMutationUpdateRecurringDeliveriesArgs = {
  delivery: IDeliveryInput
  message?: InputMaybe<ISaveMessageInput>
  recurringSettings: IRecurringDeliveriesSettingsInput
  relatedRecurringIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
  timezoneId: Scalars['String']['input']
}

export type IMutationUpdateResourceControlsArgs = {
  input: IUpdateResourceControlsInput
}

export type IMutationUpdateResourcePropertyArgs = {
  id: Scalars['ObjectId']['input']
  input: IUpdateResourcePropertyInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateResourceTemplateArgs = {
  id: Scalars['ObjectId']['input']
  input: IUpdateResourceTemplateInput
  projectId: Scalars['ObjectId']['input']
}

export type IMutationUpdateStatusUpdatesMissedStatusesArgs = {
  activityCode: Scalars['String']['input']
  company?: InputMaybe<Scalars['String']['input']>
  projectId: Scalars['ObjectId']['input']
  updates: Array<InputMaybe<IStatusUpdateDateInput>>
  userId: Scalars['ObjectId']['input']
}

export type IMutationUpdateStatusUpdatesMultiDatesArgs = {
  activityCode: Scalars['String']['input']
  dates?: InputMaybe<Array<InputMaybe<IStatusUpdateMultiCompaniesInput>>>
  projectId: Scalars['ObjectId']['input']
  timezoneId: Scalars['String']['input']
  userId: Scalars['ObjectId']['input']
}

export type IMutationUpdateTemplatePropertySettingsArgs = {
  input: ITemplatePropertySettingsInput
  projectId: Scalars['ObjectId']['input']
  propertyId: Scalars['ObjectId']['input']
  templateId: Scalars['ObjectId']['input']
}

export type IMutationUploadExcelScheduleArgs = {
  fileName: Scalars['String']['input']
  fullFilePath: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  sheetData: ISheetDataInput
  shouldUpdateCurrentSchedule: Scalars['Boolean']['input']
  timezoneId: Scalars['String']['input']
  userId: Scalars['ObjectId']['input']
}

export type IMutationUploadMaterialsExcelArgs = {
  data: IUploadMaterialsExcelInput
}

export type IMutationUploadScheduleArgs = {
  file: Scalars['String']['input']
  fileName: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  timezoneId: Scalars['String']['input']
  userId: Scalars['ObjectId']['input']
  xerProjectId: Scalars['String']['input']
}

export type IMutationUploadUsersFromCsvArgs = {
  reassignClaimedPhone?: InputMaybe<Scalars['Boolean']['input']>
  uploadUsersFromCsv: ICsvFileModelInput
}

export type IMutationUpsertMaturixDataArgs = {
  maturixProjectId: Scalars['String']['input']
  strengthUnit?: InputMaybe<Scalars['String']['input']>
  struxHubProjectId?: InputMaybe<Scalars['ObjectId']['input']>
  temperatureUnit?: InputMaybe<Scalars['String']['input']>
}

export type IMutationUpsertMaturixTokenForProjectArgs = {
  maturixToken: Scalars['String']['input']
  struxHubProjectId: Scalars['ObjectId']['input']
}

export interface INotification {
  /** Activity object Id. */
  activityObjectId?: Maybe<Scalars['String']['output']>
  /** Author Id. */
  authorId: Scalars['ObjectId']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is archived. */
  isArchived: Scalars['Boolean']['output']
  /** Message Id. */
  messageId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipient Id. */
  recipientId: Scalars['ObjectId']['output']
  /** Schedule Id. */
  scheduleId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type: NotificationType
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Was read. */
  wasRead: Scalars['Boolean']['output']
}

export interface INotificationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<INotification>
}

export interface INotificationCustomFilter {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default for users. */
  defaultForUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Filters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<INotificationFilter>>>
  /** Group By. */
  groupBy?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface INotificationCustomFilterInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default for users. */
  defaultForUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Filters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<INotificationFilterInput>>>
  /** Group By. */
  groupBy?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface INotificationCustomFilterList {
  data: Array<INotificationCustomFilter>
  page: IPageInfo
}

export interface INotificationFilter {
  /** Type. */
  type?: Maybe<NotificationFilterType>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface INotificationFilterInput {
  /** Type. */
  type?: InputMaybe<NotificationFilterType>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum NotificationFilterType {
  Company = 'company',
  Editor = 'editor',
  Equipment = 'equipment',
  Location = 'location',
  NotificationType = 'notificationType',
  Status = 'status',
  WorkflowType = 'workflowType',
}

export interface INotificationInput {
  /** Activity object Id. */
  activityObjectId?: InputMaybe<Scalars['String']['input']>
  /** Author Id. */
  authorId: Scalars['ObjectId']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is archived. */
  isArchived: Scalars['Boolean']['input']
  /** Message Id. */
  messageId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipient Id. */
  recipientId: Scalars['ObjectId']['input']
  /** Schedule Id. */
  scheduleId?: InputMaybe<Scalars['String']['input']>
  /** Type. */
  type: NotificationType
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Was read. */
  wasRead: Scalars['Boolean']['input']
}

export interface INotificationList {
  data: Array<INotification>
  page: IPageInfo
}

export enum NotificationType {
  ActivityChanged = 'ACTIVITY_CHANGED',
  ActivityFollowed = 'ACTIVITY_FOLLOWED',
  CastFollowed = 'CAST_FOLLOWED',
  CategoryOfVarianceCreated = 'CATEGORY_OF_VARIANCE_CREATED',
  CategoryOfVarianceReplied = 'CATEGORY_OF_VARIANCE_REPLIED',
  ClosureEnded = 'CLOSURE_ENDED',
  ClosureFollowed = 'CLOSURE_FOLLOWED',
  ClosureStarted = 'CLOSURE_STARTED',
  DeliveryCanceled = 'DELIVERY_CANCELED',
  DeliveryDeleted = 'DELIVERY_DELETED',
  DeliveryDelivering = 'DELIVERY_DELIVERING',
  DeliveryDenied = 'DELIVERY_DENIED',
  DeliveryDone = 'DELIVERY_DONE',
  DeliveryFailedInspection = 'DELIVERY_FAILED_INSPECTION',
  DeliveryFollowed = 'DELIVERY_FOLLOWED',
  DeliveryIncompleteDone = 'DELIVERY_INCOMPLETE_DONE',
  DeliveryOnhold = 'DELIVERY_ONHOLD',
  DeliveryOnsite = 'DELIVERY_ONSITE',
  DeliveryPassedInspection = 'DELIVERY_PASSED_INSPECTION',
  DeliveryPaused = 'DELIVERY_PAUSED',
  DeliveryRequested = 'DELIVERY_REQUESTED',
  DeliveryRequestedByLocationClosure = 'DELIVERY_REQUESTED_BY_LOCATION_CLOSURE',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  DeliveryUpdated = 'DELIVERY_UPDATED',
  FlagCreated = 'FLAG_CREATED',
  FlagReplied = 'FLAG_REPLIED',
  MessageReceived = 'MESSAGE_RECEIVED',
  NewUserCreatedViaSignUp = 'NEW_USER_CREATED_VIA_SIGN_UP',
  PermitAccepted = 'PERMIT_ACCEPTED',
  PermitActivated = 'PERMIT_ACTIVATED',
  PermitChanged = 'PERMIT_CHANGED',
  PermitClosed = 'PERMIT_CLOSED',
  PermitDeleted = 'PERMIT_DELETED',
  PermitDenied = 'PERMIT_DENIED',
  PermitEnded = 'PERMIT_ENDED',
  PermitFailed = 'PERMIT_FAILED',
  PermitFollowed = 'PERMIT_FOLLOWED',
  PermitMessageReceived = 'PERMIT_MESSAGE_RECEIVED',
  PermitOnsite = 'PERMIT_ONSITE',
  PermitPassed = 'PERMIT_PASSED',
  PermitReviewed = 'PERMIT_REVIEWED',
  PermitSubmitted = 'PERMIT_SUBMITTED',
  PermitToInspect = 'PERMIT_TO_INSPECT',
  RequestForInformationCreated = 'REQUEST_FOR_INFORMATION_CREATED',
  RfiReplied = 'RFI_REPLIED',
  SafetyHazardCreated = 'SAFETY_HAZARD_CREATED',
  SafetyHazardReplied = 'SAFETY_HAZARD_REPLIED',
  ScannerDeactivated = 'SCANNER_DEACTIVATED',
  ScheduleCommentCreated = 'SCHEDULE_COMMENT_CREATED',
  ScheduleCommentReplied = 'SCHEDULE_COMMENT_REPLIED',
  ScheduleUpdated = 'SCHEDULE_UPDATED',
  StatusUpdateCreated = 'STATUS_UPDATE_CREATED',
  StatusUpdateReplied = 'STATUS_UPDATE_REPLIED',
}

export interface INotifyEntityInput {
  /** Entity id. */
  entityId: Scalars['ObjectId']['input']
  /** Notification type. */
  notificationType?: InputMaybe<NotificationType>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
}

export interface IObjectIdPermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Values. */
  objectIdValues?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IObjectIdPermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
}

export interface IOffloadingEquipment extends ILocationBase {
  /** Accessible levels. */
  accessibleLevels?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** GPS position derived from linked StruxTag sensor. */
  effectivePosition?: Maybe<IEquipmentPosition>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** The sensor (StruxTag) linked to this equipment. */
  linkedSensor?: Maybe<ISensor>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Rollup values aggregated from linked workflows. */
  rollups?: Maybe<Scalars['JSONObject']['output']>
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IOffloadingEquipmentInput {
  /** Accessible levels. */
  accessibleLevels?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IOnSiteContactPerson {
  /** Email. */
  email?: Maybe<Scalars['String']['output']>
  /** Vendor full name. */
  fullName?: Maybe<Scalars['String']['output']>
  /** Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
}

export interface IOnSiteContactResponse {
  /** On Site Contact Company. */
  company?: Maybe<Scalars['String']['output']>
  /** On Site Contact Contact. */
  contact?: Maybe<Scalars['String']['output']>
  /** On Site Contact Name. */
  name?: Maybe<Scalars['String']['output']>
}

export enum OnTimeStatus {
  LateStart = 'Late_Start',
  No = 'No',
  None = 'None',
  Overdue = 'Overdue',
  Yes = 'Yes',
}

export interface IOpenWeatherForecast {
  /** Total precipitation volume (rain + snow) for next 3 hours, mm; null if neither present. */
  amountOfPrecipitation?: Maybe<Scalars['Float']['output']>
  /** Forecast clouds parameters. */
  cloudsParams: IForecastCloudsParams
  /** Forecast weather conditions parameters. */
  conditionParams: Array<Maybe<IForecastConditionParams>>
  /** Time of data forecasted, ISO, UTC. */
  forecastIsoDate: Scalars['String']['output']
  /** Time of data forecasted, unix, UTC, long format. */
  forecastTime: Scalars['Long']['output']
  /** Forecast main parameters. */
  mainParams: IForecastMainParams
  /** Probability of precipitation. The values of the parameter vary between 0 and 1, where 0 is equal to 0%. */
  probabilityOfPrecipitation: Scalars['Float']['output']
  /** Forecast rain precipitation parameters. */
  rainParams?: Maybe<IForecastPrecipitationParams>
  /** Forecast snow precipitation parameters. */
  snowParams?: Maybe<IForecastPrecipitationParams>
  /** Forecast system parameters. */
  systemParams: IForecastSystemParams
  /** Average visibility, metres. The maximum value of the visibility is 10km. */
  visibility: Scalars['Int']['output']
  /** Forecast wind parameters. */
  windParams: IForecastWindParams
}

export interface IOperationRule {
  /** Assign expression. */
  assignExpression?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Expression. */
  expression?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Name shown for the rule, e.g. "Mechanical". */
  name?: Maybe<Scalars['String']['output']>
  /** Operation. */
  operation: OperationType
  /** Operation subject. */
  operationSubject: OperationSubjectType
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IOperationRuleChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IOperationRule>
}

export interface IOperationRuleInput {
  /** Assign expression. */
  assignExpression?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Expression. */
  expression?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Name shown for the rule, e.g. "Mechanical". */
  name?: InputMaybe<Scalars['String']['input']>
  /** Operation. */
  operation: OperationType
  /** Operation subject. */
  operationSubject: OperationSubjectType
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IOperationRuleList {
  data: Array<IOperationRule>
  page: IPageInfo
}

export enum OperationSubjectType {
  Activity = 'activity',
  Delivery = 'delivery',
  Permit = 'permit',
  PermitBic = 'permitBic',
  SignUpNotification = 'signUpNotification',
}

export enum OperationType {
  ExternalCalendar = 'externalCalendar',
  Notification = 'notification',
}

export enum OperatorType {
  Contains = 'Contains',
  DoesNotContain = 'DoesNotContain',
  In = 'In',
  Is = 'Is',
  NotIn = 'NotIn',
}

export interface IOrderedSitemap {
  /** Globe view Id. */
  globeViewId?: Maybe<Scalars['ObjectId']['output']>
  /** Sitemap order. */
  order?: Maybe<Scalars['Int']['output']>
  /** Sitemap id. */
  sitemapId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IOrderedSitemapInput {
  /** Globe view Id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Sitemap order. */
  order: Scalars['Int']['input']
  /** Sitemap id. */
  sitemapId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IPageInfo {
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

export interface IParsedImportFile {
  headers: Array<Scalars['String']['output']>
  rowCount: Scalars['Int']['output']
  suggestedMappings: Array<ISuggestedMapping>
}

export type IPermitActionInterface = {
  /** Action Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Type. */
  type?: Maybe<PermitActionType>
}

export enum PermitActionType {
  EndClosureAction = 'EndClosureAction',
  StartClosureAction = 'StartClosureAction',
}

export type IPermitFieldInterface = {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IPermitFieldSourceInput {
  /** PermitFieldId (ObjectId) if mapping from a permit field */
  permitFieldId?: InputMaybe<Scalars['ObjectId']['input']>
  /** SitePermitSpecialFieldType if mapping from a special SitePermit property */
  permitSpecialField?: InputMaybe<SitePermitSpecialFieldType>
}

export enum PermitFieldType {
  Activity = 'Activity',
  AdditionalDate = 'AdditionalDate',
  Assignee = 'Assignee',
  Checklist = 'Checklist',
  Company = 'Company',
  CompanyInformational = 'CompanyInformational',
  Divider = 'Divider',
  Email = 'Email',
  Equipment = 'Equipment',
  EquipmentInformational = 'EquipmentInformational',
  File = 'File',
  InlineMedia = 'InlineMedia',
  InputNumber = 'InputNumber',
  InputText = 'InputText',
  InputTextArea = 'InputTextArea',
  Instructions = 'Instructions',
  LinkedWorkflow = 'LinkedWorkflow',
  Location = 'Location',
  LocationInformational = 'LocationInformational',
  Material = 'Material',
  MaterialInformational = 'MaterialInformational',
  MaterialResource = 'MaterialResource',
  MaterialResourceInformational = 'MaterialResourceInformational',
  Measure = 'Measure',
  PhoneNumber = 'PhoneNumber',
  PrimaryActivity = 'PrimaryActivity',
  Question = 'Question',
  Requester = 'Requester',
  RichText = 'RichText',
  Section = 'Section',
  Select = 'Select',
  Signature = 'Signature',
  StartFinishDates = 'StartFinishDates',
  Subscriber = 'Subscriber',
  Subsection = 'Subsection',
  Table = 'Table',
  Text = 'Text',
  Time = 'Time',
  User = 'User',
}

export interface IPermitFieldsInput {
  /** Attachment fields. */
  attachmentFields?: InputMaybe<Array<InputMaybe<IAttachmentPermitFieldInput>>>
  /** Checklist answer item fields. */
  checklistAnswerItemFields?: InputMaybe<
    Array<InputMaybe<IChecklistAnswerItemPermitFieldInput>>
  >
  /** Date time fields. */
  dateTimeFields?: InputMaybe<Array<InputMaybe<IDateTimePermitFieldInput>>>
  /** Location fields. */
  locationFields?: InputMaybe<Array<InputMaybe<ILocationPermitFieldInput>>>
  /** Material fields. */
  materialFields?: InputMaybe<Array<InputMaybe<IMaterialFormFieldInput>>>
  /** Material resource fields. */
  materialResourceFields?: InputMaybe<
    Array<InputMaybe<IMaterialResourceFormFieldInput>>
  >
  /** Measure fields. */
  measureFields?: InputMaybe<Array<InputMaybe<IMeasurePermitFieldInput>>>
  /** Object Id fields. */
  objectIdFields?: InputMaybe<Array<InputMaybe<IObjectIdPermitFieldInput>>>
  /** Rich text fields. */
  richTextFields?: InputMaybe<Array<InputMaybe<IRichTextFieldInput>>>
  /** Signature fields. */
  signatureFields?: InputMaybe<Array<InputMaybe<ISignaturePermitFieldInput>>>
  /** String fields. */
  stringFields?: InputMaybe<Array<InputMaybe<IStringPermitFieldInput>>>
  /** Measure fields. */
  tableFields?: InputMaybe<Array<InputMaybe<ITablePermitFieldInput>>>
}

export interface IPermitType {
  /** IDs of steps for auto-ending. */
  autoEndStepIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** BasedOn id. */
  basedOn?: Maybe<Scalars['ObjectId']['output']>
  /** Booking deadline options. */
  bookingDeadlineOptions?: Maybe<IBookingDeadlineOptions>
  /** Associated category id. Can be null. */
  categoryId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default duration options. */
  defaultDurationOptions?: Maybe<IWorkflowDurationOptions>
  /** Icon name. */
  iconName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inspection options. */
  inspectionOptions?: Maybe<IInspectionOptions>
  /** Is auto activation enabled. */
  isAutoActivationEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Determines whether the form is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Is enabled. */
  isEnabled: Scalars['Boolean']['output']
  /** Indicates whether the workflow form title is mandatory. */
  isWorkflowTitleMandatory?: Maybe<Scalars['Boolean']['output']>
  /** Maximum duration options. */
  maxDurationOptions?: Maybe<IWorkflowDurationOptions>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Permit type name. */
  name?: Maybe<Scalars['String']['output']>
  /** Order index. */
  orderIndex: Scalars['Int']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recurring options. */
  recurringOptions?: Maybe<IRecurringOptions>
  /** Should block requesting on non-work times. */
  shouldBlockOnNonWorkTimes?: Maybe<Scalars['Boolean']['output']>
  /** Type (eg 'hotwork', 'ladder', 'energized', 'aerial', 'fireExtinguisher'). */
  type: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Steps. */
  workflowSteps?: Maybe<Array<Maybe<IWorkflowStep>>>
}

export interface IPermitTypeActionsDtoInput {
  /** Permit actions. */
  actions?: InputMaybe<Array<InputMaybe<IAction>>>
  /** Permit type Id. */
  permitTypeId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Workflow step Id */
  workflowStepId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IPermitTypeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IPermitType>
}

export interface IPermitTypeChecklist {
  /** List. */
  list?: Maybe<Array<Maybe<IChecklistItem>>>
  /** List type. */
  listType?: Maybe<Scalars['String']['output']>
}

export interface IPermitTypeChecklistInput {
  /** List. */
  list?: InputMaybe<Array<InputMaybe<IChecklistItemInput>>>
  /** List type. */
  listType?: InputMaybe<Scalars['String']['input']>
}

export interface IPermitTypeField {
  /** Allow create new item. */
  allowCreateNew?: Maybe<Scalars['Boolean']['output']>
  /** Allow precise location. */
  allowPreciseLocation?: Maybe<Scalars['Boolean']['output']>
  /** Allow select existing item. */
  allowSelectExisting?: Maybe<Scalars['Boolean']['output']>
  /** Can edit is mandatory. */
  canEditIsMandatory: Scalars['Boolean']['output']
  /** Can edit is show. */
  canEditIsShown: Scalars['Boolean']['output']
  /** Caption. */
  caption: Scalars['String']['output']
  /** Checklist. */
  checklist?: Maybe<IPermitTypeChecklist>
  /** Default options for sort, group, and filters. */
  defaultOptions?: Maybe<IPermitTypeFieldDefaultOptions>
  /** Filter options. */
  filterOptions?: Maybe<Array<Maybe<ITypeFieldFilterOptions>>>
  /** Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inline media items. */
  inlineMediaItems?: Maybe<Array<Maybe<IAttachment>>>
  /** Instructions. */
  instructions?: Maybe<IInstructions>
  /** Is LBS logic enabled. */
  isLBSLogicEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Is mandatory. */
  isMandatory?: Maybe<Scalars['Boolean']['output']>
  /** Is multiple. */
  isMultiple?: Maybe<Scalars['Boolean']['output']>
  /** Is shown. */
  isShown?: Maybe<Scalars['Boolean']['output']>
  /** Is used in material. */
  isUsedInMaterial?: Maybe<Scalars['Boolean']['output']>
  /** Is user stamp enabled. */
  isUserStampEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Display mode for inline media. */
  mediaView?: Maybe<MediaViewType>
  /** Parent Id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Select options */
  selectOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Permit field type. */
  type?: Maybe<PermitFieldType>
}

/** Default values for sort, group and filters of a permit field. */
export interface IPermitTypeFieldDefaultOptions {
  /** The default filter options. */
  filterOptions?: Maybe<Array<Maybe<IResourcesFilter>>>
  /** The group option. */
  groupOption?: Maybe<Scalars['String']['output']>
  /** The sort direction. */
  sortDirection?: Maybe<SortDirection>
  /** The sort option. */
  sortOption?: Maybe<Scalars['String']['output']>
}

/** Input type for default values for sort, group and filters of a permit field. */
export interface IPermitTypeFieldDefaultOptionsInput {
  /** The default filter options. */
  filterOptions?: InputMaybe<Array<InputMaybe<IResourcesFilterInput>>>
  /** The group option. */
  groupOption?: InputMaybe<Scalars['String']['input']>
  /** The sort direction. */
  sortDirection?: InputMaybe<SortDirection>
  /** The sort option. */
  sortOption?: InputMaybe<Scalars['String']['input']>
}

export interface IPermitTypeFieldReference {
  /** Checklist item id. */
  checkListItemId?: Maybe<Scalars['ObjectId']['output']>
  /** Permit type field id. */
  permitTypeFieldId: Scalars['ObjectId']['output']
}

export interface IPermitTypeFieldReferenceInput {
  /** Checklist item id. */
  checkListItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Permit type field id. */
  permitTypeFieldId: Scalars['ObjectId']['input']
}

export interface IPermitTypeFieldsInput {
  /** Allow create new item. */
  allowCreateNew?: InputMaybe<Scalars['Boolean']['input']>
  /** Allow precise location. */
  allowPreciseLocation?: InputMaybe<Scalars['Boolean']['input']>
  /** Allow select existing item. */
  allowSelectExisting?: InputMaybe<Scalars['Boolean']['input']>
  /** Can edit is mandatory. */
  canEditIsMandatory: Scalars['Boolean']['input']
  /** Can edit is shown. */
  canEditIsShown: Scalars['Boolean']['input']
  /** Caption. */
  caption: Scalars['String']['input']
  /** Checklist. */
  checklist?: InputMaybe<IPermitTypeChecklistInput>
  /** Default options for sort, group, and filters. */
  defaultOptions?: InputMaybe<IPermitTypeFieldDefaultOptionsInput>
  /** Filter options. */
  filterOptions?: InputMaybe<Array<InputMaybe<ITypeFieldFilterOptionsInput>>>
  /** Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Inline media items. */
  inlineMediaItems?: InputMaybe<Array<InputMaybe<IAttachmentInput>>>
  /** Instructions. */
  instructions?: InputMaybe<IInstructionsInput>
  /** Is LBS logic enabled. */
  isLBSLogicEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Is mandatory. */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>
  /** Is multiple. */
  isMultiple?: InputMaybe<Scalars['Boolean']['input']>
  /** Is shown. */
  isShown: Scalars['Boolean']['input']
  /** Is used in material. */
  isUsedInMaterial?: InputMaybe<Scalars['Boolean']['input']>
  /** Is user stamp enabled. */
  isUserStampEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Display mode for inline media. */
  mediaView?: InputMaybe<MediaViewType>
  /** Parent Id. */
  parentId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Select options */
  selectOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Permit field type. */
  type?: InputMaybe<PermitFieldType>
}

export interface IPermitTypeInput {
  /** IDs of steps for auto-ending. */
  autoEndStepIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Id of parent template. */
  basedOn?: InputMaybe<Scalars['ObjectId']['input']>
  /** Booking deadline options. */
  bookingDeadlineOptions?: InputMaybe<IBookingDeadlineOptionsInput>
  /** Associated category id. Can be null. */
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default duration options. */
  defaultDurationOptions?: InputMaybe<IWorkflowDurationOptionsInput>
  /** Icon name. */
  iconName?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Inspection options. */
  inspectionOptions?: InputMaybe<IInspectionOptionsInput>
  /** Is auto activation enabled. */
  isAutoActivationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Is enabled. */
  isEnabled: Scalars['Boolean']['input']
  /** Indicates whether the workflow form title is mandatory. */
  isWorkflowTitleMandatory?: InputMaybe<Scalars['Boolean']['input']>
  /** Maximum duration options. */
  maxDurationOptions?: InputMaybe<IWorkflowDurationOptionsInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Order index. */
  orderIndex: Scalars['Int']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recurring options. */
  recurringOptions?: InputMaybe<IRecurringOptionsInput>
  /** Should block requesting on non-work times. */
  shouldBlockOnNonWorkTimes?: InputMaybe<Scalars['Boolean']['input']>
  /** Type (eg 'hotwork', 'ladder', 'energized', 'aerial', 'fireExtinguisher'). */
  type: Scalars['String']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Inspection options. */
  workflowSteps?: InputMaybe<Array<InputMaybe<IWorkflowStepInput>>>
}

export interface IPermitTypeList {
  data: Array<IPermitType>
  page: IPageInfo
}

export interface IPermitWithFieldsInput {
  /** Fields. */
  fields?: InputMaybe<IPermitFieldsInput>
  /** Message. */
  message?: InputMaybe<ISaveMessageInput>
  /** Permit. */
  permit?: InputMaybe<ISitePermitInput>
  /** Step submissions with user field data when requireAllSubmissions is enabled. */
  stepSubmissions?: InputMaybe<Array<InputMaybe<IStepSubmissionInput>>>
}

export interface IPhoneActivityLogItem {
  /** AccountCreated / IdentityUpdated / PhoneTransferred / PhoneRemoved. */
  changeType?: Maybe<Scalars['String']['output']>
  /** Other party of a transfer. */
  counterpartyName?: Maybe<Scalars['String']['output']>
  /** Counterparty's user id in this tenant, if a member (for the user card). */
  counterpartyUserId?: Maybe<Scalars['String']['output']>
  /** Released / Claimed, for transfers. */
  direction?: Maybe<Scalars['String']['output']>
  /** Tenant the action came from. */
  initiatorTenantHost?: Maybe<Scalars['String']['output']>
  /** True when a system/job made the change. */
  isSystem: Scalars['Boolean']['output']
  /** When the change occurred. */
  occurredAt: Scalars['DateTime']['output']
  /** The number this row is about. */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** Previous number vacated/replaced. */
  replacedNumber?: Maybe<Scalars['String']['output']>
  /** Terminal status of the operation. */
  status?: Maybe<Scalars['String']['output']>
  /** Account this entry is about. */
  subjectName?: Maybe<Scalars['String']['output']>
  /** Subject's user id in this tenant, if a member (for the user card). */
  subjectUserId?: Maybe<Scalars['String']['output']>
}

/** Outcome of a phone-number transfer or removal. */
export interface IPhoneTransferResult {
  /** 'strandSource' or 'replaceTarget' when a confirmation is required. */
  confirmationReason?: Maybe<Scalars['String']['output']>
  /** Human-readable detail for a warning, failure, or confirmation prompt. */
  message?: Maybe<Scalars['String']['output']>
  /** The phone number involved, when known. */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** True when the operation was refused pending an explicit confirmation. */
  requiresConfirmation: Scalars['Boolean']['output']
  /** Raw backend status string. */
  status?: Maybe<Scalars['String']['output']>
  /** True when the operation completed (see message for any reconcile warning). */
  success: Scalars['Boolean']['output']
}

export interface IPhoto {
  /** Activity object Id. */
  activityObjectId?: Maybe<Scalars['String']['output']>
  /** Author Id. */
  author?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Message Id. */
  messageId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Thumb url. */
  thumbUrl?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Url. */
  url?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IPhotoChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IPhoto>
}

export interface IPhotoInput {
  /** Activity object Id. */
  activityObjectId?: InputMaybe<Scalars['String']['input']>
  /** Author Id. */
  author?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Message Id. */
  messageId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Thumb url. */
  thumbUrl?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Url. */
  url?: InputMaybe<Scalars['String']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IPhotoList {
  data: Array<IPhoto>
  page: IPageInfo
}

export interface IPosition {
  /** X. */
  x: Scalars['Float']['output']
  /** Y. */
  y: Scalars['Float']['output']
}

export interface IPositionInput {
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

/** Source of an equipment's effective position. */
export enum PositionSource {
  Live = 'LIVE',
  None = 'NONE',
}

export interface IPreciseLocation {
  /** Bearing. */
  bearing?: Maybe<Scalars['Float']['output']>
  /** GlobeView Id. */
  globeViewId?: Maybe<Scalars['ObjectId']['output']>
  /** Map screenshot URL. */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** Latitude. */
  latitude?: Maybe<Scalars['Float']['output']>
  /** Longitude. */
  longitude?: Maybe<Scalars['Float']['output']>
  /** Overview map screenshot URL. */
  overviewImageUrl?: Maybe<Scalars['String']['output']>
  /** Pitch. */
  pitch?: Maybe<Scalars['Float']['output']>
  /** Zoom. */
  zoom?: Maybe<Scalars['Float']['output']>
}

export interface IPreciseLocationInput {
  /** Bearing. */
  bearing?: InputMaybe<Scalars['Float']['input']>
  /** GlobeView Id. */
  globeViewId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Map screenshot URL. */
  imageUrl?: InputMaybe<Scalars['String']['input']>
  /** Latitude. */
  latitude?: InputMaybe<Scalars['Float']['input']>
  /** Longitude. */
  longitude?: InputMaybe<Scalars['Float']['input']>
  /** Overview map screenshot URL. */
  overviewImageUrl?: InputMaybe<Scalars['String']['input']>
  /** Pitch. */
  pitch?: InputMaybe<Scalars['Float']['input']>
  /** Zoom. */
  zoom?: InputMaybe<Scalars['Float']['input']>
}

export enum PresentationScreenKey {
  Deliveries = 'deliveries',
  Forms = 'forms',
  Gantt = 'gantt',
  Logistics = 'logistics',
}

export interface IPresentationSettings {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inactivity duration. */
  inactivityDuration: Scalars['Int']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** List of screens to show. */
  screens?: Maybe<Array<Maybe<IScreen>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User id who has updated the settings. */
  updatedBy?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IPresentationSettingsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IPresentationSettings>
}

export interface IPresentationSettingsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Inactivity duration. */
  inactivityDuration: Scalars['Int']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** List of screens to show. */
  screens?: InputMaybe<Array<InputMaybe<IScreenInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User id who has updated the settings. */
  updatedBy?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IPresentationSettingsList {
  data: Array<IPresentationSettings>
  page: IPageInfo
}

export interface IProcoreIntegrationConfigurationInput {
  /** Is Procore integration enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** List of Procore projects associated with the StruxHub project */
  procoreProjects?: InputMaybe<Array<InputMaybe<IProcoreProjectConfigInput>>>
  /** StruxHub Project Id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** List of workflow type configurations with field mappings */
  workflowTypes?: InputMaybe<
    Array<InputMaybe<IIntegrationWorkflowTypeConfigInput>>
  >
}

export interface IProcoreProjectConfigInput {
  /** Procore Company Id */
  companyId?: InputMaybe<Scalars['String']['input']>
  /** Procore Project Id */
  projectId?: InputMaybe<Scalars['String']['input']>
}

export interface IProject {
  /** Whether workflow markups are disabled by default for everyone in this project (false = shown). */
  areWorkflowMarkupsDisabledByDefault?: Maybe<Scalars['Boolean']['output']>
  /** Project closures. */
  closedIntervals?: Maybe<Array<Maybe<IProjectClosedInterval>>>
  /** Project code. */
  code: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** DateTime format. */
  dateTimeFormat?: Maybe<Scalars['String']['output']>
  /** Project default landing page. */
  defaultLandingPage?: Maybe<DefaultLandingPage>
  /** Header image URL. */
  headerImageUrl?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Indicates if the logo is white. */
  isLogoWhite?: Maybe<Scalars['Boolean']['output']>
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>
  /** Materials upload id. */
  materialsUploadId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  projectConfig?: Maybe<IProjectPreferences>
  /** Mongo schedule id. */
  scheduleId?: Maybe<Scalars['ObjectId']['output']>
  /** List of completed pages. */
  setUpFinished?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Timezone id. */
  timezoneId?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** List of working days. */
  workingDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Working hours in time milliseconds. Superseded by workingSchedule; mirrors its most widely used range, which may match no single day. */
  workingHours?: Maybe<IWorkingHours>
  /** Per-day working schedule. A weekday listed here is a working day and carries its own hours. Derived from the legacy working days and hours for projects that have no stored schedule. */
  workingSchedule?: Maybe<Array<Maybe<IWorkingScheduleDay>>>
}

export enum ProjectAccessType {
  Admin = 'admin',
  Member = 'member',
  Owner = 'owner',
}

/** One record per unique user/project/day combination. */
export interface IProjectActiveUsersDailyResult {
  /** The date (start of day in the requested timezone), as epoch milliseconds. */
  date?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The project ID. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** The project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** The user ID. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

/** Result of querying active user details for a project within a time period. */
export interface IProjectActiveUsersDetailsResult {
  /** List of active users with their details. */
  activeUsers?: Maybe<Array<Maybe<IActiveUserDetails>>>
  /** End of the query period (exclusive), as epoch milliseconds. */
  periodEnd?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Start of the query period (inclusive), as epoch milliseconds. */
  periodStart?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The project ID. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** The project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** The tenant (company) name. */
  tenantName?: Maybe<Scalars['String']['output']>
}

/** Result of querying active users for a project within a time period. */
export interface IProjectActiveUsersResult {
  /** Number of unique active users in the period. */
  activeUserCount?: Maybe<Scalars['Int']['output']>
  /** List of unique user IDs active in the period. */
  activeUserIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** End of the query period (exclusive), as epoch milliseconds. */
  periodEnd?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Start of the query period (inclusive), as epoch milliseconds. */
  periodStart?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The project ID. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** The project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** The tenant (company) name. */
  tenantName?: Maybe<Scalars['String']['output']>
}

export interface IProjectAddress {
  /** Local address - street, number of building, etc. */
  address?: Maybe<Scalars['String']['output']>
  /** Altitude. */
  altitude?: Maybe<Scalars['Float']['output']>
  /** Bearing. */
  bearing?: Maybe<Scalars['Float']['output']>
  /** Earth coordinates of bounding box. */
  bounds?: Maybe<IAddressBounds>
  /** Earth coordinates of the center point. */
  center?: Maybe<ILatLng>
  /** Name of the city. */
  city?: Maybe<Scalars['String']['output']>
  /** Name of the country. */
  country?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Pitch. */
  pitch?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** USA state name if the country is USA. */
  state?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Zip code. */
  zipcode?: Maybe<Scalars['String']['output']>
  /** Zoom. */
  zoom?: Maybe<Scalars['Float']['output']>
}

export interface IProjectAddressChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectAddress>
}

export interface IProjectAddressInput {
  /** Local address - street, number of building, etc. */
  address?: InputMaybe<Scalars['String']['input']>
  /** Altitude. */
  altitude?: InputMaybe<Scalars['Float']['input']>
  /** Bearing. */
  bearing?: InputMaybe<Scalars['Float']['input']>
  /** Earth coordinates of bounding box. */
  bounds?: InputMaybe<IAddressBoundsInput>
  /** Earth coordinates of the center point. */
  center?: InputMaybe<ILatLngInput>
  /** Name of the city. */
  city?: InputMaybe<Scalars['String']['input']>
  /** Name of the country. */
  country?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Pitch. */
  pitch?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** USA state name if the country is USA. */
  state?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Zip code. */
  zipcode?: InputMaybe<Scalars['String']['input']>
  /** Zoom. */
  zoom?: InputMaybe<Scalars['Float']['input']>
}

export interface IProjectAddressList {
  data: Array<IProjectAddress>
  page: IPageInfo
}

export interface IProjectChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProject>
}

export interface IProjectClosedInterval {
  /** End date. */
  endDate: Scalars['MillisecondsDate']['output']
  /** Name. */
  name?: Maybe<Scalars['String']['output']>
  /** Start date. */
  startDate: Scalars['MillisecondsDate']['output']
}

export interface IProjectClosedIntervalInput {
  /** End date. */
  endDate: Scalars['MillisecondsDate']['input']
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Start date. */
  startDate: Scalars['MillisecondsDate']['input']
}

export interface IProjectColoringOptions {
  /** List of project colors. */
  colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Indicates if weekly work plan coloring is disabled. */
  isWWPColoringDisabled: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectColoringOptionsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectColoringOptions>
}

export interface IProjectColoringOptionsInput {
  /** List of project colors. */
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Indicates if weekly work plan coloring is disabled. */
  isWWPColoringDisabled: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectColoringOptionsList {
  data: Array<IProjectColoringOptions>
  page: IPageInfo
}

export interface IProjectDataInput {
  /** Project address. */
  address: IProjectAddressInput
  /** Project history. */
  history: IProjectHistoryInput
  /** Project. */
  project: IProjectInput
  /** Project type options. */
  typeOptions: IProjectTypeOptionsInput
}

export interface IProjectHistory {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Info about the last updates by pages. */
  lastUpdated: Array<Maybe<ILastUpdatedItem>>
  /** History of materials uploads. */
  materialsHistory?: Maybe<Array<Maybe<IHistoryItem>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** History of schedule uploads. */
  scheduleHistory?: Maybe<Array<Maybe<IHistoryItem>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectHistoryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectHistory>
}

export interface IProjectHistoryInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Info about the last updates by pages. */
  lastUpdated: Array<InputMaybe<ILastUpdatedItemInput>>
  /** History of materials uploads. */
  materialsHistory?: InputMaybe<Array<InputMaybe<IHistoryItemInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** History of schedule uploads. */
  scheduleHistory?: InputMaybe<Array<InputMaybe<IHistoryItemInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectHistoryList {
  data: Array<IProjectHistory>
  page: IPageInfo
}

export interface IProjectInput {
  /** Whether workflow markups are disabled by default for everyone in this project (false = shown). */
  areWorkflowMarkupsDisabledByDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** Project closures. */
  closedIntervals?: InputMaybe<Array<InputMaybe<IProjectClosedIntervalInput>>>
  /** Project code. */
  code: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** DateTime format. */
  dateTimeFormat?: InputMaybe<Scalars['String']['input']>
  /** Project default landing page. */
  defaultLandingPage?: InputMaybe<DefaultLandingPage>
  /** Header image URL. */
  headerImageUrl?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Indicates if the logo is white. */
  isLogoWhite?: InputMaybe<Scalars['Boolean']['input']>
  /** Logo URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** Materials upload id. */
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Mongo schedule id. */
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  /** List of completed pages. */
  setUpFinished?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Timezone id. */
  timezoneId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** List of working days. */
  workingDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  /** Working hours in time milliseconds. Superseded by workingSchedule; re-derived from it when one is provided. */
  workingHours?: InputMaybe<IWorkingHoursInput>
  /** Per-day working schedule. When provided it wins, and workingDays / workingHours are re-derived from it. */
  workingSchedule?: InputMaybe<Array<InputMaybe<IWorkingScheduleDayInput>>>
}

export interface IProjectLocation extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Is linked implicitly set. */
  isLinked: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IProjectLocationInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is Linked implicitly set. */
  isLinked: Scalars['Boolean']['input']
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectMaterial {
  /** Category id. */
  categoryId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Description of material. */
  description?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Materials upload id. */
  materialsUploadId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Total planned quantity of material. */
  plannedQuantity?: Maybe<Scalars['Float']['output']>
  /** List of procurement data. */
  procurementDataList?: Maybe<Array<Maybe<IMaterialProcurementData>>>
  /** Name of material. */
  productName?: Maybe<Scalars['String']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectMaterialCategory {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Description of material category. */
  description?: Maybe<Scalars['String']['output']>
  /** Field definitions of material category. */
  fieldDefinitions?: Maybe<Array<Maybe<IMaterialCategoryFieldDefinition>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Materials upload id. */
  materialsUploadId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Name of material category. */
  name: Scalars['String']['output']
  /** Total planned quantity of material category. */
  plannedQuantity?: Maybe<Scalars['Float']['output']>
  /** List of procurement data. */
  procurementDataList?: Maybe<Array<Maybe<IMaterialProcurementData>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectMaterialCategoryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectMaterialCategory>
}

export interface IProjectMaterialCategoryFieldDefinitionInput {
  /** Name of definition. */
  name: Scalars['String']['input']
  /** Type of definition. */
  type: Scalars['String']['input']
}

export interface IProjectMaterialCategoryInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Description of material category. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Field definitions of material category. */
  fieldDefinitions?: InputMaybe<
    Array<InputMaybe<IProjectMaterialCategoryFieldDefinitionInput>>
  >
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Materials upload id. */
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Name of material category. */
  name: Scalars['String']['input']
  /** Total planned quantity of material category. */
  plannedQuantity?: InputMaybe<Scalars['Float']['input']>
  /** List of procurement data. */
  procurementDataList?: InputMaybe<
    Array<InputMaybe<IMaterialProcurementDataInput>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectMaterialCategoryList {
  data: Array<IProjectMaterialCategory>
  page: IPageInfo
}

export interface IProjectMaterialChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectMaterial>
}

export interface IProjectMaterialInput {
  /** Category id. */
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Description of material. */
  description?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Materials upload id. */
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Total planned quantity of material. */
  plannedQuantity?: InputMaybe<Scalars['Float']['input']>
  /** List of procurement data. */
  procurementDataList?: InputMaybe<
    Array<InputMaybe<IMaterialProcurementDataInput>>
  >
  /** Name of material. */
  productName?: InputMaybe<Scalars['String']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectMaterialList {
  data: Array<IProjectMaterial>
  page: IPageInfo
}

export interface IProjectMaterialOptions {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** List of unchecked material categories. */
  hiddenCategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** List of unchecked material subcategories. */
  hiddenSubCategoryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Indicates if CSI categories and subcategories for materials are disabled. */
  isCSIDisabled: Scalars['Boolean']['output']
  /** Indicates if CSI subcategories for materials are disabled. */
  isCSISubCategoriesDisabled: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectMaterialOptionsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectMaterialOptions>
}

export interface IProjectMaterialOptionsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** List of unchecked material categories. */
  hiddenCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** List of unchecked material subcategories. */
  hiddenSubCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Indicates if CSI categories and subcategories for materials are disabled. */
  isCSIDisabled: Scalars['Boolean']['input']
  /** Indicates if CSI subcategories for materials are disabled. */
  isCSISubCategoriesDisabled: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectMaterialOptionsList {
  data: Array<IProjectMaterialOptions>
  page: IPageInfo
}

export interface IProjectPreferences {
  /** Should analytics be allowed. */
  allowAnalytics: Scalars['Boolean']['output']
  /** Should container updates be allowed. */
  allowContainerUpdates: Scalars['Boolean']['output']
  /** Should deliveries toggling be allowed. */
  allowDeliveriesToggling: Scalars['Boolean']['output']
  /** Should equipment be allowed. */
  allowEquipment: Scalars['Boolean']['output']
  /** Should forms toggling be allowed. */
  allowFormsToggling: Scalars['Boolean']['output']
  /** Should the Locations app be allowed. */
  allowLocations: Scalars['Boolean']['output']
  /** Should logistics toggling be allowed. */
  allowLogisticsToggling: Scalars['Boolean']['output']
  /** Should Material Resources V2 toggling be allowed. */
  allowMaterialResourcesToggling: Scalars['Boolean']['output']
  /** Should materials be allowed. */
  allowMaterials: Scalars['Boolean']['output']
  /** Should materials toggling be allowed. */
  allowMaterialsToggling: Scalars['Boolean']['output']
  /** Should photos be allowed. */
  allowPhotos: Scalars['Boolean']['output']
  /** Should project creation be allowed. */
  allowProjectCreation: Scalars['Boolean']['output']
  /** Should StruxTags be allowed. */
  allowStruxTags: Scalars['Boolean']['output']
  /** Should tilesets be allowed. */
  allowTilesets: Scalars['Boolean']['output']
  /** Should tracker toggling be allowed. */
  allowTrackerToggling: Scalars['Boolean']['output']
  /** Form categories. */
  formCategories?: Maybe<IFormCategories>
  /** Tilesets configuration. */
  tilesetsConfiguration?: Maybe<ITilesetsConfiguration>
}

export interface IProjectSetupFinished {
  /** Page name. */
  pageName: Scalars['String']['output']
  /** Setup is finished for this page. */
  setupFinished?: Maybe<Scalars['Boolean']['output']>
}

export interface IProjectSetupFinishedInput {
  /** Page name. */
  pageName: Scalars['String']['input']
  /** Setup is finished for this page. */
  setupFinished?: InputMaybe<Scalars['Boolean']['input']>
}

export interface IProjectStatusUpdateOptions {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Indicates if the options hasn't been updated yet by user. */
  isAutoGenerated: Scalars['Boolean']['output']
  /** Indicates if manpower is disabled in status updates. */
  isManpowerDisabled: Scalars['Boolean']['output']
  /** Indicates if percent complete is disabled in status updates. */
  isPercentCompleteDisabled: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectStatusUpdateOptionsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectStatusUpdateOptions>
}

export interface IProjectStatusUpdateOptionsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Indicates if the options hasn't been updated yet by user. */
  isAutoGenerated: Scalars['Boolean']['input']
  /** Indicates if manpower is disabled in status updates. */
  isManpowerDisabled: Scalars['Boolean']['input']
  /** Indicates if percent complete is disabled in status updates. */
  isPercentCompleteDisabled: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectStatusUpdateOptionsList {
  data: Array<IProjectStatusUpdateOptions>
  page: IPageInfo
}

export interface IProjectTypeOptions {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Indicates if Analytics app is disabled. */
  isAnalyticsDisabled: Scalars['Boolean']['output']
  /** Indicates if Deliveries app is disabled. */
  isDeliveriesDisabled: Scalars['Boolean']['output']
  /** Indicates if Equipment are disabled. */
  isEquipmentDisabled: Scalars['Boolean']['output']
  /** Indicates if Forms are disabled. */
  isFormsDisabled: Scalars['Boolean']['output']
  /** Indicates if Locations app is disabled. */
  isLocationsDisabled: Scalars['Boolean']['output']
  /** Indicates if Logistics app is disabled. */
  isLogisticsDisabled: Scalars['Boolean']['output']
  /** Indicates if Materials Resources V2 app is disabled. */
  isMaterialResourcesDisabled: Scalars['Boolean']['output']
  /** Indicates if Materials app is disabled. */
  isMaterialsDisabled: Scalars['Boolean']['output']
  /** Indicates if Photos app is disabled. */
  isPhotosDisabled: Scalars['Boolean']['output']
  /** Indicates if StruxTag app is disabled. */
  isStruxTagDisabled: Scalars['Boolean']['output']
  /** Indicates if Tracker app is disabled. */
  isTrackerDisabled: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IProjectTypeOptionsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IProjectTypeOptions>
}

export interface IProjectTypeOptionsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Indicates if Analytics app is disabled. */
  isAnalyticsDisabled: Scalars['Boolean']['input']
  /** Indicates if Deliveries app is disabled. */
  isDeliveriesDisabled: Scalars['Boolean']['input']
  /** Indicates if Equipment are disabled. */
  isEquipmentDisabled: Scalars['Boolean']['input']
  /** Indicates if Forms are disabled. */
  isFormsDisabled: Scalars['Boolean']['input']
  /** Indicates if Locations app is disabled. */
  isLocationsDisabled: Scalars['Boolean']['input']
  /** Indicates if Logistics app is disabled. */
  isLogisticsDisabled: Scalars['Boolean']['input']
  /** Indicates if Materials Resources V2 app is disabled. */
  isMaterialResourcesDisabled: Scalars['Boolean']['input']
  /** Indicates if Materials app is disabled. */
  isMaterialsDisabled: Scalars['Boolean']['input']
  /** Indicates if Photos app is disabled. */
  isPhotosDisabled: Scalars['Boolean']['input']
  /** Indicates if StruxTag app is disabled. */
  isStruxTagDisabled: Scalars['Boolean']['input']
  /** Indicates if Tracker app is disabled. */
  isTrackerDisabled: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IProjectTypeOptionsList {
  data: Array<IProjectTypeOptions>
  page: IPageInfo
}

/** Type-specific configuration for a resource property. */
export interface IPropertyConfiguration {
  /** Allowed MIME types or file extensions for file properties. */
  acceptedFileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Allow custom values not in the options list. */
  allowCustomOptions?: Maybe<Scalars['Boolean']['output']>
  /** Kind of computation: 'date_diff' or 'operational_duration'. */
  computationKind?: Maybe<Scalars['String']['output']>
  /** Number format: 'integer' or null for decimal. */
  format?: Maybe<Scalars['String']['output']>
  /** Source field name for computed fields. */
  fromField?: Maybe<Scalars['String']['output']>
  /** Configuration for importing and exporting relational property values. */
  importExport?: Maybe<IImportExportConfiguration>
  /** Include a 'None' option in the selection. */
  includeNoneOption?: Maybe<Scalars['Boolean']['output']>
  /** Maximum file size in megabytes per file. */
  maxFileSizeMb?: Maybe<Scalars['Int']['output']>
  /** Maximum number of file attachments allowed. */
  maxFiles?: Maybe<Scalars['Int']['output']>
  /** Allow multi-line input for text properties. */
  multiline?: Maybe<Scalars['Boolean']['output']>
  /** Available options for select properties. */
  options?: Maybe<Array<ISelectOption>>
  /** Configuration for resource link properties. */
  resourceLink?: Maybe<IResourceLinkConfiguration>
  /** Configuration for rollup properties. */
  rollup?: Maybe<IRollupConfiguration>
  /** Target field name for computed fields. */
  toField?: Maybe<Scalars['String']['output']>
  /** Output unit for computed fields (e.g., 'minutes'). */
  unit?: Maybe<Scalars['String']['output']>
}

/** Input for type-specific property configuration. */
export interface IPropertyConfigurationInput {
  /** Allowed MIME types or file extensions for file properties. */
  acceptedFileTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Allow custom values not in the options list. */
  allowCustomOptions?: InputMaybe<Scalars['Boolean']['input']>
  /** Kind of computation: 'date_diff' or 'operational_duration'. */
  computationKind?: InputMaybe<Scalars['String']['input']>
  /** Number format: 'integer' or null for decimal. */
  format?: InputMaybe<Scalars['String']['input']>
  /** Source field name for computed fields. */
  fromField?: InputMaybe<Scalars['String']['input']>
  /** Configuration for importing and exporting relational property values. */
  importExport?: InputMaybe<IImportExportConfigurationInput>
  /** Include a 'None' option in the selection. */
  includeNoneOption?: InputMaybe<Scalars['Boolean']['input']>
  /** Maximum file size in megabytes per file. */
  maxFileSizeMb?: InputMaybe<Scalars['Int']['input']>
  /** Maximum number of file attachments allowed. */
  maxFiles?: InputMaybe<Scalars['Int']['input']>
  /** Allow multi-line input for text properties. */
  multiline?: InputMaybe<Scalars['Boolean']['input']>
  /** Available options for select properties. */
  options?: InputMaybe<Array<ISelectOptionInput>>
  /** Configuration for resource-link properties. */
  resourceLink?: InputMaybe<IResourceLinkConfigurationInput>
  /** Configuration for rollup properties. */
  rollup?: InputMaybe<IRollupConfigurationInput>
  /** Target field name for computed fields. */
  toField?: InputMaybe<Scalars['String']['input']>
  /** Output unit for computed fields (e.g., 'minutes'). */
  unit?: InputMaybe<Scalars['String']['input']>
}

export enum PropertyType {
  Checkbox = 'checkbox',
  Company = 'company',
  ComputedField = 'computed_field',
  Datetime = 'datetime',
  File = 'file',
  Hierarchy = 'hierarchy',
  Number = 'number',
  ResourceLink = 'resource_link',
  Rollup = 'rollup',
  Select = 'select',
  Text = 'text',
  User = 'user',
}

export interface IQuery {
  activities?: Maybe<Array<Maybe<IActivity>>>
  activitiesConfigurations?: Maybe<IActivitiesConfigurationsList>
  activityAssignments?: Maybe<IActivityAssignmentList>
  activityCodeRelationships?: Maybe<IActivityCodeRelationshipList>
  activityCodeTypes?: Maybe<IActivityCodeTypeList>
  activityCodes?: Maybe<IActivityCodeList>
  activityFiltersSettings?: Maybe<IActivityFiltersSettings>
  activityFollowings?: Maybe<IActivityFollowingList>
  activityListCustomFilters?: Maybe<IActivityListCustomFilterList>
  activityLocation?: Maybe<IActivityLocation>
  activityLocations?: Maybe<IActivityLocationList>
  activityPresets?: Maybe<IActivityPresetList>
  activityResourceRelationships?: Maybe<IActivityResourceRelationshipList>
  analyticsSettings?: Maybe<IAnalyticsSettings>
  basemaps?: Maybe<IBasemapList>
  calendarSubscribers?: Maybe<ICalendarSubscriberList>
  calendars?: Maybe<ICalendarList>
  castAssignments?: Maybe<ICastAssignmentList>
  castFollowings?: Maybe<ICastFollowingList>
  /** Returns true if project code is unique */
  checkIsProjectCodeUnique?: Maybe<Scalars['Boolean']['output']>
  checkPhoneNumber?: Maybe<Scalars['Boolean']['output']>
  closure?: Maybe<IClosure>
  closureAssignments?: Maybe<IClosureAssignmentList>
  closureFollowings?: Maybe<IClosureFollowingList>
  closures?: Maybe<IClosureList>
  companies?: Maybe<ICompanyList>
  companiesBasicInfo?: Maybe<Array<Maybe<ICompanyBasicInfo>>>
  company?: Maybe<ICompany>
  companyRelationships?: Maybe<ICompanyRelationshipList>
  companyTypeTags?: Maybe<IEntityTagList>
  concreteDirectOrder?: Maybe<IConcreteDirectOrder>
  concreteDirectOrders?: Maybe<IConcreteDirectOrderList>
  concreteDirectPayloads?: Maybe<IConcreteDirectPayloadList>
  configuration?: Maybe<IConfiguration>
  constraint?: Maybe<IConstraint>
  constraints?: Maybe<IConstraintList>
  contentObjects?: Maybe<IContentObjectList>
  defaultCompanyType?: Maybe<DefaultCompanyType>
  defaultPermitTypes?: Maybe<IDefaultPermitTypeList>
  defaultTeams?: Maybe<IDefaultTeamList>
  deliveries?: Maybe<IDeliveryList>
  deliveryAssignments?: Maybe<IDeliveryAssignmentList>
  deliveryConfigurations?: Maybe<IDeliveryConfigurationsList>
  deliveryFieldsConfigurations?: Maybe<IDeliveryFieldsConfigurationsList>
  deliveryFollowings?: Maybe<IDeliveryFollowingList>
  deliveryListCustomFilters?: Maybe<IDeliveryListCustomFilterList>
  deliveryStatusChanges?: Maybe<IDeliveryStatusChangeList>
  deliveryUnits?: Maybe<IDeliveryUnitList>
  deliveryVehicleTypes?: Maybe<IDeliveryVehicleTypeList>
  devices?: Maybe<Array<Maybe<IDeviceInfo>>>
  excelSheets?: Maybe<Array<Maybe<ISheetData>>>
  formCategories?: Maybe<IFormCategoryList>
  generateOneTimeQrCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  generateQrCode?: Maybe<Scalars['String']['output']>
  /** Exports raw ActiveUserBucket documents within a time period, enriched with user/project names. */
  getActiveUserBucketsRaw?: Maybe<Array<Maybe<IActiveUserBucketRecord>>>
  getActivity?: Maybe<IActivity>
  getAvailableProjects?: Maybe<Array<Maybe<IProject>>>
  getCalendarConfiguration?: Maybe<ICalendarConfiguration>
  getCsvUsers?: Maybe<Scalars['String']['output']>
  getCurrentMaterialUploadProgress?: Maybe<IUploadMaterialsProgress>
  getCurrentUser?: Maybe<IUser>
  getDeletedUsers?: Maybe<Array<Maybe<IDeletedUserInfo>>>
  getDeliveryReport?: Maybe<Array<Maybe<IDeliveryReportResponse>>>
  getDeliveryTicket?: Maybe<IDeliveryTicketResponse>
  getFormAnalyticReport?: Maybe<Array<Maybe<IFormAnalyticResponse>>>
  /** Returns closures related to the provided form (workflow). */
  getFormRelatedClosures?: Maybe<Array<Maybe<IClosure>>>
  getMapboxTilesets?: Maybe<Array<Maybe<ITileset>>>
  getMaterialsExcelSheets?: Maybe<Array<Maybe<ISheetData>>>
  getMaturixCasts?: Maybe<Array<Maybe<IMaturixCast>>>
  getMaturixMonitoringData?: Maybe<IMaturixMonitoringDataResponse>
  getMaturixProjects?: Maybe<Array<Maybe<IMaturixProject>>>
  /** Gets active users for projects within a time period (for MAU/DAU/WAU calculation). If projectIds is omitted, returns results for all projects. */
  getProjectActiveUsers?: Maybe<Array<Maybe<IProjectActiveUsersResult>>>
  /** Gets active users per project per day within a time period. Returns one entry per project per day with unique user count. */
  getProjectActiveUsersDaily?: Maybe<
    Array<Maybe<IProjectActiveUsersDailyResult>>
  >
  /** Gets active user details (userId, name, email) for projects within a time period. If projectIds is omitted, returns results for all projects. */
  getProjectActiveUsersDetails?: Maybe<
    Array<Maybe<IProjectActiveUsersDetailsResult>>
  >
  getSharedDeliveriesByProjectToId?: Maybe<Array<Maybe<ISharedDelivery>>>
  getSharedSitePermitsByProjectToId?: Maybe<Array<Maybe<ISharedSitePermit>>>
  getSignedUnverifiedUploadUrl?: Maybe<Array<Maybe<IFileRequisites>>>
  /** Gets unique active users across all projects in the tenant within a time period (for MAU calculation at tenant level). */
  getTenantActiveUsers?: Maybe<ITenantActiveUsersResult>
  /** Gets unique active user details (userId, name, email) across all projects in the tenant within a time period. */
  getTenantActiveUsersDetails?: Maybe<ITenantActiveUsersDetailsResult>
  getUploadLogs?: Maybe<Array<Maybe<IUploadLog>>>
  /** Tenant-wide Users Directory report: one flat record per user's project membership. */
  getUsersDirectoryReport?: Maybe<Array<Maybe<IUserDirectoryReportRecord>>>
  globeViews?: Maybe<IGlobeViewList>
  hierarchyConfigurations?: Maybe<IHierarchyConfigurationsList>
  /** Distinct hierarchy option values referenced by at least one live record under this property. */
  hierarchyPropertyOptionUsage?: Maybe<Array<Scalars['String']['output']>>
  isActivityCodeClaimed?: Maybe<Scalars['Boolean']['output']>
  jobsiteConfiguration?: Maybe<IJobsiteConfiguration>
  /** Get jobsite configuration by project code for JHP standalone mode. */
  jobsiteConfigurationByCode?: Maybe<IJobsiteConfigurationByCode>
  /** Returns board data JSON for a single project's Jobsite Homepage. */
  jobsiteHomepageBoardData?: Maybe<Scalars['String']['output']>
  locations?: Maybe<ILocationList>
  logisticsConfigurations?: Maybe<ILogisticsConfigurationsList>
  markups?: Maybe<IMarkupList>
  materialConfiguration?: Maybe<IMaterialConfiguration>
  messages?: Maybe<IMessageList>
  notificationCustomFilters?: Maybe<INotificationCustomFilterList>
  notifications?: Maybe<INotificationList>
  notifyActivityEntityChanged?: Maybe<Scalars['Boolean']['output']>
  operationRules?: Maybe<IOperationRuleList>
  /** Parses a CSV/Excel file and returns headers with auto-suggested column mappings. */
  parseResourceImportFile?: Maybe<IParsedImportFile>
  permitTypes?: Maybe<IPermitTypeList>
  /** Get a phone number's transfer/assign/remove history, newest first. */
  phoneActivityLogs?: Maybe<Array<Maybe<IPhoneActivityLogItem>>>
  photos?: Maybe<IPhotoList>
  presentationSettings?: Maybe<IPresentationSettingsList>
  previewResourceControlCascade?: Maybe<IResourceControlCascadeResult>
  project?: Maybe<IProject>
  projectAddresses?: Maybe<IProjectAddressList>
  projectColoringOptions?: Maybe<IProjectColoringOptionsList>
  projectHistories?: Maybe<IProjectHistoryList>
  projectMaterialCategories?: Maybe<IProjectMaterialCategoryList>
  projectMaterialOptions?: Maybe<IProjectMaterialOptionsList>
  projectMaterials?: Maybe<IProjectMaterialList>
  projectStatusUpdateOptions?: Maybe<IProjectStatusUpdateOptionsList>
  projectTypeOptions?: Maybe<IProjectTypeOptionsList>
  recurringDeliveriesSettings?: Maybe<IRecurringDeliveriesSettings>
  recurringWorkflowSettings?: Maybe<IRecurringWorkflowSettings>
  relativeActivities?: Maybe<IRelativeActivities>
  remoteTilesets?: Maybe<IRemoteTilesetList>
  reportTemplate?: Maybe<IReportTemplate>
  /** Tenant User id of the project member with the given StruxHub account id, or null. */
  resolveScannedAccount?: Maybe<Scalars['ObjectId']['output']>
  /** Returns all properties for a resource type, seeding defaults if needed. */
  resourceProperties?: Maybe<Array<IResourceProperty>>
  resourceProperty?: Maybe<IResourceProperty>
  /** Returns the count of resource records for the property's resource type. */
  resourcePropertyUsageCount?: Maybe<Scalars['Int']['output']>
  resourceTemplate?: Maybe<IResourceTemplate>
  /** Returns all templates for a resource type, seeding defaults if needed. */
  resourceTemplates?: Maybe<Array<IResourceTemplate>>
  /** Returns all registered resource types. */
  resourceTypes?: Maybe<Array<IResourceType>>
  resources?: Maybe<IResourceList>
  resourcesCustomFilters?: Maybe<IResourcesCustomFilterList>
  scanHistories?: Maybe<IScanHistoryList>
  scanners?: Maybe<IScannerList>
  schedule?: Maybe<ISchedule>
  schedules?: Maybe<IScheduleList>
  sitePermitAssignments?: Maybe<ISitePermitAssignmentList>
  sitePermitFollowings?: Maybe<ISitePermitFollowingList>
  sitePermitInspectionChanges?: Maybe<ISitePermitInspectionChangeList>
  sitePermitInspections?: Maybe<ISitePermitInspectionList>
  sitePermitStatusChanges?: Maybe<ISitePermitStatusChangeList>
  sitePermits?: Maybe<ISitePermitList>
  /** Returns site permits with advanced filtering and sorting capabilities using MongoDB aggregation pipeline */
  sitePermitsAggregation?: Maybe<ISitePermitList>
  /** Returns site permit facets for filtering based on the same filter criteria as sitePermitsAggregation */
  sitePermitsFacets?: Maybe<ISitePermitFacets>
  sitemapItems?: Maybe<ISitemapItemList>
  sitemaps?: Maybe<ISitemapList>
  statusUpdates?: Maybe<IStatusUpdateList>
  struxHubCompanies?: Maybe<IStruxHubCompanyList>
  struxHubCompany?: Maybe<IStruxHubCompany>
  /** Get StruxTag activity sessions by project and infuse ID. */
  struxTagActivitySessions?: Maybe<Array<Maybe<IStruxTagActivitySession>>>
  /** Get StruxTag GPS path by project, infuse ID, and date range. */
  struxTagGpsPath?: Maybe<IStruxTagGpsPath>
  /** Get engine-on utilization per day for a StruxTag over the last N days (project-local). */
  struxTagUtilization?: Maybe<IStruxTagUtilization>
  teams?: Maybe<ITeamList>
  tenantLinks?: Maybe<ITenantLinkList>
  threads?: Maybe<IThreadList>
  tilesets?: Maybe<ITilesetList>
  trades?: Maybe<ITradeList>
  unreadNotifications?: Maybe<Array<Maybe<INotification>>>
  unreadNotificationsCount?: Maybe<Scalars['Long']['output']>
  uploadLogConfiguration?: Maybe<IUploadLogConfiguration>
  uploadLogCustomFilters?: Maybe<IUploadLogCustomFilterList>
  /** Returns upload logs with their related deliveries and site permits using MongoDB aggregation pipeline */
  uploadLogsAggregation?: Maybe<IUploadLogAggregatedList>
  /** Returns upload log facets for filtering based on the same filter criteria as uploadLogsAggregation */
  uploadLogsFacets?: Maybe<IUploadLogFacets>
  user?: Maybe<IUser>
  /** Get user activity logs for a project. */
  userActivityLogs?: Maybe<Array<Maybe<IUserActivityLog>>>
  userProject?: Maybe<IUserProject>
  userProjects?: Maybe<IUserProjectList>
  userRoles?: Maybe<IUserRoleList>
  userTags?: Maybe<Array<Maybe<IUserTag>>>
  users?: Maybe<IUserList>
  /** Validates location restrictions for given locations and time periods based on workflow Id. */
  validateLocationRestrictionsForTimePeriods?: Maybe<
    Array<Maybe<ITimePeriodValidationResult>>
  >
  verifyUploadedFile?: Maybe<IFileRequisites>
  weatherForecasts?: Maybe<Array<Maybe<IWeatherForecast>>>
  whiteListItems?: Maybe<IWhiteListItemList>
  workBreakdownStructure?: Maybe<IWorkBreakdownStructure>
  workBreakdownStructures?: Maybe<IWorkBreakdownStructureList>
  workflowConfigurations?: Maybe<IWorkflowConfigurationsList>
  workflowLocationRestrictions?: Maybe<IWorkflowLocationRestrictionList>
  workflowsCustomFilters?: Maybe<IWorkflowsCustomFilterList>
  xerProjects?: Maybe<Array<Maybe<IXerProjectInfo>>>
  zoneMapThresholds?: Maybe<IZoneMapThresholdsList>
}

export type IQueryActivitiesArgs = {
  date?: InputMaybe<Scalars['MillisecondsDate']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  timezoneId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryActivitiesConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityAssignmentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityCodeRelationshipsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityCodeTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityCodesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityFiltersSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryActivityFollowingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityListCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityLocationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryActivityLocationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryActivityPresetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryActivityResourceRelationshipsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryAnalyticsSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryBasemapsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCalendarSubscribersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCalendarsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCastAssignmentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCastFollowingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCheckIsProjectCodeUniqueArgs = {
  projectCode: Scalars['String']['input']
}

export type IQueryCheckPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input']
}

export type IQueryClosureArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryClosureAssignmentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryClosureFollowingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryClosuresArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCompaniesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCompaniesBasicInfoArgs = {
  projectCode?: InputMaybe<Scalars['String']['input']>
  searchString?: InputMaybe<Scalars['String']['input']>
}

export type IQueryCompanyArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IQueryCompanyRelationshipsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryCompanyTypeTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryConcreteDirectOrderArgs = {
  cdId?: InputMaybe<Scalars['Guid']['input']>
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryConcreteDirectOrdersArgs = {
  cdIds: Array<InputMaybe<Scalars['String']['input']>>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryConcreteDirectPayloadsArgs = {
  cdIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  cdOrderId?: InputMaybe<Scalars['Guid']['input']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IQueryConstraintArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryConstraintsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryContentObjectsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDefaultPermitTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDefaultTeamsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveriesArgs = {
  fromDate?: InputMaybe<Scalars['Long']['input']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  toDate?: InputMaybe<Scalars['Long']['input']>
}

export type IQueryDeliveryAssignmentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryFieldsConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryFollowingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryListCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryDeliveryStatusChangesArgs = {
  deliveryId?: InputMaybe<Scalars['ObjectId']['input']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryUnitsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDeliveryVehicleTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryDevicesArgs = {
  userIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export type IQueryExcelSheetsArgs = {
  fullFilePath: Scalars['String']['input']
}

export type IQueryFormCategoriesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryGenerateOneTimeQrCodesArgs = {
  qrCodeData: Array<InputMaybe<Scalars['String']['input']>>
}

export type IQueryGenerateQrCodeArgs = {
  data: Scalars['String']['input']
}

export type IQueryGetActiveUserBucketsRawArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
}

export type IQueryGetActivityArgs = {
  activityCode: Scalars['String']['input']
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryGetCalendarConfigurationArgs = {
  projectId: Scalars['String']['input']
}

export type IQueryGetCsvUsersArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetCurrentMaterialUploadProgressArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetDeletedUsersArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetDeliveryTicketArgs = {
  deliveryId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryGetFormAnalyticReportArgs = {
  fromDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  toDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
}

export type IQueryGetFormRelatedClosuresArgs = {
  permit: ISitePermitInput
  recurringSettings?: InputMaybe<IRecurringWorkflowSettingsInput>
  timezoneId: Scalars['String']['input']
}

export type IQueryGetMapboxTilesetsArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetMaterialsExcelSheetsArgs = {
  fullFilePath: Scalars['String']['input']
}

export type IQueryGetMaturixCastsArgs = {
  struxHubProjectId: Scalars['ObjectId']['input']
}

export type IQueryGetMaturixMonitoringDataArgs = {
  monitoringId: Scalars['String']['input']
  struxHubProjectId: Scalars['ObjectId']['input']
}

export type IQueryGetMaturixProjectsArgs = {
  struxHubProjectId: Scalars['ObjectId']['input']
}

export type IQueryGetProjectActiveUsersArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
  projectIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>
}

export type IQueryGetProjectActiveUsersDailyArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
  timezone: Scalars['String']['input']
}

export type IQueryGetProjectActiveUsersDetailsArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
  projectIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>
}

export type IQueryGetSharedDeliveriesByProjectToIdArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetSharedSitePermitsByProjectToIdArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryGetSignedUnverifiedUploadUrlArgs = {
  fileName: Scalars['String']['input']
  uploadingType: Scalars['String']['input']
}

export type IQueryGetTenantActiveUsersArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
}

export type IQueryGetTenantActiveUsersDetailsArgs = {
  periodEnd: Scalars['MillisecondsDate']['input']
  periodStart: Scalars['MillisecondsDate']['input']
}

export type IQueryGetUploadLogsArgs = {
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sourceEntityIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  sourceEntityType?: InputMaybe<SourceEntityType>
}

export type IQueryGetUsersDirectoryReportArgs = {
  accessType?: InputMaybe<ProjectAccessType>
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  inviteStatus?: InputMaybe<InviteStatus>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryGlobeViewsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryHierarchyConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryHierarchyPropertyOptionUsageArgs = {
  projectId: Scalars['ObjectId']['input']
  propertyId: Scalars['ObjectId']['input']
}

export type IQueryIsActivityCodeClaimedArgs = {
  code: Scalars['String']['input']
  scheduleId: Scalars['ObjectId']['input']
}

export type IQueryJobsiteConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryJobsiteConfigurationByCodeArgs = {
  projectCode: Scalars['String']['input']
}

export type IQueryJobsiteHomepageBoardDataArgs = {
  projectCode: Scalars['String']['input']
}

export type IQueryLocationsArgs = {
  attributeType?: InputMaybe<LocationType>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  kind?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryLogisticsConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryMarkupsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sitePermitIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  sort?: InputMaybe<ISortBy>
}

export type IQueryMaterialConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryMessagesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryNotificationCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryNotificationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryNotifyActivityEntityChangedArgs = {
  notifyActivityEntityChanged: INotifyEntityInput
}

export type IQueryOperationRulesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryParseResourceImportFileArgs = {
  projectId: Scalars['ObjectId']['input']
  resourceTypeId: Scalars['String']['input']
  storagePath: Scalars['String']['input']
}

export type IQueryPermitTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryPhoneActivityLogsArgs = {
  phoneNumber: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IQueryPhotosArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryPresentationSettingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryPreviewResourceControlCascadeArgs = {
  locationIds: Array<Scalars['ObjectId']['input']>
  projectId: Scalars['ObjectId']['input']
  proposedIsBookable?: InputMaybe<Scalars['Boolean']['input']>
  proposedWorkflowTypes?: InputMaybe<Array<Scalars['ObjectId']['input']>>
}

export type IQueryProjectArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryProjectAddressesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectColoringOptionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectHistoriesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectMaterialCategoriesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectMaterialOptionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectMaterialsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectStatusUpdateOptionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryProjectTypeOptionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryRecurringDeliveriesSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryRecurringWorkflowSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryRelativeActivitiesArgs = {
  activityP6Code?: InputMaybe<Scalars['String']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryRemoteTilesetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryReportTemplateArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  templateId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryResolveScannedAccountArgs = {
  projectId: Scalars['ObjectId']['input']
  stxAccountId: Scalars['ObjectId']['input']
}

export type IQueryResourcePropertiesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
  projectId: Scalars['ObjectId']['input']
  resourceTypeId: Scalars['String']['input']
}

export type IQueryResourcePropertyArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryResourcePropertyUsageCountArgs = {
  id: Scalars['ObjectId']['input']
  projectId: Scalars['ObjectId']['input']
}

export type IQueryResourceTemplateArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryResourceTemplatesArgs = {
  projectId: Scalars['ObjectId']['input']
  resourceTypeId: Scalars['String']['input']
}

export type IQueryResourcesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryResourcesCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  resourceTypeId: Scalars['String']['input']
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryScanHistoriesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryScannersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryScheduleArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQuerySchedulesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitAssignmentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitFollowingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitInspectionChangesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitInspectionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitStatusChangesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  permitId?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitsAggregationArgs = {
  filter: ISitePermitFilterInput
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitePermitsFacetsArgs = {
  filter: ISitePermitFilterInput
}

export type IQuerySitemapItemsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQuerySitemapsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryStatusUpdatesArgs = {
  activityP6Codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryStruxHubCompaniesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryStruxHubCompanyArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryStruxTagActivitySessionsArgs = {
  from?: InputMaybe<Scalars['String']['input']>
  infuseId: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  to?: InputMaybe<Scalars['String']['input']>
}

export type IQueryStruxTagGpsPathArgs = {
  from: Scalars['DateTime']['input']
  infuseId: Scalars['String']['input']
  maxPoints?: InputMaybe<Scalars['Int']['input']>
  projectId: Scalars['ObjectId']['input']
  to: Scalars['DateTime']['input']
}

export type IQueryStruxTagUtilizationArgs = {
  infuseId: Scalars['String']['input']
  projectId: Scalars['ObjectId']['input']
  windowDays?: InputMaybe<Scalars['Int']['input']>
}

export type IQueryTeamsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryTenantLinksArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryThreadsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryTilesetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryTradesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryUnreadNotificationsArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryUnreadNotificationsCountArgs = {
  projectId: Scalars['ObjectId']['input']
}

export type IQueryUploadLogConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUploadLogCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUploadLogsAggregationArgs = {
  filter: IUploadLogAggregationFilterInput
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryUploadLogsFacetsArgs = {
  filter: IUploadLogAggregationFilterInput
}

export type IQueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>
  firebaseId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUserActivityLogsArgs = {
  activityType?: InputMaybe<UserActivityType>
  actorUserId?: InputMaybe<Scalars['ObjectId']['input']>
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  targetUserId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUserProjectArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUserProjectsArgs = {
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryUserRolesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryUsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryValidateLocationRestrictionsForTimePeriodsArgs = {
  locationIds: Array<Scalars['ObjectId']['input']>
  permitId?: InputMaybe<Scalars['ObjectId']['input']>
  timePeriods: Array<IDateIntervalInput>
  workflowId: Scalars['ObjectId']['input']
}

export type IQueryVerifyUploadedFileArgs = {
  input: IGenerateSignedUploadUrlInput
}

export type IQueryWeatherForecastsArgs = {
  weatherForecasts: IWeatherForecastRangeInput
}

export type IQueryWhiteListItemsArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryWorkBreakdownStructureArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryWorkBreakdownStructuresArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryWorkflowConfigurationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryWorkflowLocationRestrictionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export type IQueryWorkflowsCustomFiltersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type IQueryXerProjectsArgs = {
  file: Scalars['String']['input']
}

export type IQueryZoneMapThresholdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  sort?: InputMaybe<ISortBy>
}

export interface IReadBy {
  /** Was message read. */
  isRead: Scalars['Boolean']['output']
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IReadByInput {
  /** Was message read. */
  isRead: Scalars['Boolean']['input']
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export enum RecentlyUpdatedMode {
  DateRange = 'DateRange',
  Last6Week = 'Last6Week',
  LastMonth = 'LastMonth',
  LastP6Update = 'LastP6Update',
  LastWeek = 'LastWeek',
  Today = 'Today',
}

export interface IRecentlyUpdatedSavedFilter {
  /** EndDate. */
  endDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Mode. */
  mode?: Maybe<RecentlyUpdatedMode>
  /** StartDate. */
  startDate?: Maybe<Scalars['MillisecondsDate']['output']>
}

export interface IRecentlyUpdatedSavedFilterInput {
  /** EndDate. */
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Mode. */
  mode?: InputMaybe<RecentlyUpdatedMode>
  /** StartDate. */
  startDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
}

export enum RecipientType {
  Company = 'company',
  DefaultTeams = 'defaultTeams',
  Roles = 'roles',
  Teams = 'teams',
  Trades = 'trades',
  User = 'user',
}

export interface IRecipients {
  /** Recipient ids. */
  ids?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Recipient type. */
  type?: Maybe<RecipientType>
}

export interface IRecipientsInput {
  /** Recipient ids. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Recipient type. */
  type?: InputMaybe<RecipientType>
}

export interface IRecurringDeliveriesSettings {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** End of repeating date. */
  endDate: Scalars['Long']['output']
  /** Frequency of repeating. */
  frequency: Scalars['Short']['output']
  /** Frequency type enum (weeks, days). */
  frequencyType: CalendricalType
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Selected day numbers. */
  selectedDays?: Maybe<Array<Maybe<Scalars['Byte']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IRecurringDeliveriesSettingsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IRecurringDeliveriesSettings>
}

export interface IRecurringDeliveriesSettingsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** End of repeating date. */
  endDate: Scalars['Long']['input']
  /** Frequency of repeating. */
  frequency: Scalars['Short']['input']
  /** Frequency type enum (weeks, days). */
  frequencyType: CalendricalType
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Selected day numbers. */
  selectedDays?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IRecurringOptions {
  /** Is enabled. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Max duration. */
  maxDuration?: Maybe<Scalars['Int']['output']>
}

export interface IRecurringOptionsInput {
  /** Is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Max duration. */
  maxDuration?: InputMaybe<Scalars['Int']['input']>
}

/** Result of recurring workflow creation containing both created workflows and blocked dates information. */
export interface IRecurringWorkflowCreationResult {
  /** Information about blocked workflows grouped by blocking entity. */
  blockedWorkflows: Array<Maybe<IBlockedWorkflowGroup>>
  /** Successfully created workflows. */
  createdWorkflows: Array<Maybe<ISitePermit>>
}

export interface IRecurringWorkflowSettings {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** End of repeating date. */
  endDate: Scalars['Long']['output']
  /** Frequency of repeating. */
  frequency: Scalars['Short']['output']
  /** Frequency type enum (weeks, days). */
  frequencyType: CalendricalType
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Selected day numbers. */
  selectedDays?: Maybe<Array<Maybe<Scalars['Byte']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IRecurringWorkflowSettingsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IRecurringWorkflowSettings>
}

export interface IRecurringWorkflowSettingsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** End of repeating date. */
  endDate: Scalars['Long']['input']
  /** Frequency of repeating. */
  frequency: Scalars['Short']['input']
  /** Frequency type enum (weeks, days). */
  frequencyType: CalendricalType
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Selected day numbers. */
  selectedDays?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export enum RelationshipType {
  ChildOf = 'CHILD_OF',
  ParentOf = 'PARENT_OF',
}

export interface IRelativeActivities {
  /** Predecessors. */
  predecessors: Array<Maybe<IActivity>>
  /** Successors. */
  successors: Array<Maybe<IActivity>>
}

export interface IRemoteTileset {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Source of the remote tileset */
  source: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IRemoteTilesetChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IRemoteTileset>
}

export interface IRemoteTilesetInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Source of the remote tileset */
  source: Scalars['String']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IRemoteTilesetList {
  data: Array<IRemoteTileset>
  page: IPageInfo
}

export interface IReport {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fail reason. */
  failReason?: Maybe<Scalars['ObjectId']['output']>
  /** Failed step. */
  failedStep?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Report url. */
  reportUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Requestor id. */
  requestorId?: Maybe<Scalars['ObjectId']['output']>
  /** User Id. */
  status?: Maybe<ReportStatus>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IReportChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IReport>
}

export interface IReportFileInput {
  /** File id. */
  fileId?: InputMaybe<Scalars['String']['input']>
  /** File name. */
  fileName?: InputMaybe<Scalars['String']['input']>
}

export enum ReportStatus {
  CompilingHandlebarsTemplate = 'COMPILING_HANDLEBARS_TEMPLATE',
  Done = 'DONE',
  Failed = 'FAILED',
  FetchingData = 'FETCHING_DATA',
  GeneratingReport = 'GENERATING_REPORT',
  LoadingTemplates = 'LOADING_TEMPLATES',
  Starting = 'STARTING',
}

export interface IReportTemplate {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Logo url. */
  files?: Maybe<Array<Maybe<IReportTemplateFile>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Report name. */
  name?: Maybe<Scalars['String']['output']>
  /** Template id. */
  templateId?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IReportTemplateFile {
  /** File id. */
  fileId?: Maybe<Scalars['String']['output']>
  /** File type. */
  fileType?: Maybe<FileType>
  /** Report file title. */
  name?: Maybe<Scalars['String']['output']>
}

export interface IResource {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Guid. */
  guid?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Parent resource id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Short name. */
  shortName?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IResourceChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IResource>
}

export interface IResourceControlCascadeResult {
  /** Number of affected permit types. */
  affectedPermitTypeCount: Scalars['Int']['output']
  /** Permit types from which references were (or would be) removed. */
  affectedPermitTypes?: Maybe<Array<IAffectedPermitType>>
  /** Resource ids that could not be disabled (their transaction was rolled back and skipped). */
  failedLocationIds?: Maybe<Array<Scalars['ObjectId']['output']>>
  /** Total number of references removed across all affected permit types. */
  totalRemovals: Scalars['Int']['output']
}

/** Format for resource data export. */
export enum ResourceExportFormat {
  Csv = 'CSV',
  Excel = 'EXCEL',
}

export interface IResourceExportRecordsInput {
  /** Export format (CSV or EXCEL). */
  format: ResourceExportFormat
  /** Property IDs to include. If null, all properties are exported. */
  propertyIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Specific record IDs to export. If null, all records are exported. */
  recordIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** The resource type to export. */
  resourceTypeId: Scalars['String']['input']
  /** Property ID or 'name' to sort by. */
  sortBy?: InputMaybe<Scalars['String']['input']>
  /** Sort direction: 'asc' or 'desc'. */
  sortOrder?: InputMaybe<Scalars['String']['input']>
}

export interface IResourceExportResult {
  data?: Maybe<Scalars['String']['output']>
  filename?: Maybe<Scalars['String']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
}

/** Configuration for resource link properties. */
export interface IResourceLinkConfiguration {
  /** Whether the target can only be linked to one source at a time. */
  exclusive: Scalars['Boolean']['output']
  /** The resource type that can be linked to. */
  targetResourceType: Scalars['String']['output']
}

/** Input for resource-link property configuration. */
export interface IResourceLinkConfigurationInput {
  /** If true, only one link of this kind is allowed per source. */
  exclusive?: InputMaybe<Scalars['Boolean']['input']>
  /** Resource type the link points to (e.g., 'location'). */
  targetResourceType: Scalars['String']['input']
}

export interface IResourceList {
  data: Array<IResource>
  page: IPageInfo
}

/** Defines a custom property that can be added to entities via templates. */
export interface IResourceProperty {
  /** Type-specific configuration. */
  configuration: IPropertyConfiguration
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The user who created this property. */
  createdBy?: Maybe<Scalars['ObjectId']['output']>
  /** Human-readable label. */
  displayName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** If true, property has been archived and is no longer in active use. */
  isArchived: Scalars['Boolean']['output']
  /** If true, property is managed by external system and read-only in UI. */
  isExternal: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Identifier name (snake_case). */
  name: Scalars['String']['output']
  /** Global ordering. */
  position: Scalars['Int']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Type of property. */
  propertyType: PropertyType
  /** The resource type this property belongs to. */
  resourceTypeId: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IResourcePropertyChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IResourceProperty>
}

/** Defines a schema of custom properties that can be applied to entities. */
export interface IResourceTemplate {
  /** Live count of resource records using this template. */
  appliedObjectsCount: Scalars['Int']['output']
  /** Count of non-hidden properties associated with this template — for list views that need a count without the full properties payload. */
  associatedPropertiesCount: Scalars['Int']['output']
  /** Configuration for how entities using this template are displayed as cards. */
  cardConfiguration?: Maybe<ICardConfiguration>
  /** Prefix used for auto-generating resource codes (e.g., 'EQP', 'MAT', 'STG'). */
  codePrefix?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User ID who created this template. */
  createdBy?: Maybe<Scalars['String']['output']>
  /** Optional description of when to use this template. */
  description?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Display name for this template. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Properties included in this template with their settings. */
  properties: Array<ITemplateProperty>
  /** The resource type this template applies to. */
  resourceTypeId: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User ID who last updated this template. */
  updatedBy?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IResourceTemplateChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IResourceTemplate>
}

/** Information about a registered resource type. */
export interface IResourceType {
  /** Optional description. */
  description?: Maybe<Scalars['String']['output']>
  /** Unique identifier (e.g., 'offloading_equipment'). */
  id: Scalars['String']['output']
  /** Display name. */
  name: Scalars['String']['output']
}

export interface IResourcesCustomFilter {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default for users. */
  defaultForUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Filters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<IResourcesFilter>>>
  /** Group By. */
  groupBy?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Resource type Id. */
  resourceTypeId: Scalars['String']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IResourcesCustomFilterInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default for users. */
  defaultForUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Filters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<IResourcesFilterInput>>>
  /** Group By. */
  groupBy?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource type Id. */
  resourceTypeId: Scalars['String']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IResourcesCustomFilterList {
  data: Array<IResourcesCustomFilter>
  page: IPageInfo
}

export interface IResourcesFilter {
  /** Type string. */
  type?: Maybe<Scalars['String']['output']>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IResourcesFilterInput {
  /** Type string. */
  type?: InputMaybe<Scalars['String']['input']>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum RestrictionType {
  MaxDuration = 'MaxDuration',
  MaxOverlapping = 'MaxOverlapping',
}

export interface IRichText {
  /** Attachments. */
  attachments?: Maybe<Array<Maybe<IAttachment>>>
  /** Content. */
  content?: Maybe<Scalars['String']['output']>
}

export interface IRichTextFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IRichTextInput>>>
}

export interface IRichTextFormField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Values. */
  richTextValues?: Maybe<Array<Maybe<IRichText>>>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IRichTextInput {
  /** Attachments. */
  attachments?: InputMaybe<Array<InputMaybe<IAttachmentInput>>>
  /** Content. */
  content?: InputMaybe<Scalars['String']['input']>
}

/** Configuration for rollup properties that aggregate data from linked entities. */
export interface IRollupConfiguration {
  /** Field to aggregate for sum/avg/min/max. */
  aggregateField?: Maybe<Scalars['String']['output']>
  /** Aggregation function: count, sum, avg, min, max. */
  aggregateFunction: Scalars['String']['output']
  /** How the source links to this entity. */
  relationshipType: Scalars['String']['output']
  /** The resource type being aggregated from. */
  sourceResourceType: Scalars['String']['output']
}

/** Input for rollup property configuration. */
export interface IRollupConfigurationInput {
  /** Field to aggregate for sum/avg/min/max. */
  aggregateField?: InputMaybe<Scalars['String']['input']>
  /** Aggregation function: count, sum, avg, min, max. */
  aggregateFunction: Scalars['String']['input']
  /** How the source links to this entity. */
  relationshipType: Scalars['String']['input']
  /** The resource type being aggregated from. */
  sourceResourceType: Scalars['String']['input']
}

export interface IRoute extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IRouteInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISaveMemberModelInput {
  /** Account position. */
  accountPosition?: InputMaybe<UserAccountPosition>
  /** Added by. */
  addedBy?: InputMaybe<Scalars['String']['input']>
  /** Avatar url. */
  avatarUrl?: InputMaybe<Scalars['String']['input']>
  /** Company alias. */
  companyAlias?: InputMaybe<Scalars['String']['input']>
  /** Email. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Optional. Tenant's internal EmployeeId. */
  employeeId?: InputMaybe<Scalars['String']['input']>
  /** External company name. */
  externalCompanyName?: InputMaybe<Scalars['String']['input']>
  /** First name. */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Job title. */
  globalRole?: InputMaybe<Scalars['String']['input']>
  /** Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Initials. */
  initials?: InputMaybe<Scalars['String']['input']>
  /** Hide Users in User Directory. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** Reports to Id. */
  reportsToId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Setup finished. */
  setUpFinished?: InputMaybe<Array<InputMaybe<IProjectSetupFinishedInput>>>
  /** User project settings. */
  userProjectSettings?: InputMaybe<IUserProjectInput>
}

export interface ISaveMessageInput {
  readBy?: InputMaybe<Array<InputMaybe<IReadByInput>>>
  text?: InputMaybe<Scalars['String']['input']>
  thumbUrl?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export interface ISavedViewSettings {
  /** Is hidden */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Upload log custom filter Id */
  resourcesCustomFilterId?: Maybe<Scalars['ObjectId']['output']>
  /** Upload log custom filter Id */
  uploadLogCustomFilterId?: Maybe<Scalars['ObjectId']['output']>
  /** Workflow custom filter Id */
  workflowCustomFilterId?: Maybe<Scalars['ObjectId']['output']>
}

export interface ISavedViewSettingsInput {
  /** Is hidden */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Upload log custom filter Id */
  resourcesCustomFilterId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Upload log custom filter Id */
  uploadLogCustomFilterId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Workflow custom filter Id */
  workflowCustomFilterId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IScanHistory {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Date. */
  date?: Maybe<Scalars['MillisecondsDate']['output']>
  /** End date. */
  endDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** IsAllowed. */
  isAllowed: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Queue date. */
  queueDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** ScannerId. */
  scannerId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** UserId. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IScanHistoryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IScanHistory>
}

export interface IScanHistoryInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Date. */
  date?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** End date. */
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** IsAllowed. */
  isAllowed: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Queue date. */
  queueDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** ScannerId. */
  scannerId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** UserId. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IScanHistoryList {
  data: Array<IScanHistory>
  page: IPageInfo
}

export interface IScanner {
  /** AllowedUsers. */
  allowedUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** AssociatedCodes. */
  associatedCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** BadgeName. */
  badgeName?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is Scanner Active. */
  isActive: Scalars['Boolean']['output']
  /** Is Deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** IsInverted. */
  isInverted: Scalars['Boolean']['output']
  /** Is Open Scanner. */
  isOpenScanner: Scalars['Boolean']['output']
  /** Is Queue Active. */
  isQueueActive: Scalars['Boolean']['output']
  /** Is Queue Scanner. */
  isQueueScanner: Scalars['Boolean']['output']
  /** IsRealLocationRelated. */
  isRealLocationRelated: Scalars['Boolean']['output']
  /** Timer automatically ENDS at close of work day. */
  isTimedByDay: Scalars['Boolean']['output']
  /** Is Timed Scanner. */
  isTimedScanner: Scalars['Boolean']['output']
  /** Location. */
  location?: Maybe<ISiteLocation>
  /** LocationName. */
  locationName?: Maybe<Scalars['String']['output']>
  /** MaxElapsedTime. */
  maxElapsedTime?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IScannerChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IScanner>
}

export interface IScannerInput {
  /** AllowedUsers. */
  allowedUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** AssociatedCodes. */
  associatedCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** BadgeName. */
  badgeName?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is Scanner Active. */
  isActive: Scalars['Boolean']['input']
  /** Is Deleted. */
  isDeleted: Scalars['Boolean']['input']
  /** IsInverted. */
  isInverted: Scalars['Boolean']['input']
  /** Is Open Scanner. */
  isOpenScanner: Scalars['Boolean']['input']
  /** Is Queue Active. */
  isQueueActive: Scalars['Boolean']['input']
  /** Is Queue Scanner. */
  isQueueScanner: Scalars['Boolean']['input']
  /** IsRealLocationRelated. */
  isRealLocationRelated: Scalars['Boolean']['input']
  /** Timer automatically ENDS at close of work day. */
  isTimedByDay: Scalars['Boolean']['input']
  /** Is Timed Scanner. */
  isTimedScanner: Scalars['Boolean']['input']
  /** Location. */
  location?: InputMaybe<ISiteLocationInput>
  /** LocationName. */
  locationName?: InputMaybe<Scalars['String']['input']>
  /** MaxElapsedTime. */
  maxElapsedTime?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IScannerList {
  data: Array<IScanner>
  page: IPageInfo
}

export interface ISchedule {
  /** Number of activities in the file. */
  activityQuantity: Scalars['Int']['output']
  /** Number of companies in the file. */
  companyQuantity: Scalars['Int']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Schedule file name. */
  fileName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Uploader id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IScheduleChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISchedule>
}

export interface IScheduleComparingResult {
  /** Activity codes by types before and after upload. */
  activityCodeTypesForCompare: Array<Maybe<ICategoryForCompare>>
  /** Resources before and after upload. */
  resourceForCompare: ICategoryForCompare
}

export interface IScheduleList {
  data: Array<ISchedule>
  page: IPageInfo
}

export interface IScreen {
  /** Duration of showing screen. */
  duration: Scalars['Int']['output']
  /** Is screen shown. */
  isShown: Scalars['Boolean']['output']
  /** Screen id. */
  key: PresentationScreenKey
  /** Order to be shown. */
  order: Scalars['Int']['output']
}

export interface IScreenInput {
  /** Duration of showing screen. */
  duration: Scalars['Int']['input']
  /** Is screen shown. */
  isShown: Scalars['Boolean']['input']
  /** Screen id. */
  key: PresentationScreenKey
  /** Order to be shown. */
  order: Scalars['Int']['input']
}

/** An option for select-type properties. */
export interface ISelectOption {
  /** If true, option is deprecated but still valid for existing data. */
  deleted: Scalars['Boolean']['output']
  /** Human-readable label displayed in UI. */
  label: Scalars['String']['output']
  /** For Hierarchy properties: the parent option's value. Null/absent for roots and for non-hierarchy types. */
  parentValue?: Maybe<Scalars['String']['output']>
  /** The value stored when this option is selected. */
  value: Scalars['String']['output']
}

/** Input for creating/updating select options. */
export interface ISelectOptionInput {
  /** If true, option is deprecated but still valid for existing data. */
  deleted?: InputMaybe<Scalars['Boolean']['input']>
  /** Human-readable label displayed in UI. */
  label: Scalars['String']['input']
  /** For Hierarchy properties: the parent option's value. Omit for roots and for non-hierarchy types. */
  parentValue?: InputMaybe<Scalars['String']['input']>
  /** The value stored when this option is selected. */
  value: Scalars['String']['input']
}

export interface ISensor extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** External Infuse device identifier. */
  infuseId?: Maybe<Scalars['String']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** The equipment linked to this sensor, if any. */
  linkedEquipment?: Maybe<IOffloadingEquipment>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface ISensorInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** External Infuse device identifier. */
  infuseId?: InputMaybe<Scalars['String']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISharedDelivery {
  /** Booking Id */
  bookingId?: Maybe<Scalars['String']['output']>
  /** Company name */
  companyName?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delivery Id. */
  deliveryId?: Maybe<Scalars['ObjectId']['output']>
  /** Driver phone numbers. */
  driverPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** End date */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Locations From */
  locationsFrom?: Maybe<Array<Maybe<ILocationField>>>
  /** Locations To */
  locationsTo?: Maybe<Array<Maybe<ILocationField>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project from id */
  projectFromId?: Maybe<Scalars['ObjectId']['output']>
  /** Project to id */
  projectToId?: Maybe<Scalars['ObjectId']['output']>
  /** Project from url */
  projectUrl?: Maybe<Scalars['String']['output']>
  /** Responsible */
  responsible?: Maybe<ISharedResponsible>
  /** Start date */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** Delivery Status */
  status?: Maybe<DeliveryStatus>
  /** Tenant name */
  tenantName?: Maybe<Scalars['String']['output']>
  /** Truck number */
  truckNumber?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISharedDeliveryChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISharedDelivery>
}

export interface ISharedResponsible {
  /** Email */
  email?: Maybe<Scalars['String']['output']>
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>
  /** Phone Number */
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export interface ISharedSitePermit {
  /** Company name */
  companyName?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** End date */
  endDate?: Maybe<Scalars['DateTime']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is all day */
  isAllDay?: Maybe<Scalars['Boolean']['output']>
  /** location name */
  locationName?: Maybe<Scalars['String']['output']>
  /** Location url to GMaps */
  locationUrl?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Permit Id. */
  permitId?: Maybe<Scalars['ObjectId']['output']>
  /** Project from id */
  projectFromId?: Maybe<Scalars['ObjectId']['output']>
  /** Project to id */
  projectToId?: Maybe<Scalars['ObjectId']['output']>
  /** Project from url */
  projectUrl?: Maybe<Scalars['String']['output']>
  /** Responsible */
  responsible?: Maybe<ISharedResponsible>
  /** Start date */
  startDate?: Maybe<Scalars['DateTime']['output']>
  /** Site Permit Status */
  status?: Maybe<SitePermitStatus>
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>
  /** Tenant name */
  tenantName?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISharedSitePermitChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISharedSitePermit>
}

export enum SharingMode {
  AllInDateRange = 'AllInDateRange',
  FromRules = 'FromRules',
}

export interface ISheetData {
  /** Column names. */
  columns: Array<Maybe<Scalars['String']['output']>>
  /** Column names to map to. */
  columnsToMapTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Name. */
  name: Scalars['String']['output']
}

export interface ISheetDataInput {
  /** Column names. */
  columns: Array<InputMaybe<Scalars['String']['input']>>
  /** Column names to map to. */
  columnsToMapTo: Array<InputMaybe<Scalars['String']['input']>>
  /** Name. */
  name: Scalars['String']['input']
}

export interface ISignature {
  /** Base64 PNG data URL. */
  dataUrl?: Maybe<Scalars['String']['output']>
  /** Font family for typed signatures. */
  fontFamily?: Maybe<Scalars['String']['output']>
  /** Signature type (Typed or Drawn). */
  signatureType: SignatureType
  /** When signed (milliseconds). */
  timestamp?: Maybe<Scalars['Long']['output']>
  /** Typed value. */
  typedValue?: Maybe<Scalars['String']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

export interface ISignatureInput {
  /** Base64 PNG data URL. */
  dataUrl?: InputMaybe<Scalars['String']['input']>
  /** Font family for typed signatures. */
  fontFamily?: InputMaybe<Scalars['String']['input']>
  /** Signature type (Typed or Drawn). */
  signatureType: SignatureType
  /** When signed (milliseconds). */
  timestamp?: InputMaybe<Scalars['Long']['input']>
  /** Typed value. */
  typedValue?: InputMaybe<Scalars['String']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface ISignaturePermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Values. */
  signatureValues?: Maybe<Array<Maybe<ISignature>>>
  /** Permit field type. */
  type: PermitFieldType
}

export interface ISignaturePermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<ISignatureInput>>>
}

export enum SignatureType {
  Drawn = 'Drawn',
  Typed = 'Typed',
}

export interface ISiteLocation {
  /** Location id. */
  id: Scalars['ObjectId']['output']
  /** Levels. */
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Precise location. */
  preciseLocation?: Maybe<IPreciseLocation>
  /** Location type. */
  type?: Maybe<LocationType>
}

export interface ISiteLocationInput {
  /** Location id. */
  id: Scalars['ObjectId']['input']
  /** Levels. */
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Precise location. */
  preciseLocation?: InputMaybe<IPreciseLocationInput>
  /** Location type. */
  type?: InputMaybe<LocationType>
}

export interface ISitePermit {
  /** Category Id. */
  categoryId?: Maybe<Scalars['ObjectId']['output']>
  /** Site permit code. */
  code?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Created by. */
  createdBy: Scalars['ObjectId']['output']
  /** Current step Id. */
  currentWorkflowStepId: Scalars['ObjectId']['output']
  /** End Date. */
  endDate: Scalars['MillisecondsDate']['output']
  /** Fields. */
  fields?: Maybe<Array<Maybe<IPermitFieldInterface>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Initial type. */
  initialType?: Maybe<Scalars['String']['output']>
  /** Is all day. */
  isAllDay?: Maybe<Scalars['Boolean']['output']>
  /** Is auto activation enabled. */
  isAutoActivationEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Determines whether the workflow is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Is late request. */
  isLateRequest?: Maybe<Scalars['Boolean']['output']>
  /** List of permit Ids linked to this permit. */
  linkedIn?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** List of linked workflow Ids. */
  linkedWorkflows?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Log updated at timestamp. */
  logUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Recurring workflow settings id. */
  recurringSettingsId?: Maybe<Scalars['ObjectId']['output']>
  /** Specific inspection options. */
  specificInspectionOptions?: Maybe<IInspectionOptions>
  /** Start date. */
  startDate: Scalars['MillisecondsDate']['output']
  /** Status. */
  status: SitePermitStatus
  /** Round the current step is in. Every status change starts a new one; only the submissions given in it count toward the step. */
  stepRoundId?: Maybe<Scalars['ObjectId']['output']>
  /** Tracks user submissions for each workflow step, including their field data. */
  stepSubmissions?: Maybe<Array<Maybe<IStepSubmission>>>
  /** Thread Id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** Title. */
  title?: Maybe<Scalars['String']['output']>
  /** Type Id. */
  typeId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow step level. */
  workflowStepLevel?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitAssignment {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Site permit id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['output']
  /** Recipients. */
  recipients: Array<Maybe<IRecipients>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitAssignmentChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermitAssignment>
}

export interface ISitePermitAssignmentInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Site permit id. */
  entityId: Scalars['ObjectId']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Recipients. */
  recipients: Array<InputMaybe<IRecipientsInput>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitePermitAssignmentList {
  data: Array<ISitePermitAssignment>
  page: IPageInfo
}

export interface ISitePermitChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermit>
}

export interface ISitePermitFacets {
  /** Assignee filters. */
  assigneeFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Category filters. */
  categoryFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Company filters. */
  companyFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Equipment filters. */
  equipmentFilters?: Maybe<Array<Maybe<IFacet>>>
  /** File filters. */
  fileFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Location filters. */
  locationFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Status filters. */
  statusFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Type filters. */
  typeFilters?: Maybe<Array<Maybe<IFacet>>>
}

export interface ISitePermitFilterInput {
  /** Assignee Ids. */
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Category Ids. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Company Ids. */
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** End date. */
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Equipment Ids. */
  equipmentIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Files. */
  files?: InputMaybe<Array<InputMaybe<AttachementFileType>>>
  /** Permit Ids. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Include unassigned fields. */
  includeUnassignedFields?: InputMaybe<Array<InputMaybe<PermitFieldType>>>
  /** Initial types. */
  initialTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Location Ids. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Project Id. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Search string. */
  searchString?: InputMaybe<Scalars['String']['input']>
  /** Start date. */
  startDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Statuses. */
  statuses?: InputMaybe<Array<InputMaybe<SitePermitStatus>>>
  /** Permit type Ids. */
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** With all drafts. */
  withAllDrafts?: InputMaybe<Scalars['Boolean']['input']>
  /** With deleted. */
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>
}

export interface ISitePermitFollowing {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitFollowingChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermitFollowing>
}

export interface ISitePermitFollowingInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Entity Id. */
  entityId: Scalars['ObjectId']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitePermitFollowingList {
  data: Array<ISitePermitFollowing>
  page: IPageInfo
}

export interface ISitePermitInput {
  /** Site permit code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Current workflow step Id. */
  currentWorkflowStepId: Scalars['ObjectId']['input']
  /** End date. */
  endDate: Scalars['MillisecondsDate']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is all day. */
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>
  /** Is auto activation enabled. */
  isAutoActivationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** List of linked workflow Ids. */
  linkedWorkflows?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Specific inspection options. */
  specificInspectionOptions?: InputMaybe<IInspectionOptionsInput>
  /** Start date. */
  startDate: Scalars['MillisecondsDate']['input']
  /** Status. */
  status: SitePermitStatus
  /** Thread Id. */
  threadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Title. */
  title?: InputMaybe<Scalars['String']['input']>
  /** Type Id. */
  typeId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Workflow step level. */
  workflowStepLevel: Scalars['Int']['input']
}

export interface ISitePermitInspection {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fields. */
  fields?: Maybe<Array<Maybe<IPermitFieldInterface>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inspection date. */
  inspectionDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Permit Id. */
  permitId: Scalars['ObjectId']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitInspectionChange {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fields. */
  fields?: Maybe<Array<Maybe<IPermitFieldInterface>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Inspection Id . */
  inspectionId: Scalars['ObjectId']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId: Scalars['ObjectId']['output']
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitInspectionChangeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermitInspectionChange>
}

export interface ISitePermitInspectionChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermitInspection>
}

export interface ISitePermitInspectionChangeList {
  data: Array<ISitePermitInspectionChange>
  page: IPageInfo
}

export interface ISitePermitInspectionInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Inspection date. */
  inspectionDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Permit Id. */
  permitId: Scalars['ObjectId']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId: Scalars['ObjectId']['input']
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitePermitInspectionList {
  data: Array<ISitePermitInspection>
  page: IPageInfo
}

export interface ISitePermitList {
  data: Array<ISitePermit>
  page: IPageInfo
}

export enum SitePermitSpecialFieldType {
  LogAttachments = 'LogAttachments',
  WorkflowId = 'WorkflowId',
  WorkflowLog = 'WorkflowLog',
}

export enum SitePermitStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Changed = 'Changed',
  Deleted = 'Deleted',
  Denied = 'Denied',
  Done = 'Done',
  Draft = 'Draft',
  Ended = 'Ended',
  Failed = 'Failed',
  OnSite = 'OnSite',
  Passed = 'Passed',
  Requested = 'Requested',
  Reviewed = 'Reviewed',
  Submitted = 'Submitted',
  ToInspect = 'ToInspect',
}

export interface ISitePermitStatusChange {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Permit Id. */
  permitId?: Maybe<Scalars['ObjectId']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Permit status. */
  status?: Maybe<SitePermitStatus>
  /** Thread Id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow step level. */
  workflowStepLevel?: Maybe<Scalars['Int']['output']>
}

export interface ISitePermitStatusChangeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitePermitStatusChange>
}

export interface ISitePermitStatusChangeList {
  data: Array<ISitePermitStatusChange>
  page: IPageInfo
}

export interface ISitemap {
  /** Altitude. */
  altitude?: Maybe<Scalars['Float']['output']>
  /** Basemap Id. */
  basemapId?: Maybe<Scalars['ObjectId']['output']>
  /** Bearing. */
  bearing?: Maybe<Scalars['Float']['output']>
  /** Earth coordinates of bounding box. */
  bounds?: Maybe<IAddressBounds>
  /** Earth coordinates of the center point. */
  center?: Maybe<ILatLng>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Filled image. */
  filledImage?: Maybe<Scalars['String']['output']>
  /** Earth coordinates of the corner points. */
  geoCorners?: Maybe<Array<Maybe<IGeoJson2DGeographicCoordinates>>>
  /** Height. */
  height?: Maybe<Scalars['Float']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is labels shown. */
  isLabelsShown: Scalars['Boolean']['output']
  items?: Maybe<Array<Maybe<ISitemapSpecificItemData>>>
  /** Items filled image. */
  itemsFilledImage?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Pitch. */
  pitch?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Width. */
  width?: Maybe<Scalars['Float']['output']>
  /** Zoom. */
  zoom?: Maybe<Scalars['Float']['output']>
}

export interface ISitemapChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitemap>
}

export interface ISitemapCircle extends ISitemapItemShapeInterface {
  /** Division end angle. */
  divisionEndAngle?: Maybe<Scalars['Float']['output']>
  /** Division start angle. */
  divisionStartAngle?: Maybe<Scalars['Float']['output']>
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Is divided. */
  isDivided: Scalars['Boolean']['output']
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Position. */
  position?: Maybe<IPosition>
  /** Radius. */
  radius: Scalars['Float']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface ISitemapCircleInput {
  /** Division end angle. */
  divisionEndAngle?: InputMaybe<Scalars['Float']['input']>
  /** Division start angle. */
  divisionStartAngle?: InputMaybe<Scalars['Float']['input']>
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Is divided. */
  isDivided: Scalars['Boolean']['input']
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Position. */
  position?: InputMaybe<IPositionInput>
  /** Radius. */
  radius: Scalars['Float']['input']
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface ISitemapInput {
  /** Altitude. */
  altitude?: InputMaybe<Scalars['Float']['input']>
  /** Basemap Id. */
  basemapId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Bearing. */
  bearing?: InputMaybe<Scalars['Float']['input']>
  /** Earth coordinates of bounding box. */
  bounds?: InputMaybe<IAddressBoundsInput>
  /** Earth coordinates of the center point. */
  center?: InputMaybe<ILatLngInput>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Filled image. */
  filledImage?: InputMaybe<Scalars['String']['input']>
  /** Earth coordinates of the corner points. */
  geoCorners?: InputMaybe<
    Array<InputMaybe<IGeoJson2DGeographicCoordinatesInput>>
  >
  /** Height. */
  height?: InputMaybe<Scalars['Float']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is labels shown. */
  isLabelsShown: Scalars['Boolean']['input']
  /** Items filled image. */
  itemsFilledImage?: InputMaybe<Scalars['String']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Pitch. */
  pitch?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Width. */
  width?: InputMaybe<Scalars['Float']['input']>
  /** Zoom. */
  zoom?: InputMaybe<Scalars['Float']['input']>
}

export interface ISitemapItem {
  /** Assigned Id. */
  assignedId?: Maybe<Scalars['ObjectId']['output']>
  /** Assigned to. */
  assignedTo?: Maybe<LocationType>
  /** Color. */
  color?: Maybe<Scalars['String']['output']>
  /** Coordinates. */
  coordinates?: Maybe<IGeoJson2DGeographicCoordinates>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Icon name. */
  iconName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is referenced. */
  isReferenced?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Coordinates of the shape. */
  shapeCoordinates?: Maybe<ISitemapItemShapeCoordinates>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitemapItemChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitemapItem>
}

export interface ISitemapItemInput {
  /** Assigned Id. */
  assignedId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Assigned to. */
  assignedTo?: InputMaybe<LocationType>
  /** Color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** Coordinates. */
  coordinates?: InputMaybe<IGeoJson2DGeographicCoordinatesInput>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Icon name. */
  iconName?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is referenced. */
  isReferenced?: InputMaybe<Scalars['Boolean']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Coordinates of the shape. */
  shapeCoordinates?: InputMaybe<ISitemapItemShapeCoordinatesInput>
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitemapItemList {
  data: Array<ISitemapItem>
  page: IPageInfo
}

export interface ISitemapItemShapeCoordinates {
  /** Coordinates. For a polyline, the outline of its first part. */
  coordinates?: Maybe<Array<Maybe<IGeoJson2DGeographicCoordinates>>>
  /** Division end angle. */
  divisionEndAngle?: Maybe<Scalars['Float']['output']>
  /** Division start angle. */
  divisionStartAngle?: Maybe<Scalars['Float']['output']>
  /** Is closed. */
  isClosed?: Maybe<Scalars['Boolean']['output']>
  /** Parts of a polyline, largest first. */
  parts?: Maybe<Array<Maybe<ISitemapItemShapePart>>>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface ISitemapItemShapeCoordinatesInput {
  /** Coordinates. */
  coordinates?: InputMaybe<
    Array<InputMaybe<IGeoJson2DGeographicCoordinatesInput>>
  >
  /** Division end angle. */
  divisionEndAngle?: InputMaybe<Scalars['Float']['input']>
  /** Division start angle. */
  divisionStartAngle?: InputMaybe<Scalars['Float']['input']>
  /** Is closed. */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** Parts of a polyline, largest first. */
  parts?: InputMaybe<Array<InputMaybe<ISitemapItemShapePartInput>>>
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export type ISitemapItemShapeInterface = {
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface ISitemapItemShapePart {
  /** Rings. The first is the outline, or the path of an open polyline; any further ring is a hole. */
  rings?: Maybe<Array<Maybe<Array<Maybe<IGeoJson2DGeographicCoordinates>>>>>
}

export interface ISitemapItemShapePartInput {
  /** Rings. The first is the outline, or the path of an open polyline; any further ring is a hole. */
  rings?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<IGeoJson2DGeographicCoordinatesInput>>>>
  >
}

export enum SitemapItemShapeType {
  Circle = 'circle',
  Polyline = 'polyline',
  Rectangle = 'rectangle',
}

export enum SitemapLineArrowPosition {
  None = 'None',
  StartEnd = 'StartEnd',
  StartEndReversed = 'StartEndReversed',
  StartMiddleEnd = 'StartMiddleEnd',
  StartMiddleEndReversed = 'StartMiddleEndReversed',
}

export interface ISitemapList {
  data: Array<ISitemap>
  page: IPageInfo
}

export interface ISitemapPin {
  /** IsHidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Position. */
  position?: Maybe<IPosition>
}

export interface ISitemapPinInput {
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Position. */
  position?: InputMaybe<IPositionInput>
}

export interface ISitemapPolyline extends ISitemapItemShapeInterface {
  /** Arrow position. */
  arrowPosition?: Maybe<SitemapLineArrowPosition>
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Is closed. */
  isClosed: Scalars['Boolean']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Points. */
  points?: Maybe<Array<Maybe<IPosition>>>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
}

export interface ISitemapPolylineInput {
  /** Arrow position. */
  arrowPosition?: InputMaybe<SitemapLineArrowPosition>
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** IsClosed. */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Points. */
  points?: InputMaybe<Array<InputMaybe<IPositionInput>>>
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
}

export interface ISitemapRectangle extends ISitemapItemShapeInterface {
  /** Fill color. */
  fillColor?: Maybe<Scalars['String']['output']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['output']
  /** Height. */
  height: Scalars['Float']['output']
  /** Is item displayed on the map. */
  isDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Line color. */
  lineColor?: Maybe<Scalars['String']['output']>
  /** Line width. */
  lineWidth: Scalars['Int']['output']
  /** Position. */
  position?: Maybe<IPosition>
  /** Rotation. */
  rotation?: Maybe<Scalars['Float']['output']>
  /** Type. */
  type?: Maybe<Scalars['String']['output']>
  /** Width. */
  width: Scalars['Float']['output']
}

export interface ISitemapRectangleInput {
  /** Fill color. */
  fillColor?: InputMaybe<Scalars['String']['input']>
  /** Fill opacity. */
  fillOpacity: Scalars['Float']['input']
  /** Height. */
  height: Scalars['Float']['input']
  /** Is item displayed on the map. */
  isDisplayed?: InputMaybe<Scalars['Boolean']['input']>
  /** Line color. */
  lineColor?: InputMaybe<Scalars['String']['input']>
  /** Line width. */
  lineWidth: Scalars['Int']['input']
  /** Position. */
  position?: InputMaybe<IPositionInput>
  /** Rotation. */
  rotation?: InputMaybe<Scalars['Float']['input']>
  /** Type. */
  type?: InputMaybe<Scalars['String']['input']>
  /** Width. */
  width: Scalars['Float']['input']
}

export interface ISitemapSpecificItemData {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Icon. */
  icon?: Maybe<ISitemapPin>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Label. */
  label?: Maybe<ISitemapTextBox>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Shape. */
  shape?: Maybe<ISitemapItemShapeInterface>
  /** Sitemap Id. */
  sitemapId?: Maybe<Scalars['ObjectId']['output']>
  /** Sitemap item Id. */
  sitemapItemId?: Maybe<Scalars['ObjectId']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ISitemapSpecificItemDataChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ISitemapSpecificItemData>
}

export interface ISitemapSpecificItemDataCircleInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Icon. */
  icon?: InputMaybe<ISitemapPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<ISitemapTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<ISitemapCircleInput>
  /** Sitemap Id. */
  sitemapId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitemapSpecificItemDataPolylineInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Icon. */
  icon?: InputMaybe<ISitemapPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<ISitemapTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<ISitemapPolylineInput>
  /** Sitemap Id. */
  sitemapId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitemapSpecificItemDataRectangleInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Icon. */
  icon?: InputMaybe<ISitemapPinInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Label. */
  label?: InputMaybe<ISitemapTextBoxInput>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Shape. */
  shape?: InputMaybe<ISitemapRectangleInput>
  /** Sitemap Id. */
  sitemapId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Sitemap item Id. */
  sitemapItemId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ISitemapTextBox {
  /** Color. */
  color?: Maybe<Scalars['String']['output']>
  /** Font size. */
  fontSize: Scalars['Int']['output']
  /** Is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** Is text box displayed. */
  isTextBoxDisplayed: Scalars['Boolean']['output']
  /** Position. */
  position?: Maybe<IPosition>
}

export interface ISitemapTextBoxInput {
  /** Color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** Font size. */
  fontSize: Scalars['Int']['input']
  /** Is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Is text box displayed. */
  isTextBoxDisplayed: Scalars['Boolean']['input']
  /** Position. */
  position?: InputMaybe<IPositionInput>
}

export interface ISitemapsSetupSettings {
  /** Last edited sitemap id. */
  lastEditedSitemapId?: Maybe<Scalars['ObjectId']['output']>
}

export interface ISitemapsSetupSettingsInput {
  /** Last edited sitemap id. */
  lastEditedSitemapId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface ISortBy {
  by: Scalars['String']['input']
  order?: InputMaybe<SortDirection>
}

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export enum SourceEntityType {
  Delivery = 'Delivery',
  Form = 'Form',
}

export interface IStaging extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IStagingInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IStartClosureAction extends IPermitActionInterface {
  /** Action Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Mapping of location field ids to lists of specified permit type identifiers. */
  locationFieldsMap?: Maybe<Array<Maybe<IStartClosureActionLocationMap>>>
  /** Type. */
  type?: Maybe<PermitActionType>
}

export interface IStartClosureActionInput {
  /** Action Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Mapping of location field ids to lists of specified permit type identifiers. */
  locationFieldsMap?: InputMaybe<
    Array<InputMaybe<IStartClosureActionLocationMapEntryInput>>
  >
}

export interface IStartClosureActionLocationMap {
  /** Location field id. */
  fieldId: Scalars['ObjectId']['output']
  /** Indicates whether this mapping entry is disabled (excluded from processing). Null means not explicitly set. */
  isDisabled?: Maybe<Scalars['Boolean']['output']>
  /** List of specified permit type identifiers for this field. */
  specifiedPermitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IStartClosureActionLocationMapEntryInput {
  /** Location field id. */
  fieldId: Scalars['ObjectId']['input']
  /** Indicates whether this mapping entry is disabled (excluded from processing). Null means not explicitly set. */
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
  /** List of specified permit type identifiers for this field. */
  specifiedPermitTypes?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >
}

export interface IStatusChange {
  /** Date */
  date?: Maybe<Scalars['String']['output']>
  /** Email */
  email?: Maybe<Scalars['String']['output']>
  /** Status */
  status?: Maybe<Scalars['String']['output']>
  /** User Company */
  userCompany?: Maybe<Scalars['String']['output']>
  /** User Id */
  userId?: Maybe<Scalars['String']['output']>
  /** User Name */
  userName?: Maybe<Scalars['String']['output']>
}

export interface IStatusUpdate {
  /** Activity P6 code. */
  activityP6Code: Scalars['String']['output']
  /** Actual finish date. */
  actualFinishDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Actual start date. */
  actualStartDate?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Author id. */
  authorId: Scalars['ObjectId']['output']
  /** Companies. */
  companies?: Maybe<Array<Maybe<ICompanyStatusUpdate>>>
  /** Company name. */
  companyName?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The date this status update is created for. */
  dateFor: Scalars['MillisecondsDate']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Is inherited. */
  isInherited?: Maybe<Scalars['Boolean']['output']>
  /** Man power. */
  manpower?: Maybe<Scalars['Int']['output']>
  /** Man power updated at. */
  manpowerUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Percent complete. */
  percentComplete?: Maybe<Scalars['Int']['output']>
  /** Percent complete updated at. */
  percentCompleteUpdatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Planned percent complete. */
  plannedPercentComplete?: Maybe<Scalars['Float']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Thread id. */
  threadId?: Maybe<Scalars['ObjectId']['output']>
  /** Type. */
  type?: Maybe<StatusUpdateType>
  /** Update version. */
  updateVersion?: Maybe<Scalars['Int']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IStatusUpdateChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IStatusUpdate>
}

export interface IStatusUpdateCompanyInput {
  /** Manpower. */
  manpower?: InputMaybe<Scalars['Int']['input']>
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Percent complete. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
}

export interface IStatusUpdateDateInput {
  /** Man power. */
  manpower?: InputMaybe<Scalars['Int']['input']>
  /** Percent complete. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
  /** Timezone id. */
  timezoneId: Scalars['String']['input']
  /** Unix time. */
  unixTime: Scalars['MillisecondsDate']['input']
}

export interface IStatusUpdateInput {
  /** Activity P6 code. */
  activityP6Code: Scalars['String']['input']
  /** Actual finish date. */
  actualFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Actual start date. */
  actualStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Author id. */
  authorId: Scalars['ObjectId']['input']
  /** Companies. */
  companies?: InputMaybe<Array<InputMaybe<ICompanyStatusUpdateInput>>>
  /** Company name. */
  companyName?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The date this status update is created for. */
  dateFor: Scalars['MillisecondsDate']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is deleted. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  /** Is inherited. */
  isInherited?: InputMaybe<Scalars['Boolean']['input']>
  /** Man power. */
  manpower?: InputMaybe<Scalars['Int']['input']>
  /** Man power updated at. */
  manpowerUpdatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Percent complete. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
  /** Percent complete updated at. */
  percentCompleteUpdatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Planned percent complete. */
  plannedPercentComplete?: InputMaybe<Scalars['Float']['input']>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Thread id. */
  threadId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Type. */
  type?: InputMaybe<StatusUpdateType>
  /** Update version. */
  updateVersion?: InputMaybe<Scalars['Int']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IStatusUpdateList {
  data: Array<IStatusUpdate>
  page: IPageInfo
}

export interface IStatusUpdateMultiCompaniesInput {
  /** Actual finish date. */
  actualFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Actual start date. */
  actualStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Companies. */
  companies?: InputMaybe<Array<InputMaybe<IStatusUpdateCompanyInput>>>
  /** Type. */
  type?: InputMaybe<StatusUpdateType>
  /** Unix time. */
  unixTime: Scalars['MillisecondsDate']['input']
}

export enum StatusUpdateType {
  Active = 'Active',
  Bulk = 'Bulk',
  Change = 'Change',
  Missed = 'Missed',
  P6 = 'P6',
  Recalc = 'Recalc',
  SetDate = 'SetDate',
}

export interface IStepSubmission {
  /** Field values submitted by this user for this step. */
  fields?: Maybe<Array<Maybe<IPermitFieldInterface>>>
  /** Round of the step this submission was given in. Only the current round's submissions count toward the step. */
  roundId?: Maybe<Scalars['ObjectId']['output']>
  /** Ball-in-court rule this submission counts toward, on a step that needs one sign-off per rule. */
  ruleId?: Maybe<Scalars['ObjectId']['output']>
  /** Workflow step ID. */
  stepId: Scalars['ObjectId']['output']
  /** Timestamp when the submission was made. */
  submittedAt: Scalars['MillisecondsDate']['output']
  /** User ID who submitted this step. */
  userId: Scalars['ObjectId']['output']
}

export interface IStepSubmissionInput {
  /** Field values submitted by this user for this step. */
  fields?: InputMaybe<IPermitFieldsInput>
  /** Round of the step this submission was given in. Only the current round's submissions count toward the step. */
  roundId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Ball-in-court rule this submission counts toward, on a step that needs one sign-off per rule. */
  ruleId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Workflow step ID. */
  stepId: Scalars['ObjectId']['input']
  /** Timestamp when the submission was made. */
  submittedAt: Scalars['MillisecondsDate']['input']
  /** User ID who submitted this step. */
  userId: Scalars['ObjectId']['input']
}

export interface IStringPair {
  /** The Key. */
  key?: Maybe<Scalars['String']['output']>
  /** The Value. */
  value?: Maybe<Scalars['String']['output']>
}

export interface IStringPairInput {
  /** The Key. */
  key?: InputMaybe<Scalars['String']['input']>
  /** The Value. */
  value?: InputMaybe<Scalars['String']['input']>
}

export interface IStringPermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Values. */
  stringValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Permit field type. */
  type: PermitFieldType
}

export interface IStringPermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface IStruxHubCompany {
  /** Company address. */
  address?: Maybe<ICompanyAddress>
  /** Avatar URL. */
  avatarUrl?: Maybe<Scalars['String']['output']>
  /** Business email. */
  businessEmail?: Maybe<Scalars['String']['output']>
  /** Business phone. */
  businessPhone?: Maybe<Scalars['String']['output']>
  /** Company code. */
  code?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** DBA. */
  dba?: Maybe<Scalars['String']['output']>
  /** FavIcon URL. */
  favIconUrl?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** License number. */
  licenseNumber?: Maybe<Scalars['String']['output']>
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Company name. */
  name?: Maybe<Scalars['String']['output']>
  /** Company relationships. */
  relationships?: Maybe<Array<Maybe<IEntityRelationship>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IStruxHubCompanyList {
  data: Array<IStruxHubCompany>
  page: IPageInfo
}

export interface IStruxTagActivitySession {
  createdAt?: Maybe<Scalars['Long']['output']>
  derivationVersion?: Maybe<Scalars['String']['output']>
  durationMs?: Maybe<Scalars['Long']['output']>
  endedAt?: Maybe<Scalars['Long']['output']>
  id?: Maybe<Scalars['ObjectId']['output']>
  idleDurationMs?: Maybe<Scalars['Long']['output']>
  infuseId?: Maybe<Scalars['String']['output']>
  movingDurationMs?: Maybe<Scalars['Long']['output']>
  projectId?: Maybe<Scalars['String']['output']>
  segments?: Maybe<Array<Maybe<IStruxTagActivitySessionSegment>>>
  startedAt?: Maybe<Scalars['Long']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['Long']['output']>
}

export interface IStruxTagActivitySessionSegment {
  durationMs?: Maybe<Scalars['Long']['output']>
  endedAt?: Maybe<Scalars['Long']['output']>
  startedAt?: Maybe<Scalars['Long']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export interface IStruxTagGpsPath {
  segments: Array<IStruxTagGpsPathSegment>
  summary: IStruxTagGpsPathSummary
}

export interface IStruxTagGpsPathPoint {
  hAcc: Scalars['Float']['output']
  height?: Maybe<Scalars['Float']['output']>
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  timestamp: Scalars['DateTime']['output']
}

export interface IStruxTagGpsPathSegment {
  points: Array<IStruxTagGpsPathPoint>
}

export interface IStruxTagGpsPathSummary {
  averageSpeedMps?: Maybe<Scalars['Float']['output']>
  distanceMeters: Scalars['Float']['output']
  endedAt?: Maybe<Scalars['DateTime']['output']>
  maxSpeedMps?: Maybe<Scalars['Float']['output']>
  pointCount: Scalars['Int']['output']
  startedAt?: Maybe<Scalars['DateTime']['output']>
}

export interface IStruxTagUtilization {
  days: Array<IStruxTagUtilizationDay>
  percentDaysUsed?: Maybe<Scalars['Int']['output']>
  shiftHours: Scalars['Float']['output']
  totalHours: Scalars['Float']['output']
  utilizationRate?: Maybe<Scalars['Float']['output']>
  windowEnd: Scalars['String']['output']
  windowStart: Scalars['String']['output']
}

export interface IStruxTagUtilizationDay {
  date: Scalars['String']['output']
  hours: Scalars['Float']['output']
  isToday: Scalars['Boolean']['output']
  isWorkingDay: Scalars['Boolean']['output']
  overtimeHours: Scalars['Float']['output']
  /** Scheduled shift length for this specific weekday, in hours. */
  shiftHours: Scalars['Float']['output']
}

export interface ISubscription {
  activitiesConfigurations?: Maybe<IActivitiesConfigurationsChangeEvent>
  activity?: Maybe<IActivityChangeEvent>
  activityAssignment?: Maybe<IActivityAssignmentChangeEvent>
  activityCode?: Maybe<IActivityCodeChangeEvent>
  activityCodeRelationship?: Maybe<IActivityCodeRelationshipChangeEvent>
  activityCodeType?: Maybe<IActivityCodeTypeChangeEvent>
  activityFollowing?: Maybe<IActivityFollowingChangeEvent>
  activityLocation?: Maybe<IActivityLocationChangeEvent>
  activityPreset?: Maybe<IActivityPresetChangeEvent>
  activityResourceRelationship?: Maybe<IActivityResourceRelationshipChangeEvent>
  analyticsSettings?: Maybe<IAnalyticsSettingsChangeEvent>
  basemap?: Maybe<IBasemapChangeEvent>
  castAssignment?: Maybe<ICastAssignmentChangeEvent>
  castFollowing?: Maybe<ICastFollowingChangeEvent>
  closure?: Maybe<IClosureChangeEvent>
  closureAssignment?: Maybe<IClosureAssignmentChangeEvent>
  closureFollowing?: Maybe<IClosureFollowingChangeEvent>
  company?: Maybe<ICompanyChangeEvent>
  companyRelationship?: Maybe<ICompanyRelationshipChangeEvent>
  companyTypeTag?: Maybe<IEntityTagChangeEvent>
  concreteDirectOrder?: Maybe<IConcreteDirectOrderChangeEvent>
  concreteDirectPayload?: Maybe<IConcreteDirectPayloadChangeEvent>
  configuration?: Maybe<IConfigurationChangeEvent>
  constraint?: Maybe<IConstraintChangeEvent>
  contentObject?: Maybe<IContentObjectChangeEvent>
  delivery?: Maybe<IDeliveryChangeEvent>
  deliveryAssignment?: Maybe<IDeliveryAssignmentChangeEvent>
  deliveryConfigurations?: Maybe<IDeliveryConfigurationsChangeEvent>
  deliveryFieldsConfigurations?: Maybe<IDeliveryFieldsConfigurationsChangeEvent>
  deliveryFollowing?: Maybe<IDeliveryFollowingChangeEvent>
  deliveryStatusChange?: Maybe<IDeliveryStatusChangeChangeEvent>
  deliveryUnit?: Maybe<IDeliveryUnitChangeEvent>
  deliveryVehicleType?: Maybe<IDeliveryVehicleTypeChangeEvent>
  formCategory?: Maybe<IFormCategoryChangeEvent>
  globeView?: Maybe<IGlobeViewChangeEvent>
  globeViewSpecificItemData?: Maybe<IGlobeViewSpecificItemDataChangeEvent>
  jobsiteConfiguration?: Maybe<IJobsiteConfigurationChangeEvent>
  location?: Maybe<ILocationChangeEvent>
  logisticsConfigurations?: Maybe<ILogisticsConfigurationsChangeEvent>
  markup?: Maybe<IMarkupChangeEvent>
  materialConfiguration?: Maybe<IMaterialConfigurationChangeEvent>
  message?: Maybe<IMessageChangeEvent>
  notification?: Maybe<INotificationChangeEvent>
  operationRule?: Maybe<IOperationRuleChangeEvent>
  permitType?: Maybe<IPermitTypeChangeEvent>
  photo?: Maybe<IPhotoChangeEvent>
  presentationSettings?: Maybe<IPresentationSettingsChangeEvent>
  project?: Maybe<IProjectChangeEvent>
  projectAddress?: Maybe<IProjectAddressChangeEvent>
  projectColoringOptions?: Maybe<IProjectColoringOptionsChangeEvent>
  projectHistory?: Maybe<IProjectHistoryChangeEvent>
  projectMaterial?: Maybe<IProjectMaterialChangeEvent>
  projectMaterialCategory?: Maybe<IProjectMaterialCategoryChangeEvent>
  projectMaterialOptions?: Maybe<IProjectMaterialOptionsChangeEvent>
  projectStatusUpdateOptions?: Maybe<IProjectStatusUpdateOptionsChangeEvent>
  projectTypeOptions?: Maybe<IProjectTypeOptionsChangeEvent>
  recurringDeliveriesSettings?: Maybe<IRecurringDeliveriesSettingsChangeEvent>
  recurringWorkflowSettings?: Maybe<IRecurringWorkflowSettingsChangeEvent>
  remoteTileset?: Maybe<IRemoteTilesetChangeEvent>
  report?: Maybe<IReportChangeEvent>
  resource?: Maybe<IResourceChangeEvent>
  resourceProperty?: Maybe<IResourcePropertyChangeEvent>
  resourceTemplate?: Maybe<IResourceTemplateChangeEvent>
  scanHistory?: Maybe<IScanHistoryChangeEvent>
  scanner?: Maybe<IScannerChangeEvent>
  schedule?: Maybe<IScheduleChangeEvent>
  sharedDelivery?: Maybe<ISharedDeliveryChangeEvent>
  sharedSitePermit?: Maybe<ISharedSitePermitChangeEvent>
  sitePermit?: Maybe<ISitePermitChangeEvent>
  sitePermitAssignment?: Maybe<ISitePermitAssignmentChangeEvent>
  sitePermitFollowing?: Maybe<ISitePermitFollowingChangeEvent>
  sitePermitInspection?: Maybe<ISitePermitInspectionChangeEvent>
  sitePermitInspectionChange?: Maybe<ISitePermitInspectionChangeChangeEvent>
  sitePermitStatusChange?: Maybe<ISitePermitStatusChangeChangeEvent>
  sitemap?: Maybe<ISitemapChangeEvent>
  sitemapItem?: Maybe<ISitemapItemChangeEvent>
  sitemapSpecificItemData?: Maybe<ISitemapSpecificItemDataChangeEvent>
  statusUpdate?: Maybe<IStatusUpdateChangeEvent>
  team?: Maybe<ITeamChangeEvent>
  thread?: Maybe<IThreadChangeEvent>
  tileset?: Maybe<ITilesetChangeEvent>
  trade?: Maybe<ITradeChangeEvent>
  transferProjectDataProgress?: Maybe<ITransferProjectDataProgressChangeEvent>
  uploadLogConfiguration?: Maybe<IUploadLogConfigurationChangeEvent>
  uploadLogCustomFilter?: Maybe<IUploadLogCustomFilterChangeEvent>
  uploadMaterialsProgress?: Maybe<IUploadMaterialsProgressChangeEvent>
  uploadScheduleProgress?: Maybe<IUploadScheduleProgressChangeEvent>
  user?: Maybe<IUserChangeEvent>
  userProject?: Maybe<IUserProjectChangeEvent>
  userRole?: Maybe<IUserRoleChangeEvent>
  weatherForecast?: Maybe<IWeatherForecastChangeEvent>
  whiteListItem?: Maybe<IWhiteListItemChangeEvent>
  workflowConfigurations?: Maybe<IWorkflowConfigurationsChangeEvent>
  workflowLocationRestriction?: Maybe<IWorkflowLocationRestrictionChangeEvent>
  zoneMapThresholds?: Maybe<IZoneMapThresholdsChangeEvent>
}

export type ISubscriptionActivitiesConfigurationsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionActivityArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionActivityAssignmentArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionActivityCodeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionActivityCodeRelationshipArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionActivityCodeTypeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionActivityFollowingArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionActivityLocationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionActivityPresetArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionActivityResourceRelationshipArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionAnalyticsSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionBasemapArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionCastAssignmentArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionCastFollowingArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionClosureArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionClosureAssignmentArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionClosureFollowingArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionCompanyArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionCompanyRelationshipArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionCompanyTypeTagArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionConcreteDirectOrderArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionConcreteDirectPayloadArgs = {
  cdOrderId?: InputMaybe<Scalars['Guid']['input']>
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ISubscriptionConstraintArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionContentObjectArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryAssignmentArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryConfigurationsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryFieldsConfigurationsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryFollowingArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryStatusChangeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryUnitArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionDeliveryVehicleTypeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionFormCategoryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionGlobeViewArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionGlobeViewSpecificItemDataArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionJobsiteConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionLocationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionLogisticsConfigurationsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionMarkupArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionMaterialConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionMessageArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionNotificationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionOperationRuleArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionPermitTypeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionPhotoArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionPresentationSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectAddressArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectColoringOptionsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectHistoryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectMaterialArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectMaterialCategoryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  materialsUploadId?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectMaterialOptionsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectStatusUpdateOptionsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionProjectTypeOptionsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionRecurringDeliveriesSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionRecurringWorkflowSettingsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionRemoteTilesetArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionReportArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionResourceArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  scheduleId: Scalars['ObjectId']['input']
}

export type ISubscriptionResourcePropertyArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionResourceTemplateArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionScanHistoryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionScannerArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionScheduleArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSharedDeliveryArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectToId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSharedSitePermitArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectToId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitArgs = {
  currentUserId?: InputMaybe<Scalars['ObjectId']['input']>
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitAssignmentArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitFollowingArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitInspectionArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitInspectionChangeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitePermitStatusChangeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  permitId?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitemapArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitemapItemArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionSitemapSpecificItemDataArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionStatusUpdateArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionTeamArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionThreadArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionTilesetArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionTradeArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionTransferProjectDataProgressArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  operationId?: InputMaybe<Scalars['String']['input']>
}

export type ISubscriptionUploadLogConfigurationArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionUploadLogCustomFilterArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionUploadMaterialsProgressArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionUploadScheduleProgressArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId: Scalars['ObjectId']['input']
}

export type ISubscriptionUserArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionUserProjectArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  userId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionUserRoleArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionWeatherForecastArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionWhiteListItemArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionWorkflowConfigurationsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionWorkflowLocationRestrictionArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export type ISubscriptionZoneMapThresholdsArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface ISuggestedMapping {
  columnHeader: Scalars['String']['output']
  columnIndex: Scalars['Int']['output']
  field?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  propertyName?: Maybe<Scalars['String']['output']>
}

export interface ISummaryField {
  /** Field id. */
  fieldId?: Maybe<Scalars['ObjectId']['output']>
  /** Name. */
  name?: Maybe<Scalars['String']['output']>
}

export interface ISummaryFieldInput {
  /** Field id. */
  fieldId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>
}

export interface ITablePermitField extends IPermitFieldInterface {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['output']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['output']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: Maybe<Scalars['ObjectId']['output']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: Maybe<Scalars['Int']['output']>
  /** Values. */
  tableValues?: Maybe<Array<Maybe<ITableRowPermitField>>>
  /** Permit field type. */
  type: PermitFieldType
}

export interface ITablePermitFieldInput {
  /** Field Id. */
  fieldId: Scalars['ObjectId']['input']
  /** Instance Id. */
  instanceId: Scalars['ObjectId']['input']
  /** Parent instance id. Used for conditional fields. */
  parentInstanceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Index of the parent value. Used for referencing specific values. */
  parentValueIndex?: InputMaybe<Scalars['Int']['input']>
  /** Permit field type. */
  type: PermitFieldType
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<IPermitFieldsInput>>>
}

export interface ITableRowPermitField {
  /** Cells. */
  cells?: Maybe<Array<Maybe<IPermitFieldInterface>>>
}

export interface ITeam {
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ITeamChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ITeam>
}

export interface ITeamInput {
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ITeamList {
  data: Array<ITeam>
  page: IPageInfo
}

/** Defines how a property is used within a specific template. */
export interface ITemplateProperty {
  /** Default value as string. */
  defaultValue?: Maybe<Scalars['String']['output']>
  /** Whether this property is hidden in UI. */
  isHidden: Scalars['Boolean']['output']
  /** Whether this property is required. */
  isRequired: Scalars['Boolean']['output']
  /** Display order within this template. */
  orderIndex: Scalars['Int']['output']
  /** The full property definition. */
  property?: Maybe<IResourceProperty>
  /** Reference to the ResourceProperty definition. */
  propertyId: Scalars['ObjectId']['output']
  /** Cached property name for quick lookup. */
  propertyName: Scalars['String']['output']
}

/** Input for properties within a template. */
export interface ITemplatePropertyInput {
  /** Default value for new entities. */
  defaultValue?: InputMaybe<Scalars['String']['input']>
  /** Whether this property is hidden in UI. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this property is required. */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Display order within this template. */
  orderIndex: Scalars['Int']['input']
  /** Reference to the ResourceProperty definition. */
  propertyId: Scalars['ObjectId']['input']
}

/** Input for updating property settings within a template. */
export interface ITemplatePropertySettingsInput {
  /** Default value for new entities. */
  defaultValue?: InputMaybe<Scalars['String']['input']>
  /** Whether this property is hidden in UI. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this property is required. */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Display order within this template. */
  orderIndex?: InputMaybe<Scalars['Int']['input']>
}

/** Result of querying active user details across all projects in a tenant within a time period. */
export interface ITenantActiveUsersDetailsResult {
  /** List of unique active users with their details (deduplicated across all projects). */
  activeUsers?: Maybe<Array<Maybe<IActiveUserDetails>>>
  /** End of the query period (exclusive), as epoch milliseconds. */
  periodEnd?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Start of the query period (inclusive), as epoch milliseconds. */
  periodStart?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The tenant (company) name. */
  tenantName?: Maybe<Scalars['String']['output']>
}

/** Result of querying active users across all projects in a tenant within a time period. */
export interface ITenantActiveUsersResult {
  /** Number of unique active users across all projects in the period. */
  activeUserCount?: Maybe<Scalars['Int']['output']>
  /** End of the query period (exclusive), as epoch milliseconds. */
  periodEnd?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Start of the query period (inclusive), as epoch milliseconds. */
  periodStart?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The tenant (company) name. */
  tenantName?: Maybe<Scalars['String']['output']>
}

export interface ITenantLink {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project events producer id */
  projectFromId?: Maybe<Scalars['ObjectId']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Tenant endpoint to fetch events */
  tenantCalendarEndpoint?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ITenantLinkList {
  data: Array<ITenantLink>
  page: IPageInfo
}

export interface IThread {
  activityObjectId?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IThreadChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IThread>
}

export interface IThreadInput {
  activityObjectId?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IThreadList {
  data: Array<IThread>
  page: IPageInfo
}

export enum ThresholdUnit {
  Number = 'number',
  Percent = 'percent',
}

export interface ITileset {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Errors. */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** IsProcessed. */
  isProcessed: Scalars['Boolean']['output']
  /** Mapbox data. */
  mapboxData?: Maybe<IMapboxTilesetData>
  /** MapboxTilesetId. */
  mapboxTilesetId: Scalars['String']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Status. */
  status?: Maybe<TilesetProcessingStatus>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Upload Id. */
  uploadId?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ITilesetChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ITileset>
}

export interface ITilesetInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Errors. */
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** IsProcessed. */
  isProcessed: Scalars['Boolean']['input']
  /** MapboxTilesetId. */
  mapboxTilesetId: Scalars['String']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Status. */
  status?: InputMaybe<TilesetProcessingStatus>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** MapboxTilesetId. */
  uploadId?: InputMaybe<Scalars['String']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ITilesetList {
  data: Array<ITileset>
  page: IPageInfo
}

export enum TilesetProcessingStatus {
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success',
  Superseded = 'superseded',
}

export interface ITilesetsConfiguration {
  /** Max number of tilesets to upload. */
  maxNumber: Scalars['Int']['output']
  /** Max size of tileset file to upload. */
  maxSize?: Maybe<Scalars['String']['output']>
}

export interface ITimePeriodValidationResult {
  /** Whether all locations are valid for this time period. */
  isValid?: Maybe<Scalars['Boolean']['output']>
  /** The validation results for each location during this time period. */
  locationResults?: Maybe<Array<Maybe<ILocationRestrictionCheckResult>>>
  /** The time period that was validated. */
  timePeriod?: Maybe<IDateInterval>
}

export interface ITrade {
  /** Color. */
  color?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface ITradeChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ITrade>
}

export interface ITradeInput {
  /** Color. */
  color?: InputMaybe<Scalars['String']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface ITradeList {
  data: Array<ITrade>
  page: IPageInfo
}

export enum TransferNotificationEnum {
  CompaniesFinished = 'CompaniesFinished',
  CompanyFailure = 'CompanyFailure',
  CopyingCompanies = 'CopyingCompanies',
  CopyingForms = 'CopyingForms',
  CopyingMaterials = 'CopyingMaterials',
  CopyingUsers = 'CopyingUsers',
  Custom = 'Custom',
  FormsFailure = 'FormsFailure',
  FormsFinished = 'FormsFinished',
  Initiate = 'Initiate',
  MaterialsFailure = 'MaterialsFailure',
  MaterialsFinished = 'MaterialsFinished',
  UsersFailure = 'UsersFailure',
  UsersFinished = 'UsersFinished',
}

export interface ITransferProjectDataProgressChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<ITransferProjectProgressGraphType>
}

export interface ITransferProjectDefinitionsGraphType {
  /** list of definitions if should copy all for each APP */
  all?: InputMaybe<ICopyAllGraphType>
  /** Companies */
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Forms */
  forms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** ID */
  id?: InputMaybe<Scalars['String']['input']>
  /** Material Groups */
  materialGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Materials */
  materials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Template Name */
  name?: InputMaybe<Scalars['String']['input']>
  /** Operation ID */
  operationId?: InputMaybe<Scalars['String']['input']>
  /** Overwriting Forms */
  overwritingForms?: InputMaybe<Scalars['Boolean']['input']>
  /** Project Destination */
  projectDestination?: InputMaybe<Scalars['ObjectId']['input']>
  /** Project Source */
  projectSource?: InputMaybe<Scalars['ObjectId']['input']>
  /** Tenant Name */
  tenantName?: InputMaybe<Scalars['String']['input']>
  /** User Companies */
  userCompanies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Users */
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface ITransferProjectProgressGraphType {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Message */
  message?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** OperationId */
  operationId?: Maybe<Scalars['String']['output']>
  /** Project Destination */
  projectDestination: Scalars['ObjectId']['output']
  /** Project Source */
  projectSource: Scalars['ObjectId']['output']
  /** Status. */
  status: TransferNotificationEnum
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

/** Graph type for TypeFieldFilterOptions. */
export interface ITypeFieldFilterOptions {
  /** The dependent field ID for field-based filtering. */
  fieldId?: Maybe<Scalars['String']['output']>
  /** The values from the dependent field that trigger this filter. */
  fieldValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The conditional type used for filtering. */
  operator: OperatorType
  /** The property path to filter on. */
  propertyPath?: Maybe<Scalars['String']['output']>
  /** The list of filter values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** Input graph type for TypeFieldFilterOptions. */
export interface ITypeFieldFilterOptionsInput {
  /** The dependent field ID for field-based filtering. */
  fieldId?: InputMaybe<Scalars['String']['input']>
  /** The values from the dependent field that trigger this filter. */
  fieldValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The conditional type used for filtering. */
  operator: OperatorType
  /** The property path to filter on. */
  propertyPath?: InputMaybe<Scalars['String']['input']>
  /** The list of filter values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface IUpdateActivitiesFieldsInput {
  /** Activity linking settings. */
  activityLinkingSettings?: InputMaybe<IActivityLinkingSettingsInput>
  /** Actual finish date. */
  actualFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Actual start date. */
  actualStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Calendar id. */
  calendarId?: InputMaybe<Scalars['ObjectId']['input']>
  /** P6 code being used as Id. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Company id. */
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Activity id. */
  id: Scalars['ObjectId']['input']
  /** Locations. */
  locations?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Message. */
  message?: InputMaybe<ISaveMessageInput>
  /** Activity on time status. */
  onTimeStatus?: InputMaybe<OnTimeStatus>
  /** Activity complete percent. */
  percentComplete?: InputMaybe<Scalars['Int']['input']>
  /** Planned finish date. */
  plannedFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Planned start date. */
  plannedStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Remaining early finish date. */
  remainingEarlyFinishDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Remaining early start date. */
  remainingEarlyStartDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Requester id. */
  requesterId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Resource id. */
  resourceId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Activity status. */
  status?: InputMaybe<ActivityStatus>
  /** Total float. */
  totalFloat?: InputMaybe<Scalars['Float']['input']>
  /** Work breakdown structure id. */
  workBreakdownStructureId?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IUpdateDeliveriesFieldsInput {
  /** Activity Id. */
  activityId?: InputMaybe<Scalars['String']['input']>
  /** Company. */
  company?: InputMaybe<Scalars['ObjectId']['input']>
  /** Delivery ids. */
  deliveryIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
  /** Driver phone numbers. */
  driverPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** EndDate. */
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Inspector user Id. */
  inspector?: InputMaybe<Scalars['ObjectId']['input']>
  /** Installation zone. */
  installationZone?: InputMaybe<Scalars['String']['input']>
  /** Is inspection required. */
  isInspectionRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Delivery location from. */
  locationsFrom?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Delivery location to. */
  locationsTo?: InputMaybe<Array<InputMaybe<ISiteLocationInput>>>
  /** Materials. */
  materials?: InputMaybe<Array<InputMaybe<IDeliveryMaterialInput>>>
  /** Message. */
  message?: InputMaybe<ISaveMessageInput>
  /** Node. */
  note?: InputMaybe<Scalars['String']['input']>
  /** Number of equipment picks. */
  numberOfEquipmentPicks?: InputMaybe<Scalars['String']['input']>
  /** Offloading equipments. */
  offloadingEquipments?: InputMaybe<Array<InputMaybe<IDeliveryAttributeInput>>>
  /** On site contact person ids. */
  onSiteContactPersonIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Sitemap urls. */
  sitemapUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** StartDate. */
  startDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Timezone id. */
  timezoneId: Scalars['String']['input']
  /** Truck license plate. */
  truckLicensePlate?: InputMaybe<Scalars['String']['input']>
  /** Truck number. */
  truckNumber?: InputMaybe<Scalars['String']['input']>
  /** Truck size. */
  truckSize?: InputMaybe<Scalars['ObjectId']['input']>
  /** Vendor. */
  vendor?: InputMaybe<Scalars['ObjectId']['input']>
  /** Vendor emails. */
  vendorEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export interface IUpdateLocationsIsBookableInput {
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['input']
  /** Location ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
}

export interface IUpdateLocationsOperatingIntervalsInput {
  /** Location ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
}

export interface IUpdateLocationsPermittedCompaniesInput {
  /** Location ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Permitted companies. */
  permittedCompanies: Array<Scalars['ObjectId']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
}

export interface IUpdateLocationsShowInMapInput {
  /** Location ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['input']
}

export interface IUpdateLocationsWorkflowTypesInput {
  /** Location ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Workflow type ids. */
  workflowTypes: Array<Scalars['ObjectId']['input']>
}

export interface IUpdateResourceControlsInput {
  /** Non-permit date closures; omit to leave unchanged, empty to clear. */
  closures?: InputMaybe<Array<ILocationClosureIntervalInput>>
  /** Workflow-resource (bookable) flag; omit to leave unchanged. */
  isBookable?: InputMaybe<Scalars['Boolean']['input']>
  /** Resource (location) ids to update. */
  locationIds: Array<Scalars['ObjectId']['input']>
  /** Operating intervals; omit to leave unchanged, empty to clear. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Permitted company ids; omit to leave unchanged, empty to clear. */
  permittedCompanies?: InputMaybe<Array<Scalars['ObjectId']['input']>>
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Workflow restrictions (max duration / max overlapping); omit to leave unchanged, empty to clear. */
  workflowRestrictions?: InputMaybe<
    Array<IUpdateResourceControlsRestrictionInput>
  >
  /** Permitted workflow type ids; omit to leave unchanged, empty to clear. */
  workflowTypes?: InputMaybe<Array<Scalars['ObjectId']['input']>>
}

export interface IUpdateResourceControlsRestrictionInput {
  /** Type of restriction. */
  restrictionType: RestrictionType
  /** Restriction values. */
  values?: InputMaybe<Array<Scalars['String']['input']>>
  /** Workflow ids impacted by this restriction. */
  workflowIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>
}

/** Input for updating an existing property definition. */
export interface IUpdateResourcePropertyInput {
  /** Type-specific configuration. */
  configuration?: InputMaybe<IPropertyConfigurationInput>
  /** Human-readable label for UI display. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** If true, property is managed by external system and read-only in UI. */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>
  /** Global display order. */
  position?: InputMaybe<Scalars['Int']['input']>
}

/** Input for updating an existing resource template. */
export interface IUpdateResourceTemplateInput {
  /** Prefix used for auto-generating resource codes. */
  codePrefix?: InputMaybe<Scalars['String']['input']>
  /** Optional description of when to use this template. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Display name for this template. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Updated properties list (replaces existing). */
  properties?: InputMaybe<Array<ITemplatePropertyInput>>
}

export interface IUpdaterInfo {
  /** Email. */
  email?: Maybe<Scalars['String']['output']>
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>
}

export interface IUpdaterInfoInput {
  /** Email. */
  email?: InputMaybe<Scalars['String']['input']>
  /** First name. */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Id. */
  id: Scalars['ObjectId']['input']
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']['input']>
}

export interface IUploadLog {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** File category associated with this upload. */
  fileCategory?: Maybe<FileCategory>
  /** Type of the uploaded file. */
  fileType?: Maybe<Scalars['String']['output']>
  /** URL where the uploaded file is stored. */
  fileUrl?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** A value indicating whether the upload log is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>
  /** IDs of the locations associated with this upload. */
  locationIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Name of the location associated with this upload. */
  locationName?: Maybe<Scalars['String']['output']>
  /** Type of the location associated with this upload. */
  locationType?: Maybe<LocationType>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** ID of the project associated with the uploaded file. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** Name of the project associated with the uploaded file. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Code or identifier of the source entity. */
  sourceEntityCode?: Maybe<Scalars['String']['output']>
  /** ID of the source entity related to this upload. */
  sourceEntityId?: Maybe<Scalars['ObjectId']['output']>
  /** Type of the source entity (e.g., Delivery, Form). */
  sourceEntityType?: Maybe<SourceEntityType>
  /** Display name of the source entity type. */
  sourceEntityTypeName?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Company ID of the user who performed the upload. */
  userCompanyId?: Maybe<Scalars['ObjectId']['output']>
  /** Company name of the user who performed the upload. */
  userCompanyName?: Maybe<Scalars['String']['output']>
  /** ID of the user who performed the upload. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** Name of the user who performed the upload. */
  userName?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow category ID associated with this upload. */
  workflowCategory?: Maybe<Scalars['ObjectId']['output']>
  /** Workflow type ID associated with this upload. */
  workflowType?: Maybe<Scalars['ObjectId']['output']>
}

/** Upload log with related delivery and site permit entities */
export interface IUploadLogAggregated {
  /** The related delivery entity if the upload log is associated with a delivery. */
  delivery?: Maybe<IDelivery>
  /** The related site permit entity if the upload log is associated with a site permit. */
  sitePermit?: Maybe<ISitePermit>
  /** The upload log entry. */
  uploadLog: IUploadLog
}

export interface IUploadLogAggregatedList {
  data: Array<IUploadLogAggregated>
  page: IPageInfo
}

export interface IUploadLogAggregationFilterInput {
  /** Company IDs. */
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** End date for filtering uploads. */
  endDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** File categories to filter by. */
  fileCategories?: InputMaybe<Array<InputMaybe<FileCategory>>>
  /** File types to filter by. */
  fileTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Upload log IDs for specific filtering. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Include hidden logs in the query results. */
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** Include upload logs with unassigned companies (null or empty UserCompanyId). */
  includeUnassignedCompanies?: InputMaybe<Scalars['Boolean']['input']>
  /** Include upload logs with unassigned locations (null or empty LocationIds). */
  includeUnassignedLocations?: InputMaybe<Scalars['Boolean']['input']>
  /** Include upload logs with unassigned users (null or empty UserId). */
  includeUnassignedUsers?: InputMaybe<Scalars['Boolean']['input']>
  /** Include upload logs with unassigned workflow categories (null or empty WorkflowCategory). */
  includeUnassignedWorkflowCategories?: InputMaybe<Scalars['Boolean']['input']>
  /** Include upload logs with unassigned workflow types (null or empty WorkflowType). */
  includeUnassignedWorkflowTypes?: InputMaybe<Scalars['Boolean']['input']>
  /** Location IDs. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Location types. */
  locationTypes?: InputMaybe<Array<InputMaybe<LocationType>>>
  /** Project ID. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Search string for filtering by file URL, source entity code, etc. */
  searchString?: InputMaybe<Scalars['String']['input']>
  /** Source entity IDs. */
  sourceEntityIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Start date for filtering uploads. */
  startDate?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User IDs who performed uploads. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Workflow category IDs to filter by. */
  workflowCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Workflow type IDs to filter by. */
  workflowTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
}

export interface IUploadLogConfiguration {
  /** Upload log list columns configuration. */
  columnsConfig?: Maybe<Array<Maybe<IColumnConfiguration>>>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Saved groups. */
  savedGroups?: Maybe<Array<Maybe<IFilterGroup>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IUploadLogConfigurationChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUploadLogConfiguration>
}

export interface IUploadLogConfigurationInput {
  /** Upload log list columns configuration. */
  columnsConfig?: InputMaybe<Array<InputMaybe<IColumnConfigurationInput>>>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Saved groups. */
  savedGroups?: InputMaybe<Array<InputMaybe<IFilterGroupInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IUploadLogCustomFilter {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default for users. */
  defaultForUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Filters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<IUploadLogFilter>>>
  /** Group By. */
  groupBy?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IUploadLogCustomFilterChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUploadLogCustomFilter>
}

export interface IUploadLogCustomFilterInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default for users. */
  defaultForUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Filters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<IUploadLogFilterInput>>>
  /** Group By. */
  groupBy?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IUploadLogCustomFilterList {
  data: Array<IUploadLogCustomFilter>
  page: IPageInfo
}

export interface IUploadLogFacets {
  /** Company filters. */
  companyFilters?: Maybe<Array<Maybe<IFacet>>>
  /** File category filters. */
  fileCategoryFilters?: Maybe<Array<Maybe<IFacet>>>
  /** File type filters. */
  fileTypeFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Location filters. */
  locationFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Location type filters. */
  locationTypeFilters?: Maybe<Array<Maybe<IFacet>>>
  /** User filters. */
  userFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Workflow category filters. */
  workflowCategoryFilters?: Maybe<Array<Maybe<IFacet>>>
  /** Workflow type filters. */
  workflowTypeFilters?: Maybe<Array<Maybe<IFacet>>>
}

export interface IUploadLogFilter {
  /** Type. */
  type?: Maybe<UploadLogFilterType>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IUploadLogFilterInput {
  /** Type. */
  type?: InputMaybe<UploadLogFilterType>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum UploadLogFilterType {
  Company = 'company',
  DateUploaded = 'date_uploaded',
  FileExtension = 'file_extension',
  Filetype = 'filetype',
  Formtype = 'formtype',
  Location = 'location',
  Source = 'source',
  UploadedBy = 'uploaded_by',
  WorkflowCategory = 'workflowCategory',
}

export interface IUploadLogInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** File category associated with this upload. */
  fileCategory?: InputMaybe<FileCategory>
  /** Type of the uploaded file. */
  fileType?: InputMaybe<Scalars['String']['input']>
  /** URL where the uploaded file is stored. */
  fileUrl?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** A value indicating whether the upload log is hidden. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  /** IDs of the locations associated with this upload. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Name of the location associated with this upload. */
  locationName?: InputMaybe<Scalars['String']['input']>
  /** Type of the location associated with this upload. */
  locationType?: InputMaybe<LocationType>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** ID of the project associated with the uploaded file. */
  projectId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Name of the project associated with the uploaded file. */
  projectName?: InputMaybe<Scalars['String']['input']>
  /** Code or identifier of the source entity. */
  sourceEntityCode?: InputMaybe<Scalars['String']['input']>
  /** ID of the source entity related to this upload. */
  sourceEntityId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Type of the source entity (e.g., Delivery, Form). */
  sourceEntityType?: InputMaybe<SourceEntityType>
  /** Display name of the source entity type. */
  sourceEntityTypeName?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Company ID of the user who performed the upload. */
  userCompanyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Company name of the user who performed the upload. */
  userCompanyName?: InputMaybe<Scalars['String']['input']>
  /** ID of the user who performed the upload. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** Name of the user who performed the upload. */
  userName?: InputMaybe<Scalars['String']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Workflow category ID associated with this upload. */
  workflowCategory?: InputMaybe<Scalars['ObjectId']['input']>
  /** Workflow type ID associated with this upload. */
  workflowType?: InputMaybe<Scalars['ObjectId']['input']>
}

export interface IUploadMaterialsExcelInput {
  /** Name of the file. */
  fileName: Scalars['String']['input']
  /** Full path to the file. */
  fullFilePath: Scalars['String']['input']
  /** Project id. */
  projectId: Scalars['ObjectId']['input']
  /** Sheet data. */
  sheetData: ISheetDataInput
  /** Flag for copying existing materials to upload or not. */
  shouldMergeWithExistingData: Scalars['Boolean']['input']
  /** User id. */
  userId: Scalars['ObjectId']['input']
}

export interface IUploadMaterialsProgress {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fail reason. */
  failReason?: Maybe<Scalars['String']['output']>
  /** Failed step. */
  failedStep?: Maybe<UploadMaterialsStatus>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Items to process. */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /** Materials upload id. */
  materialsUploadId?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Processed items. */
  savedItemsCount?: Maybe<Scalars['Int']['output']>
  /** Current upload status. */
  status: UploadMaterialsStatus
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IUploadMaterialsProgressChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUploadMaterialsProgress>
}

export enum UploadMaterialsStatus {
  Done = 'DONE',
  ExtractingData = 'EXTRACTING_DATA',
  Failed = 'FAILED',
  Finishing = 'FINISHING',
  ReadingFile = 'READING_FILE',
  RemovingOldData = 'REMOVING_OLD_DATA',
  SavingMaterials = 'SAVING_MATERIALS',
  Starting = 'STARTING',
}

export interface IUploadScheduleProgress {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Fail reason. */
  failReason?: Maybe<Scalars['String']['output']>
  /** Failed step. */
  failedStep?: Maybe<UploadScheduleStatus>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Items to process. */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Previous schedule id. */
  previousScheduleId?: Maybe<Scalars['ObjectId']['output']>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Processed items. */
  savedItemsCount?: Maybe<Scalars['Int']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** Current upload status. */
  status: UploadScheduleStatus
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  uploadResult?: Maybe<IUploadScheduleResult>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IUploadScheduleProgressChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUploadScheduleProgress>
}

export interface IUploadScheduleResult {
  /** Comparing info. */
  compareData: IScheduleComparingResult
  /** Previous schedule. */
  previousSchedule?: Maybe<ISchedule>
  /** Uploaded schedule. */
  schedule: ISchedule
}

export enum UploadScheduleStatus {
  Done = 'DONE',
  ExtractingData = 'EXTRACTING_DATA',
  Failed = 'FAILED',
  ReadingFile = 'READING_FILE',
  RecalculateStatusUpdates = 'RECALCULATE_STATUS_UPDATES',
  SavingActivities = 'SAVING_ACTIVITIES',
  SavingSchedule = 'SAVING_SCHEDULE',
  Starting = 'STARTING',
}

export enum UploadingType {
  AttachmentFile = 'AttachmentFile',
  Avatar = 'Avatar',
  BidPackage = 'BidPackage',
  Image = 'Image',
  MsExcel = 'MSExcel',
  MsPowerPoint = 'MSPowerPoint',
  MsWord = 'MSWord',
  ManPower = 'ManPower',
  Material = 'Material',
  Pdf = 'PDF',
  Schedule = 'Schedule',
  Tileset = 'Tileset',
}

export interface IUser {
  accountPosition?: Maybe<UserAccountPosition>
  addedBy?: Maybe<Scalars['String']['output']>
  avatarUrl?: Maybe<Scalars['String']['output']>
  companyAlias?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  email?: Maybe<Scalars['String']['output']>
  /** Optional. Tenant's internal EmployeeId. */
  employeeId?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  /** Job title. */
  globalRole?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  initials?: Maybe<Scalars['String']['output']>
  /** Indication if user was created using sign up. */
  isSignUpCreated?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  phoneNumber?: Maybe<Scalars['String']['output']>
  reportsToId?: Maybe<Scalars['ObjectId']['output']>
  setUpFinished?: Maybe<Array<Maybe<IProjectSetupFinished>>>
  /** Central StruxHub account id, for universal QR codes. Only for the caller and tenant admins; null otherwise. */
  stxAccountId?: Maybe<Scalars['String']['output']>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export enum UserAccountPosition {
  Field = 'field',
  Management = 'management',
  Office = 'office',
}

export interface IUserActivityLog {
  /** Type of activity performed. */
  activityType?: Maybe<UserActivityType>
  /** ID of user who performed the activity. */
  actorUserId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Error message if activity failed. */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Phone number involved, for phone transfer/remove activities. */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** Project ID (null for tenant-wide operations). */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** Status of the activity. */
  status?: Maybe<UserActivityStatus>
  /** Count of targets affected. */
  targetCount: Scalars['Int']['output']
  /** IDs of target users. */
  targetUserIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export enum UserActivityStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  PartialSuccess = 'Partial_Success',
}

export enum UserActivityType {
  AddUser = 'Add_User',
  AddUserProject = 'Add_User_Project',
  DeleteUser = 'Delete_User',
  RemovePhone = 'Remove_Phone',
  RemoveUserProject = 'Remove_User_Project',
  SendInvites = 'Send_Invites',
  TransferPhone = 'Transfer_Phone',
}

export interface IUserChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUser>
}

export interface IUserDataInput {
  /** Company alias. */
  companyAlias?: InputMaybe<Scalars['String']['input']>
  /** Email. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

/** One row of the Users Directory report: a user's membership in a single project. */
export interface IUserDirectoryReportRecord {
  /** Access type. */
  accessType?: Maybe<Scalars['String']['output']>
  /** Account position (e.g., Office / Field / Management). */
  accountPosition?: Maybe<Scalars['String']['output']>
  /** Company name (project membership). */
  company?: Maybe<Scalars['String']['output']>
  /** Email. */
  email?: Maybe<Scalars['String']['output']>
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** Global Role (User.GlobalRole; legacy header, same as Job Title). */
  globalRole?: Maybe<Scalars['String']['output']>
  /** Invite status. */
  inviteStatus?: Maybe<Scalars['String']['output']>
  /** Job Title (User.GlobalRole; new header, same as Global Role). */
  jobTitle?: Maybe<Scalars['String']['output']>
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>
  /** Phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** Project id. */
  projectId?: Maybe<Scalars['ObjectId']['output']>
  /** Project name. */
  projectName?: Maybe<Scalars['String']['output']>
  /** Role names (effective job titles). */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Team names (teams + default teams). */
  teams?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Tenant (database) name. */
  tenant?: Maybe<Scalars['String']['output']>
  /** User id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
}

export interface IUserList {
  data: Array<IUser>
  page: IPageInfo
}

export interface IUserNofiticationInput {
  email: Scalars['Boolean']['input']
  inApp: Scalars['Boolean']['input']
  sms: Scalars['Boolean']['input']
}

export interface IUserNotification {
  email: Scalars['Boolean']['output']
  inApp: Scalars['Boolean']['output']
  sms: Scalars['Boolean']['output']
}

export interface IUserProject {
  /** Access type. */
  accessType?: Maybe<ProjectAccessType>
  /** Activities date picker mode. */
  activitiesDatePickerMode?: Maybe<Scalars['String']['output']>
  /** Activity notifications. */
  activityNotifications?: Maybe<IUserNotification>
  /** Associated Codes */
  associatedCodes?: Maybe<Array<Maybe<IAssociatedCode>>>
  /** Company id. */
  companyId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Dashboard preferences. */
  dashboardPreferences?: Maybe<IDashboardPreferences>
  /** Default teams */
  defaultTeams?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Deliveries settings. */
  deliveriesSettings?: Maybe<IDeliveryListSettings>
  /** Delivery notifications. */
  deliveryNotifications?: Maybe<IUserNotification>
  /** Globes setup settings. */
  globesSetupSettings?: Maybe<IGlobesSetupSettings>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Invite status. */
  inviteStatus?: Maybe<InviteStatus>
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Last mobile activity filters. */
  lastMobileActivityFilters?: Maybe<Array<Maybe<ILastMobileActivityFilter>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Responsibilities. */
  responsibilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Roles. */
  roles?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Saved view settings. */
  savedViewsSettings?: Maybe<Array<Maybe<ISavedViewSettings>>>
  /** Sensor notifications. */
  scannerNotifications?: Maybe<IUserNotification>
  /** Sitemaps setup settings. */
  sitemapsSetupSettings?: Maybe<ISitemapsSetupSettings>
  /** User tags (e.g. Project Coordinator). */
  tags?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Teams. */
  teams?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Trades. */
  trades?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow notifications. */
  workflowNotifications?: Maybe<IUserNotification>
}

export interface IUserProjectChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUserProject>
}

export interface IUserProjectInput {
  /** Access type. */
  accessType?: InputMaybe<ProjectAccessType>
  /** Activities date picker mode. */
  activitiesDatePickerMode?: InputMaybe<Scalars['String']['input']>
  /** Activity notifications. */
  activityNotifications?: InputMaybe<IUserNofiticationInput>
  /** Associated Codes */
  associatedCodes?: InputMaybe<Array<InputMaybe<IAssociatedCodeInput>>>
  /** Company id. */
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Dashboard preferences. */
  dashboardPreferences?: InputMaybe<IDashboardPreferencesInput>
  /** Default teams */
  defaultTeams?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Deliveries settings. */
  deliveriesSettings?: InputMaybe<IDeliveryListSettingsInput>
  /** Delivery notifications. */
  deliveryNotifications?: InputMaybe<IUserNofiticationInput>
  /** Globes setup settings. */
  globesSetupSettings?: InputMaybe<IGlobesSetupSettingsInput>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Invite status. */
  inviteStatus?: InputMaybe<InviteStatus>
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['input']
  /** Last mobile activity filters. */
  lastMobileActivityFilters?: InputMaybe<
    Array<InputMaybe<ILastMobileActivityFilterInput>>
  >
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Responsibilities. */
  responsibilities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Roles. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Saved veiw settings. */
  savedViewsSettings?: InputMaybe<Array<InputMaybe<ISavedViewSettingsInput>>>
  /** Sensor notifications. */
  scannerNotifications?: InputMaybe<IUserNofiticationInput>
  /** Sitemaps setup settings. */
  sitemapsSetupSettings?: InputMaybe<ISitemapsSetupSettingsInput>
  /** User tags (e.g. Project Coordinator). */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Teams. */
  teams?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Trades. */
  trades?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Workflow notifications. */
  workflowNotifications?: InputMaybe<IUserNofiticationInput>
}

export interface IUserProjectList {
  data: Array<IUserProject>
  page: IPageInfo
}

export interface IUserProjectTagsInput {
  /** The complete tag set for this member. An empty list clears their tags. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** The member whose tags are being replaced. */
  userId: Scalars['ObjectId']['input']
}

export interface IUserRole {
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IUserRoleChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IUserRole>
}

export interface IUserRoleInput {
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IUserRoleList {
  data: Array<IUserRole>
  page: IPageInfo
}

export interface IUserTag {
  /** Tag color. */
  color?: Maybe<Scalars['String']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this is a system-defined tag. */
  isSystem?: Maybe<Scalars['Boolean']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Tag value. */
  value?: Maybe<Scalars['String']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IVerticalObject extends ILocationBase {
  /** Accessible levels. */
  accessibleLevels?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Levels closures. */
  levelsClosures?: Maybe<Array<Maybe<ILevelsClosure>>>
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IVerticalObjectInput {
  /** Accessible levels. */
  accessibleLevels?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Levels closures. */
  levelsClosures?: InputMaybe<Array<InputMaybe<ILevelsClosureInput>>>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IViewTypes {
  /** Mobile configuration. */
  mobile?: Maybe<HierarchyModes>
  /** Tablet configuration. */
  tablet?: Maybe<HierarchyModes>
  /** Desktop gantt configuration. */
  webGantt?: Maybe<HierarchyModes>
  /** Desktop sitemap configuration. */
  webSitemap?: Maybe<HierarchyModes>
}

export interface IViewTypesInput {
  /** Mobile configuration. */
  mobile?: InputMaybe<HierarchyModes>
  /** Tablet configuration. */
  tablet?: InputMaybe<HierarchyModes>
  /** Desktop gantt configuration. */
  webGantt?: InputMaybe<HierarchyModes>
  /** Desktop sitemap configuration. */
  webSitemap?: InputMaybe<HierarchyModes>
}

export interface IWeatherForecast {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Forecast date. */
  forecastDate: Scalars['MillisecondsDate']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Open weather forecast object. */
  openWeatherForecast: IOpenWeatherForecast
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IWeatherForecastChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IWeatherForecast>
}

export interface IWeatherForecastRangeInput {
  /** End date. */
  endDate: Scalars['MillisecondsDate']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Start date. */
  startDate: Scalars['MillisecondsDate']['input']
  /** Timezone Id. */
  timezoneId: Scalars['String']['input']
}

export interface IWhiteListItem {
  /** Company Id. */
  companyId?: Maybe<Scalars['ObjectId']['output']>
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Domain name. */
  domainName?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IWhiteListItemChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IWhiteListItem>
}

export interface IWhiteListItemInput {
  /** Company Id. */
  companyId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Domain name. */
  domainName?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IWhiteListItemList {
  data: Array<IWhiteListItem>
  page: IPageInfo
}

export interface IWorkBreakdownStructure {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Schedule entity name. */
  name: Scalars['String']['output']
  /** Parent wbs id. */
  parentId?: Maybe<Scalars['ObjectId']['output']>
  /** Schedule id. */
  scheduleId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Entity id specified in the schedule file. */
  xerEntityId?: Maybe<Scalars['String']['output']>
}

export interface IWorkBreakdownStructureList {
  data: Array<IWorkBreakdownStructure>
  page: IPageInfo
}

export interface IWorkflowConfigurations {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Workflow gantt view columns configuration. */
  ganttColumnsConfig?: Maybe<Array<Maybe<IColumnConfiguration>>>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Workflow list view columns configuration. */
  listColumnsConfig?: Maybe<Array<Maybe<IColumnConfiguration>>>
  /** Order of maps. */
  maps?: Maybe<Array<Maybe<IOrderedSitemap>>>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Saved groups. */
  savedGroups?: Maybe<Array<Maybe<IFilterGroup>>>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IWorkflowConfigurationsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IWorkflowConfigurations>
}

export interface IWorkflowConfigurationsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Workflow gantt view columns configuration. */
  ganttColumnsConfig?: InputMaybe<Array<InputMaybe<IColumnConfigurationInput>>>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Workflow list view columns configuration. */
  listColumnsConfig?: InputMaybe<Array<InputMaybe<IColumnConfigurationInput>>>
  /** Order of maps. */
  maps?: InputMaybe<Array<InputMaybe<IOrderedSitemapInput>>>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Saved groups. */
  savedGroups?: InputMaybe<Array<InputMaybe<IFilterGroupInput>>>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IWorkflowConfigurationsList {
  data: Array<IWorkflowConfigurations>
  page: IPageInfo
}

export interface IWorkflowDurationOptions {
  /** Duration. */
  duration?: Maybe<Scalars['Int']['output']>
  /** Duration type. */
  durationType?: Maybe<WorkflowDurationType>
  /** Duration unit. */
  durationUnit?: Maybe<WorkflowDurationUnit>
  /** Is enabled. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>
}

export interface IWorkflowDurationOptionsInput {
  /** Duration. */
  duration?: InputMaybe<Scalars['Int']['input']>
  /** Duration type. */
  durationType?: InputMaybe<WorkflowDurationType>
  /** Duration unit. */
  durationUnit?: InputMaybe<WorkflowDurationUnit>
  /** Is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export enum WorkflowDurationType {
  AllDay = 'AllDay',
  Time = 'Time',
  WorkWeek = 'WorkWeek',
}

export enum WorkflowDurationUnit {
  Days = 'Days',
  Hours = 'Hours',
  Minutes = 'Minutes',
  Months = 'Months',
  Weeks = 'Weeks',
}

export interface IWorkflowLocationRestriction {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Location id this restriction applies to. */
  locationId: Scalars['ObjectId']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Type of restriction. */
  restrictionType: RestrictionType
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Restriction values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow ids impacted by this restriction. */
  workflowIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IWorkflowLocationRestrictionChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IWorkflowLocationRestriction>
}

export interface IWorkflowLocationRestrictionInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Location id this restriction applies to. */
  locationId: Scalars['ObjectId']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Type of restriction. */
  restrictionType: RestrictionType
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Restriction values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
  /** Workflow ids impacted by this restriction. */
  workflowIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
}

export interface IWorkflowLocationRestrictionList {
  data: Array<IWorkflowLocationRestriction>
  page: IPageInfo
}

export interface IWorkflowStep {
  /** Actions. */
  actions?: Maybe<Array<Maybe<IPermitActionInterface>>>
  /** Who must sign before this step completes. Null on steps saved before it existed; read requireAllSubmissions then. */
  bicCompletionMode?: Maybe<BicCompletionMode>
  /** Conditional fields. */
  conditionalFields: Array<Maybe<IConditionalField>>
  /** Fields. */
  fields: Array<Maybe<IPermitTypeField>>
  /** Id. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Notification field Ids. */
  notificationFieldIds: Array<Maybe<Scalars['ObjectId']['output']>>
  /** Notification user Ids. */
  notificationUserIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** When true, all BIC users must complete this step. */
  requireAllSubmissions?: Maybe<Scalars['Boolean']['output']>
  /** Workflow step type. */
  type: WorkflowStepType
  /** Workflow rule Ids. */
  workflowRuleIds: Array<Maybe<Scalars['ObjectId']['output']>>
}

export interface IWorkflowStepInput {
  /** Who must sign before this step completes. Null on steps saved before it existed; read requireAllSubmissions then. */
  bicCompletionMode?: InputMaybe<BicCompletionMode>
  /** Conditional fields. */
  conditionalFields: Array<InputMaybe<IConditionalFieldInput>>
  /** Fields. */
  fields: Array<InputMaybe<IPermitTypeFieldsInput>>
  /** Id. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Notification field Ids. */
  notificationFieldIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
  /** Notification user Ids. */
  notificationUserIds?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** When true, all BIC users must complete this step. */
  requireAllSubmissions?: InputMaybe<Scalars['Boolean']['input']>
  /** Workflow step type. */
  type: WorkflowStepType
  /** Workflow rule Ids. */
  workflowRuleIds: Array<InputMaybe<Scalars['ObjectId']['input']>>
}

export enum WorkflowStepType {
  Approval = 'Approval',
  Finish = 'Finish',
  Inspection = 'Inspection',
  OnSite = 'OnSite',
  ReadyToInspect = 'ReadyToInspect',
  RecurringInspection = 'RecurringInspection',
  Request = 'Request',
  Review = 'Review',
  Start = 'Start',
  Submission = 'Submission',
}

export interface IWorkflowsCustomFilter {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Default for users. */
  defaultForUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Filters by filter type. */
  filtersByFilterType?: Maybe<Array<Maybe<IWorkflowsFilter>>>
  /** Group By. */
  groupBy?: Maybe<Scalars['String']['output']>
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is public. */
  isPublic: Scalars['Boolean']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** User Id. */
  userId?: Maybe<Scalars['ObjectId']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IWorkflowsCustomFilterInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Default for users. */
  defaultForUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>
  /** Filters by filter type. */
  filtersByFilterType?: InputMaybe<Array<InputMaybe<IWorkflowsFilterInput>>>
  /** Group By. */
  groupBy?: InputMaybe<Scalars['String']['input']>
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is public. */
  isPublic: Scalars['Boolean']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** User Id. */
  userId?: InputMaybe<Scalars['ObjectId']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IWorkflowsCustomFilterList {
  data: Array<IWorkflowsCustomFilter>
  page: IPageInfo
}

export interface IWorkflowsFilter {
  /** Type. */
  type?: Maybe<WorkflowsFilterType>
  /** Values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export interface IWorkflowsFilterInput {
  /** Type. */
  type?: InputMaybe<WorkflowsFilterType>
  /** Values. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum WorkflowsFilterType {
  Attachment = 'attachment',
  Category = 'category',
  Company = 'company',
  Equipment = 'equipment',
  Location = 'location',
  Project = 'project',
  ResponsibleContact = 'responsibleContact',
  Status = 'status',
  Type = 'type',
}

export interface IWorkingHours {
  /** End time. */
  endTime: Scalars['Long']['output']
  /** Start time. */
  startTime: Scalars['Long']['output']
}

export interface IWorkingHoursInput {
  /** End time. */
  endTime: Scalars['Long']['input']
  /** Start time. */
  startTime: Scalars['Long']['input']
}

export interface IWorkingScheduleDay {
  /** Day of week, 1 = Sunday .. 7 = Saturday. */
  dayOfWeek: Scalars['Int']['output']
  /** End time, in time milliseconds. */
  endTime?: Maybe<Scalars['Long']['output']>
  /** Start time, in time milliseconds. */
  startTime?: Maybe<Scalars['Long']['output']>
}

export interface IWorkingScheduleDayInput {
  /** Day of week, 1 = Sunday .. 7 = Saturday. */
  dayOfWeek: Scalars['Int']['input']
  /** End time, in time milliseconds. */
  endTime?: InputMaybe<Scalars['Long']['input']>
  /** Start time, in time milliseconds. */
  startTime?: InputMaybe<Scalars['Long']['input']>
}

export interface IXerProjectInfo {
  /** Activities count. */
  activitiesCount: Scalars['Int']['output']
  /** Id. */
  id: Scalars['String']['output']
  /** Name. */
  name: Scalars['String']['output']
}

export interface IZone extends ILocationBase {
  /** Assigned globes. */
  assignedGlobes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Code. */
  code?: Maybe<Scalars['String']['output']>
  /** Color. */
  color: Scalars['String']['output']
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Custom property values as JSON object. */
  data?: Maybe<Scalars['JSONObject']['output']>
  /** Icon name. */
  iconName: Scalars['String']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Whether this location can be booked. */
  isBookable: Scalars['Boolean']['output']
  /** Is deleted. */
  isDeleted: Scalars['Boolean']['output']
  /** Maximum booking duration for deliveries. */
  maxBookingDuration?: Maybe<Scalars['Float']['output']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: Maybe<Scalars['Int']['output']>
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** The name of the record. */
  name: Scalars['String']['output']
  /** Operating intervals. */
  operatingIntervals?: Maybe<Array<Maybe<IDateInterval>>>
  /** Delivery hierarchy parent. */
  parent?: Maybe<IDeliveryHierarchyParent>
  /** Permitted companies. */
  permittedCompanies?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** Whether this location is shown on the map. */
  showInMap: Scalars['Boolean']['output']
  /** StruxHub-generated sequential resource identifier (e.g., EQP-001). */
  stxResourceId?: Maybe<Scalars['String']['output']>
  /** Resource template ID. */
  templateId?: Maybe<Scalars['String']['output']>
  /** Type. */
  type?: Maybe<LocationType>
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
  /** Workflow restrictions for this location. */
  workflowRestrictions?: Maybe<ILocationWorkflowRestrictions>
  /** Workflow type ids. */
  workflowTypes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>
}

export interface IZoneInput {
  /** Assigned globes. */
  assignedGlobes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Assigned sitemaps. */
  assignedSitemaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Code. */
  code?: InputMaybe<Scalars['String']['input']>
  /** Color. */
  color: Scalars['String']['input']
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Custom property values as JSON object. */
  data?: InputMaybe<Scalars['JSONObject']['input']>
  /** Icon name. */
  iconName: Scalars['String']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Maximum booking duration. */
  maxBookingDuration?: InputMaybe<Scalars['Float']['input']>
  /** Maximum overlapping deliveries. */
  maxOverlappingDeliveries?: InputMaybe<Scalars['Int']['input']>
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** The name of the record. */
  name: Scalars['String']['input']
  /** Operating intervals. */
  operatingIntervals?: InputMaybe<Array<InputMaybe<IDateIntervalInput>>>
  /** Location parent. */
  parent?: InputMaybe<IDeliveryHierarchyParentInput>
  /** Permitted companies. */
  permittedCompanies?: InputMaybe<
    Array<InputMaybe<Scalars['ObjectId']['input']>>
  >
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** Resource template ID. */
  templateId?: InputMaybe<Scalars['String']['input']>
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IZoneMapThresholds {
  /** The time the record was created. */
  createdAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** Delta days behind value. */
  deltaDaysBehindValue: Scalars['Int']['output']
  /** Delta days unit. */
  deltaDaysUnit: ThresholdUnit
  /** Delta days value. */
  deltaDaysValue: Scalars['Int']['output']
  /** The id of the record. */
  id?: Maybe<Scalars['ObjectId']['output']>
  /** Is manpower disabled. */
  isManpowerDisabled: Scalars['Boolean']['output']
  /** Manpower unit. */
  manpowerUnit: ThresholdUnit
  /** Manpower value. */
  manpowerValue: Scalars['Int']['output']
  /** Metadata. */
  metadata?: Maybe<Array<Maybe<IStringPair>>>
  /** Project id. */
  projectId: Scalars['ObjectId']['output']
  /** The last time the record was changed. */
  updatedAt?: Maybe<Scalars['MillisecondsDate']['output']>
  /** The version of the record. */
  version?: Maybe<Scalars['Int']['output']>
}

export interface IZoneMapThresholdsChangeEvent {
  id?: Maybe<Scalars['ObjectId']['output']>
  item?: Maybe<IZoneMapThresholds>
}

export interface IZoneMapThresholdsInput {
  /** The time the record was created. */
  createdAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** Delta days behind value. */
  deltaDaysBehindValue: Scalars['Int']['input']
  /** Delta days unit. */
  deltaDaysUnit: ThresholdUnit
  /** Delta days value. */
  deltaDaysValue: Scalars['Int']['input']
  /** The id of the record. */
  id?: InputMaybe<Scalars['ObjectId']['input']>
  /** Is manpower disabled. */
  isManpowerDisabled: Scalars['Boolean']['input']
  /** Manpower unit. */
  manpowerUnit: ThresholdUnit
  /** Manpower value. */
  manpowerValue: Scalars['Int']['input']
  /** Metadata. */
  metadata?: InputMaybe<Array<InputMaybe<IStringPairInput>>>
  /** Project Id. */
  projectId: Scalars['ObjectId']['input']
  /** The last time the record was changed. Ignored on save. */
  updatedAt?: InputMaybe<Scalars['MillisecondsDate']['input']>
  /** The version of the record. */
  version?: InputMaybe<Scalars['Int']['input']>
}

export interface IZoneMapThresholdsList {
  data: Array<IZoneMapThresholds>
  page: IPageInfo
}

export interface IAction {
  /** End closure action. */
  endClosureAction?: InputMaybe<IEndClosureActionInput>
  /** Start closure action. */
  startClosureAction?: InputMaybe<IStartClosureActionInput>
}
